// source: analyzer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var common_common_pb = require('./common/common_pb.js');
goog.object.extend(proto, common_common_pb);
goog.exportSymbol('proto.analyzer.AIInsight', null, global);
goog.exportSymbol('proto.analyzer.AccountAlertSettings', null, global);
goog.exportSymbol('proto.analyzer.AccountEquityChart', null, global);
goog.exportSymbol('proto.analyzer.AccountLite', null, global);
goog.exportSymbol('proto.analyzer.AccountMetrics', null, global);
goog.exportSymbol('proto.analyzer.AccountPerformance', null, global);
goog.exportSymbol('proto.analyzer.AccountSummary', null, global);
goog.exportSymbol('proto.analyzer.Alert', null, global);
goog.exportSymbol('proto.analyzer.AlertCategory', null, global);
goog.exportSymbol('proto.analyzer.AlertSeverity', null, global);
goog.exportSymbol('proto.analyzer.CreateUserTagReply', null, global);
goog.exportSymbol('proto.analyzer.CreateUserTagReq', null, global);
goog.exportSymbol('proto.analyzer.DailyDrawdownCard', null, global);
goog.exportSymbol('proto.analyzer.DailyLossProgress', null, global);
goog.exportSymbol('proto.analyzer.DailyROIChart', null, global);
goog.exportSymbol('proto.analyzer.DailyROIDataPoint', null, global);
goog.exportSymbol('proto.analyzer.DashboardOverviewReply', null, global);
goog.exportSymbol('proto.analyzer.DashboardOverviewReq', null, global);
goog.exportSymbol('proto.analyzer.DayOfWeekROIChart', null, global);
goog.exportSymbol('proto.analyzer.DayOfWeekROIPoint', null, global);
goog.exportSymbol('proto.analyzer.DeleteUserTagReply', null, global);
goog.exportSymbol('proto.analyzer.DeleteUserTagReq', null, global);
goog.exportSymbol('proto.analyzer.DrawdownPoint', null, global);
goog.exportSymbol('proto.analyzer.DrawdownSeriesChart', null, global);
goog.exportSymbol('proto.analyzer.EntryExitType', null, global);
goog.exportSymbol('proto.analyzer.EntryExitTypesChart', null, global);
goog.exportSymbol('proto.analyzer.EquityCurveChart', null, global);
goog.exportSymbol('proto.analyzer.EquityCurveDataPoint', null, global);
goog.exportSymbol('proto.analyzer.EquityDataPoint', null, global);
goog.exportSymbol('proto.analyzer.EquityPoint', null, global);
goog.exportSymbol('proto.analyzer.ExpectancyMetrics', null, global);
goog.exportSymbol('proto.analyzer.FeeBreakDown', null, global);
goog.exportSymbol('proto.analyzer.FinancialOverview', null, global);
goog.exportSymbol('proto.analyzer.GetAccountPerformanceRequest', null, global);
goog.exportSymbol('proto.analyzer.GetAccountPerformanceResponse', null, global);
goog.exportSymbol('proto.analyzer.GetAccountSettingsReply', null, global);
goog.exportSymbol('proto.analyzer.GetAccountSettingsReq', null, global);
goog.exportSymbol('proto.analyzer.GetAccountTradeListRequest', null, global);
goog.exportSymbol('proto.analyzer.GetAccountTradeListResponse', null, global);
goog.exportSymbol('proto.analyzer.GetInstrumentPatternsRequest', null, global);
goog.exportSymbol('proto.analyzer.GetPerformanceChartRequest', null, global);
goog.exportSymbol('proto.analyzer.GetPerformanceOverviewReq', null, global);
goog.exportSymbol('proto.analyzer.GetPortfolioDailyAndCumulativeROIReq', null, global);
goog.exportSymbol('proto.analyzer.GetPortfolioEquityCurveReq', null, global);
goog.exportSymbol('proto.analyzer.GetPortfolioOverviewReply', null, global);
goog.exportSymbol('proto.analyzer.GetPortfolioOverviewReq', null, global);
goog.exportSymbol('proto.analyzer.GetUserTagsReply', null, global);
goog.exportSymbol('proto.analyzer.GetUserTagsReq', null, global);
goog.exportSymbol('proto.analyzer.GetWeeklyHeatmapRequest', null, global);
goog.exportSymbol('proto.analyzer.HoldingTimeBucket', null, global);
goog.exportSymbol('proto.analyzer.HoldingTimeVsReturnChart', null, global);
goog.exportSymbol('proto.analyzer.InstrumentPattern', null, global);
goog.exportSymbol('proto.analyzer.InstrumentROIRow', null, global);
goog.exportSymbol('proto.analyzer.InstrumentROITable', null, global);
goog.exportSymbol('proto.analyzer.IntAddAccountReply', null, global);
goog.exportSymbol('proto.analyzer.IntAddAccountReq', null, global);
goog.exportSymbol('proto.analyzer.KeyMetrics', null, global);
goog.exportSymbol('proto.analyzer.ListAccountsLiteReply', null, global);
goog.exportSymbol('proto.analyzer.ListAccountsLiteReq', null, global);
goog.exportSymbol('proto.analyzer.ListAccountsReply', null, global);
goog.exportSymbol('proto.analyzer.ListAccountsReq', null, global);
goog.exportSymbol('proto.analyzer.LosingStreaksRecoveryCard', null, global);
goog.exportSymbol('proto.analyzer.LotSizeCompliance', null, global);
goog.exportSymbol('proto.analyzer.MetricValue', null, global);
goog.exportSymbol('proto.analyzer.NewsProximityBucket', null, global);
goog.exportSymbol('proto.analyzer.NewsProximityEffectChart', null, global);
goog.exportSymbol('proto.analyzer.OpenTradesSummary', null, global);
goog.exportSymbol('proto.analyzer.PerformanceChart', null, global);
goog.exportSymbol('proto.analyzer.PerformanceDataPoint', null, global);
goog.exportSymbol('proto.analyzer.PerformanceMetrics', null, global);
goog.exportSymbol('proto.analyzer.PerformanceOverview', null, global);
goog.exportSymbol('proto.analyzer.PerformanceOverviewReply', null, global);
goog.exportSymbol('proto.analyzer.PerformingAccountCard', null, global);
goog.exportSymbol('proto.analyzer.PeriodSummary', null, global);
goog.exportSymbol('proto.analyzer.PortfolioAverageRoiSummary', null, global);
goog.exportSymbol('proto.analyzer.PortfolioEquityCurve', null, global);
goog.exportSymbol('proto.analyzer.PortfolioSummary', null, global);
goog.exportSymbol('proto.analyzer.ProfitTargetProgress', null, global);
goog.exportSymbol('proto.analyzer.PropRuleUsageCard', null, global);
goog.exportSymbol('proto.analyzer.ROIMeter', null, global);
goog.exportSymbol('proto.analyzer.ROIMetrics', null, global);
goog.exportSymbol('proto.analyzer.ROISessionDataPoint', null, global);
goog.exportSymbol('proto.analyzer.ROISessionTrendsChart', null, global);
goog.exportSymbol('proto.analyzer.ROITrendDataPoint', null, global);
goog.exportSymbol('proto.analyzer.ROITrendsChart', null, global);
goog.exportSymbol('proto.analyzer.ReturnBucket', null, global);
goog.exportSymbol('proto.analyzer.ReturnDistributionChart', null, global);
goog.exportSymbol('proto.analyzer.RiskBucket', null, global);
goog.exportSymbol('proto.analyzer.RiskMetric', null, global);
goog.exportSymbol('proto.analyzer.RiskMonitor', null, global);
goog.exportSymbol('proto.analyzer.RiskPerTradeVsOutcomeChart', null, global);
goog.exportSymbol('proto.analyzer.RollingDrawdownChart', null, global);
goog.exportSymbol('proto.analyzer.RollingMetricPoint', null, global);
goog.exportSymbol('proto.analyzer.RollingProfitFactorChart', null, global);
goog.exportSymbol('proto.analyzer.RollingWinRateChart', null, global);
goog.exportSymbol('proto.analyzer.ScaledInTradesCard', null, global);
goog.exportSymbol('proto.analyzer.ScalingMetrics', null, global);
goog.exportSymbol('proto.analyzer.SessionAnalysisChart', null, global);
goog.exportSymbol('proto.analyzer.SessionROIBar', null, global);
goog.exportSymbol('proto.analyzer.SetTradeTagReply', null, global);
goog.exportSymbol('proto.analyzer.SetTradeTagReq', null, global);
goog.exportSymbol('proto.analyzer.TagPerformanceRow', null, global);
goog.exportSymbol('proto.analyzer.TagPerformanceTable', null, global);
goog.exportSymbol('proto.analyzer.TimeInTradeBand', null, global);
goog.exportSymbol('proto.analyzer.TimeInTradeBandsChart', null, global);
goog.exportSymbol('proto.analyzer.TimeOfDayCell', null, global);
goog.exportSymbol('proto.analyzer.TimeOfDayROIHeatmap', null, global);
goog.exportSymbol('proto.analyzer.TimeOfDayRow', null, global);
goog.exportSymbol('proto.analyzer.TradeCounts', null, global);
goog.exportSymbol('proto.analyzer.TradeList', null, global);
goog.exportSymbol('proto.analyzer.TradeRow', null, global);
goog.exportSymbol('proto.analyzer.TradeSummary', null, global);
goog.exportSymbol('proto.analyzer.TrendChartData', null, global);
goog.exportSymbol('proto.analyzer.TrendDataPoint', null, global);
goog.exportSymbol('proto.analyzer.UpdateAccountSettingsReply', null, global);
goog.exportSymbol('proto.analyzer.UpdateAccountSettingsReq', null, global);
goog.exportSymbol('proto.analyzer.UpdateUserTagReply', null, global);
goog.exportSymbol('proto.analyzer.UpdateUserTagReq', null, global);
goog.exportSymbol('proto.analyzer.UserTag', null, global);
goog.exportSymbol('proto.analyzer.WinRateCard', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.IntAddAccountReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.IntAddAccountReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.IntAddAccountReq.displayName = 'proto.analyzer.IntAddAccountReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.IntAddAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.IntAddAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.IntAddAccountReply.displayName = 'proto.analyzer.IntAddAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.DashboardOverviewReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.DashboardOverviewReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.DashboardOverviewReq.displayName = 'proto.analyzer.DashboardOverviewReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.DashboardOverviewReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.DashboardOverviewReply.repeatedFields_, null);
};
goog.inherits(proto.analyzer.DashboardOverviewReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.DashboardOverviewReply.displayName = 'proto.analyzer.DashboardOverviewReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.PortfolioAverageRoiSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.PortfolioAverageRoiSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.PortfolioAverageRoiSummary.displayName = 'proto.analyzer.PortfolioAverageRoiSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.PerformingAccountCard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.PerformingAccountCard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.PerformingAccountCard.displayName = 'proto.analyzer.PerformingAccountCard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.WinRateCard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.WinRateCard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.WinRateCard.displayName = 'proto.analyzer.WinRateCard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.DailyDrawdownCard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.DailyDrawdownCard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.DailyDrawdownCard.displayName = 'proto.analyzer.DailyDrawdownCard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.RiskMonitor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.RiskMonitor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.RiskMonitor.displayName = 'proto.analyzer.RiskMonitor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.DailyLossProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.DailyLossProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.DailyLossProgress.displayName = 'proto.analyzer.DailyLossProgress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.LotSizeCompliance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.LotSizeCompliance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.LotSizeCompliance.displayName = 'proto.analyzer.LotSizeCompliance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ProfitTargetProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.ProfitTargetProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ProfitTargetProgress.displayName = 'proto.analyzer.ProfitTargetProgress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetPerformanceOverviewReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.GetPerformanceOverviewReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetPerformanceOverviewReq.displayName = 'proto.analyzer.GetPerformanceOverviewReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.PerformanceOverviewReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.PerformanceOverviewReply.repeatedFields_, null);
};
goog.inherits(proto.analyzer.PerformanceOverviewReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.PerformanceOverviewReply.displayName = 'proto.analyzer.PerformanceOverviewReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.PerformanceOverview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.PerformanceOverview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.PerformanceOverview.displayName = 'proto.analyzer.PerformanceOverview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ROIMeter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.ROIMeter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ROIMeter.displayName = 'proto.analyzer.ROIMeter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.FinancialOverview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.FinancialOverview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.FinancialOverview.displayName = 'proto.analyzer.FinancialOverview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.FeeBreakDown = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.FeeBreakDown, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.FeeBreakDown.displayName = 'proto.analyzer.FeeBreakDown';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.OpenTradesSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.OpenTradesSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.OpenTradesSummary.displayName = 'proto.analyzer.OpenTradesSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.KeyMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.KeyMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.KeyMetrics.displayName = 'proto.analyzer.KeyMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.MetricValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.MetricValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.MetricValue.displayName = 'proto.analyzer.MetricValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.TradeCounts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.TradeCounts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.TradeCounts.displayName = 'proto.analyzer.TradeCounts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetInstrumentPatternsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.GetInstrumentPatternsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetInstrumentPatternsRequest.displayName = 'proto.analyzer.GetInstrumentPatternsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.InstrumentPattern = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.InstrumentPattern, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.InstrumentPattern.displayName = 'proto.analyzer.InstrumentPattern';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetPerformanceChartRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.GetPerformanceChartRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetPerformanceChartRequest.displayName = 'proto.analyzer.GetPerformanceChartRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.PerformanceChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.PerformanceChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.PerformanceChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.PerformanceChart.displayName = 'proto.analyzer.PerformanceChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.PerformanceDataPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.PerformanceDataPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.PerformanceDataPoint.displayName = 'proto.analyzer.PerformanceDataPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.PeriodSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.PeriodSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.PeriodSummary.displayName = 'proto.analyzer.PeriodSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetWeeklyHeatmapRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.GetWeeklyHeatmapRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetWeeklyHeatmapRequest.displayName = 'proto.analyzer.GetWeeklyHeatmapRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetAccountPerformanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.GetAccountPerformanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetAccountPerformanceRequest.displayName = 'proto.analyzer.GetAccountPerformanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetAccountPerformanceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.GetAccountPerformanceResponse.repeatedFields_, null);
};
goog.inherits(proto.analyzer.GetAccountPerformanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetAccountPerformanceResponse.displayName = 'proto.analyzer.GetAccountPerformanceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.PerformanceMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.PerformanceMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.PerformanceMetrics.displayName = 'proto.analyzer.PerformanceMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ExpectancyMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.ExpectancyMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ExpectancyMetrics.displayName = 'proto.analyzer.ExpectancyMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.EquityCurveChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.EquityCurveChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.EquityCurveChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.EquityCurveChart.displayName = 'proto.analyzer.EquityCurveChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.EquityPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.EquityPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.EquityPoint.displayName = 'proto.analyzer.EquityPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ReturnDistributionChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.ReturnDistributionChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.ReturnDistributionChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ReturnDistributionChart.displayName = 'proto.analyzer.ReturnDistributionChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ReturnBucket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.ReturnBucket.repeatedFields_, null);
};
goog.inherits(proto.analyzer.ReturnBucket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ReturnBucket.displayName = 'proto.analyzer.ReturnBucket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.DrawdownSeriesChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.DrawdownSeriesChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.DrawdownSeriesChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.DrawdownSeriesChart.displayName = 'proto.analyzer.DrawdownSeriesChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.DrawdownPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.DrawdownPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.DrawdownPoint.displayName = 'proto.analyzer.DrawdownPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.InstrumentROITable = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.InstrumentROITable.repeatedFields_, null);
};
goog.inherits(proto.analyzer.InstrumentROITable, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.InstrumentROITable.displayName = 'proto.analyzer.InstrumentROITable';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.InstrumentROIRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.InstrumentROIRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.InstrumentROIRow.displayName = 'proto.analyzer.InstrumentROIRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.DayOfWeekROIChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.DayOfWeekROIChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.DayOfWeekROIChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.DayOfWeekROIChart.displayName = 'proto.analyzer.DayOfWeekROIChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.DayOfWeekROIPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.DayOfWeekROIPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.DayOfWeekROIPoint.displayName = 'proto.analyzer.DayOfWeekROIPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.SessionAnalysisChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.SessionAnalysisChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.SessionAnalysisChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.SessionAnalysisChart.displayName = 'proto.analyzer.SessionAnalysisChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.SessionROIBar = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.SessionROIBar, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.SessionROIBar.displayName = 'proto.analyzer.SessionROIBar';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.HoldingTimeVsReturnChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.HoldingTimeVsReturnChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.HoldingTimeVsReturnChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.HoldingTimeVsReturnChart.displayName = 'proto.analyzer.HoldingTimeVsReturnChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.HoldingTimeBucket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.HoldingTimeBucket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.HoldingTimeBucket.displayName = 'proto.analyzer.HoldingTimeBucket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.TimeOfDayROIHeatmap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.TimeOfDayROIHeatmap.repeatedFields_, null);
};
goog.inherits(proto.analyzer.TimeOfDayROIHeatmap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.TimeOfDayROIHeatmap.displayName = 'proto.analyzer.TimeOfDayROIHeatmap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.TimeOfDayRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.TimeOfDayRow.repeatedFields_, null);
};
goog.inherits(proto.analyzer.TimeOfDayRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.TimeOfDayRow.displayName = 'proto.analyzer.TimeOfDayRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.TimeOfDayCell = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.TimeOfDayCell, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.TimeOfDayCell.displayName = 'proto.analyzer.TimeOfDayCell';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.RollingWinRateChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.RollingWinRateChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.RollingWinRateChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.RollingWinRateChart.displayName = 'proto.analyzer.RollingWinRateChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.RollingProfitFactorChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.RollingProfitFactorChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.RollingProfitFactorChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.RollingProfitFactorChart.displayName = 'proto.analyzer.RollingProfitFactorChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.RollingDrawdownChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.RollingDrawdownChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.RollingDrawdownChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.RollingDrawdownChart.displayName = 'proto.analyzer.RollingDrawdownChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.RollingMetricPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.RollingMetricPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.RollingMetricPoint.displayName = 'proto.analyzer.RollingMetricPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.RiskPerTradeVsOutcomeChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.RiskPerTradeVsOutcomeChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.RiskPerTradeVsOutcomeChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.RiskPerTradeVsOutcomeChart.displayName = 'proto.analyzer.RiskPerTradeVsOutcomeChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.RiskBucket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.RiskBucket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.RiskBucket.displayName = 'proto.analyzer.RiskBucket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.LosingStreaksRecoveryCard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.LosingStreaksRecoveryCard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.LosingStreaksRecoveryCard.displayName = 'proto.analyzer.LosingStreaksRecoveryCard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.PropRuleUsageCard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.PropRuleUsageCard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.PropRuleUsageCard.displayName = 'proto.analyzer.PropRuleUsageCard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.TagPerformanceTable = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.TagPerformanceTable.repeatedFields_, null);
};
goog.inherits(proto.analyzer.TagPerformanceTable, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.TagPerformanceTable.displayName = 'proto.analyzer.TagPerformanceTable';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.TagPerformanceRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.TagPerformanceRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.TagPerformanceRow.displayName = 'proto.analyzer.TagPerformanceRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.EntryExitTypesChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.EntryExitTypesChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.EntryExitTypesChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.EntryExitTypesChart.displayName = 'proto.analyzer.EntryExitTypesChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.EntryExitType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.EntryExitType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.EntryExitType.displayName = 'proto.analyzer.EntryExitType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.TimeInTradeBandsChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.TimeInTradeBandsChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.TimeInTradeBandsChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.TimeInTradeBandsChart.displayName = 'proto.analyzer.TimeInTradeBandsChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.TimeInTradeBand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.TimeInTradeBand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.TimeInTradeBand.displayName = 'proto.analyzer.TimeInTradeBand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.NewsProximityEffectChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.NewsProximityEffectChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.NewsProximityEffectChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.NewsProximityEffectChart.displayName = 'proto.analyzer.NewsProximityEffectChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.NewsProximityBucket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.NewsProximityBucket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.NewsProximityBucket.displayName = 'proto.analyzer.NewsProximityBucket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ScaledInTradesCard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.ScaledInTradesCard.repeatedFields_, null);
};
goog.inherits(proto.analyzer.ScaledInTradesCard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ScaledInTradesCard.displayName = 'proto.analyzer.ScaledInTradesCard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ScalingMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.ScalingMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ScalingMetrics.displayName = 'proto.analyzer.ScalingMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetAccountTradeListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.GetAccountTradeListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetAccountTradeListRequest.displayName = 'proto.analyzer.GetAccountTradeListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetAccountTradeListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.GetAccountTradeListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetAccountTradeListResponse.displayName = 'proto.analyzer.GetAccountTradeListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.TradeList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.TradeList.repeatedFields_, null);
};
goog.inherits(proto.analyzer.TradeList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.TradeList.displayName = 'proto.analyzer.TradeList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.TradeRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.TradeRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.TradeRow.displayName = 'proto.analyzer.TradeRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.TradeSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.TradeSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.TradeSummary.displayName = 'proto.analyzer.TradeSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetPortfolioOverviewReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.GetPortfolioOverviewReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetPortfolioOverviewReq.displayName = 'proto.analyzer.GetPortfolioOverviewReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetPortfolioOverviewReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.GetPortfolioOverviewReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetPortfolioOverviewReply.displayName = 'proto.analyzer.GetPortfolioOverviewReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.PortfolioSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.PortfolioSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.PortfolioSummary.displayName = 'proto.analyzer.PortfolioSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ROIMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.ROIMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ROIMetrics.displayName = 'proto.analyzer.ROIMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.AccountPerformance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.AccountPerformance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.AccountPerformance.displayName = 'proto.analyzer.AccountPerformance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetPortfolioEquityCurveReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.GetPortfolioEquityCurveReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetPortfolioEquityCurveReq.displayName = 'proto.analyzer.GetPortfolioEquityCurveReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.PortfolioEquityCurve = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.PortfolioEquityCurve.repeatedFields_, null);
};
goog.inherits(proto.analyzer.PortfolioEquityCurve, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.PortfolioEquityCurve.displayName = 'proto.analyzer.PortfolioEquityCurve';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetPortfolioDailyAndCumulativeROIReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.GetPortfolioDailyAndCumulativeROIReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.displayName = 'proto.analyzer.GetPortfolioDailyAndCumulativeROIReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.EquityCurveDataPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.EquityCurveDataPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.EquityCurveDataPoint.displayName = 'proto.analyzer.EquityCurveDataPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.DailyROIChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.DailyROIChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.DailyROIChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.DailyROIChart.displayName = 'proto.analyzer.DailyROIChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.DailyROIDataPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.DailyROIDataPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.DailyROIDataPoint.displayName = 'proto.analyzer.DailyROIDataPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ListAccountsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.ListAccountsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ListAccountsReq.displayName = 'proto.analyzer.ListAccountsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ListAccountsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.ListAccountsReply.repeatedFields_, null);
};
goog.inherits(proto.analyzer.ListAccountsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ListAccountsReply.displayName = 'proto.analyzer.ListAccountsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ListAccountsLiteReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.ListAccountsLiteReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ListAccountsLiteReq.displayName = 'proto.analyzer.ListAccountsLiteReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ListAccountsLiteReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.ListAccountsLiteReply.repeatedFields_, null);
};
goog.inherits(proto.analyzer.ListAccountsLiteReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ListAccountsLiteReply.displayName = 'proto.analyzer.ListAccountsLiteReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.AccountLite = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.AccountLite, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.AccountLite.displayName = 'proto.analyzer.AccountLite';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.AccountSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.AccountSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.AccountSummary.displayName = 'proto.analyzer.AccountSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.TrendChartData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.TrendChartData.repeatedFields_, null);
};
goog.inherits(proto.analyzer.TrendChartData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.TrendChartData.displayName = 'proto.analyzer.TrendChartData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.TrendDataPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.TrendDataPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.TrendDataPoint.displayName = 'proto.analyzer.TrendDataPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.RiskMetric = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.RiskMetric, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.RiskMetric.displayName = 'proto.analyzer.RiskMetric';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.AccountMetrics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.AccountMetrics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.AccountMetrics.displayName = 'proto.analyzer.AccountMetrics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.AccountEquityChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.AccountEquityChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.AccountEquityChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.AccountEquityChart.displayName = 'proto.analyzer.AccountEquityChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.EquityDataPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.EquityDataPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.EquityDataPoint.displayName = 'proto.analyzer.EquityDataPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ROISessionTrendsChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.ROISessionTrendsChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.ROISessionTrendsChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ROISessionTrendsChart.displayName = 'proto.analyzer.ROISessionTrendsChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ROISessionDataPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.ROISessionDataPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ROISessionDataPoint.displayName = 'proto.analyzer.ROISessionDataPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ROITrendsChart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.ROITrendsChart.repeatedFields_, null);
};
goog.inherits(proto.analyzer.ROITrendsChart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ROITrendsChart.displayName = 'proto.analyzer.ROITrendsChart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.ROITrendDataPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.ROITrendDataPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.ROITrendDataPoint.displayName = 'proto.analyzer.ROITrendDataPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.AIInsight = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.AIInsight, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.AIInsight.displayName = 'proto.analyzer.AIInsight';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetAccountSettingsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.GetAccountSettingsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetAccountSettingsReq.displayName = 'proto.analyzer.GetAccountSettingsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetAccountSettingsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.GetAccountSettingsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetAccountSettingsReply.displayName = 'proto.analyzer.GetAccountSettingsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.UpdateAccountSettingsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.UpdateAccountSettingsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.UpdateAccountSettingsReq.displayName = 'proto.analyzer.UpdateAccountSettingsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.UpdateAccountSettingsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.UpdateAccountSettingsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.UpdateAccountSettingsReply.displayName = 'proto.analyzer.UpdateAccountSettingsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.AccountAlertSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.AccountAlertSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.AccountAlertSettings.displayName = 'proto.analyzer.AccountAlertSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.Alert = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.Alert, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.Alert.displayName = 'proto.analyzer.Alert';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.UserTag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.UserTag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.UserTag.displayName = 'proto.analyzer.UserTag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetUserTagsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.GetUserTagsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetUserTagsReq.displayName = 'proto.analyzer.GetUserTagsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.GetUserTagsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.analyzer.GetUserTagsReply.repeatedFields_, null);
};
goog.inherits(proto.analyzer.GetUserTagsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.GetUserTagsReply.displayName = 'proto.analyzer.GetUserTagsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.CreateUserTagReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.CreateUserTagReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.CreateUserTagReq.displayName = 'proto.analyzer.CreateUserTagReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.CreateUserTagReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.CreateUserTagReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.CreateUserTagReply.displayName = 'proto.analyzer.CreateUserTagReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.DeleteUserTagReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.DeleteUserTagReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.DeleteUserTagReq.displayName = 'proto.analyzer.DeleteUserTagReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.DeleteUserTagReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.DeleteUserTagReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.DeleteUserTagReply.displayName = 'proto.analyzer.DeleteUserTagReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.SetTradeTagReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.SetTradeTagReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.SetTradeTagReq.displayName = 'proto.analyzer.SetTradeTagReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.SetTradeTagReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.SetTradeTagReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.SetTradeTagReply.displayName = 'proto.analyzer.SetTradeTagReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.UpdateUserTagReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.UpdateUserTagReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.UpdateUserTagReq.displayName = 'proto.analyzer.UpdateUserTagReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.analyzer.UpdateUserTagReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.analyzer.UpdateUserTagReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.analyzer.UpdateUserTagReply.displayName = 'proto.analyzer.UpdateUserTagReply';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.IntAddAccountReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.IntAddAccountReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.IntAddAccountReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.IntAddAccountReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
broker: jspb.Message.getFieldWithDefault(msg, 3, ""),
platform: jspb.Message.getFieldWithDefault(msg, 4, ""),
firmType: jspb.Message.getFieldWithDefault(msg, 5, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 6, ""),
nickname: jspb.Message.getFieldWithDefault(msg, 7, ""),
accountType: jspb.Message.getFieldWithDefault(msg, 8, ""),
serverId: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.IntAddAccountReq}
 */
proto.analyzer.IntAddAccountReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.IntAddAccountReq;
  return proto.analyzer.IntAddAccountReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.IntAddAccountReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.IntAddAccountReq}
 */
proto.analyzer.IntAddAccountReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirmType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountType(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.IntAddAccountReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.IntAddAccountReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.IntAddAccountReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.IntAddAccountReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFirmType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAccountType();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getServerId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.IntAddAccountReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.IntAddAccountReq} returns this
 */
proto.analyzer.IntAddAccountReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyzer.IntAddAccountReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.IntAddAccountReq} returns this
 */
proto.analyzer.IntAddAccountReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string broker = 3;
 * @return {string}
 */
proto.analyzer.IntAddAccountReq.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.IntAddAccountReq} returns this
 */
proto.analyzer.IntAddAccountReq.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string platform = 4;
 * @return {string}
 */
proto.analyzer.IntAddAccountReq.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.IntAddAccountReq} returns this
 */
proto.analyzer.IntAddAccountReq.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string firm_type = 5;
 * @return {string}
 */
proto.analyzer.IntAddAccountReq.prototype.getFirmType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.IntAddAccountReq} returns this
 */
proto.analyzer.IntAddAccountReq.prototype.setFirmType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string account_number = 6;
 * @return {string}
 */
proto.analyzer.IntAddAccountReq.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.IntAddAccountReq} returns this
 */
proto.analyzer.IntAddAccountReq.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string nickname = 7;
 * @return {string}
 */
proto.analyzer.IntAddAccountReq.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.IntAddAccountReq} returns this
 */
proto.analyzer.IntAddAccountReq.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string account_type = 8;
 * @return {string}
 */
proto.analyzer.IntAddAccountReq.prototype.getAccountType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.IntAddAccountReq} returns this
 */
proto.analyzer.IntAddAccountReq.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string server_id = 9;
 * @return {string}
 */
proto.analyzer.IntAddAccountReq.prototype.getServerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.IntAddAccountReq} returns this
 */
proto.analyzer.IntAddAccountReq.prototype.setServerId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.IntAddAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.IntAddAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.IntAddAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.IntAddAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.IntAddAccountReply}
 */
proto.analyzer.IntAddAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.IntAddAccountReply;
  return proto.analyzer.IntAddAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.IntAddAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.IntAddAccountReply}
 */
proto.analyzer.IntAddAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.IntAddAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.IntAddAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.IntAddAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.IntAddAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.DashboardOverviewReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.DashboardOverviewReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.DashboardOverviewReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DashboardOverviewReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
currency: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.DashboardOverviewReq}
 */
proto.analyzer.DashboardOverviewReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.DashboardOverviewReq;
  return proto.analyzer.DashboardOverviewReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.DashboardOverviewReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.DashboardOverviewReq}
 */
proto.analyzer.DashboardOverviewReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.DashboardOverviewReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.DashboardOverviewReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.DashboardOverviewReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DashboardOverviewReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.DashboardOverviewReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.DashboardOverviewReq} returns this
 */
proto.analyzer.DashboardOverviewReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.analyzer.DashboardOverviewReq.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.DashboardOverviewReq} returns this
 */
proto.analyzer.DashboardOverviewReq.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.DashboardOverviewReply.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.DashboardOverviewReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.DashboardOverviewReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.DashboardOverviewReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DashboardOverviewReply.toObject = function(includeInstance, msg) {
  var f, obj = {
equityCurve: (f = msg.getEquityCurve()) && proto.analyzer.PortfolioEquityCurve.toObject(includeInstance, f),
roiMeter: (f = msg.getRoiMeter()) && proto.analyzer.ROIMeter.toObject(includeInstance, f),
totalOpenTradeCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalOpenPnl: (f = msg.getTotalOpenPnl()) && common_common_pb.Money.toObject(includeInstance, f),
equity: (f = msg.getEquity()) && common_common_pb.Money.toObject(includeInstance, f),
insightsList: jspb.Message.toObjectList(msg.getInsightsList(),
    proto.analyzer.AIInsight.toObject, includeInstance),
bestPerformingAccount: (f = msg.getBestPerformingAccount()) && proto.analyzer.PerformingAccountCard.toObject(includeInstance, f),
worstPerformingAccount: (f = msg.getWorstPerformingAccount()) && proto.analyzer.PerformingAccountCard.toObject(includeInstance, f),
winRate: (f = msg.getWinRate()) && proto.analyzer.WinRateCard.toObject(includeInstance, f),
dailyDrawdown: (f = msg.getDailyDrawdown()) && proto.analyzer.DailyDrawdownCard.toObject(includeInstance, f),
averageRoi: (f = msg.getAverageRoi()) && proto.analyzer.PortfolioAverageRoiSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.DashboardOverviewReply}
 */
proto.analyzer.DashboardOverviewReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.DashboardOverviewReply;
  return proto.analyzer.DashboardOverviewReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.DashboardOverviewReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.DashboardOverviewReply}
 */
proto.analyzer.DashboardOverviewReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.PortfolioEquityCurve;
      reader.readMessage(value,proto.analyzer.PortfolioEquityCurve.deserializeBinaryFromReader);
      msg.setEquityCurve(value);
      break;
    case 2:
      var value = new proto.analyzer.ROIMeter;
      reader.readMessage(value,proto.analyzer.ROIMeter.deserializeBinaryFromReader);
      msg.setRoiMeter(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalOpenTradeCount(value);
      break;
    case 4:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setTotalOpenPnl(value);
      break;
    case 5:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setEquity(value);
      break;
    case 6:
      var value = new proto.analyzer.AIInsight;
      reader.readMessage(value,proto.analyzer.AIInsight.deserializeBinaryFromReader);
      msg.addInsights(value);
      break;
    case 7:
      var value = new proto.analyzer.PerformingAccountCard;
      reader.readMessage(value,proto.analyzer.PerformingAccountCard.deserializeBinaryFromReader);
      msg.setBestPerformingAccount(value);
      break;
    case 8:
      var value = new proto.analyzer.PerformingAccountCard;
      reader.readMessage(value,proto.analyzer.PerformingAccountCard.deserializeBinaryFromReader);
      msg.setWorstPerformingAccount(value);
      break;
    case 9:
      var value = new proto.analyzer.WinRateCard;
      reader.readMessage(value,proto.analyzer.WinRateCard.deserializeBinaryFromReader);
      msg.setWinRate(value);
      break;
    case 10:
      var value = new proto.analyzer.DailyDrawdownCard;
      reader.readMessage(value,proto.analyzer.DailyDrawdownCard.deserializeBinaryFromReader);
      msg.setDailyDrawdown(value);
      break;
    case 11:
      var value = new proto.analyzer.PortfolioAverageRoiSummary;
      reader.readMessage(value,proto.analyzer.PortfolioAverageRoiSummary.deserializeBinaryFromReader);
      msg.setAverageRoi(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.DashboardOverviewReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.DashboardOverviewReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.DashboardOverviewReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DashboardOverviewReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEquityCurve();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.analyzer.PortfolioEquityCurve.serializeBinaryToWriter
    );
  }
  f = message.getRoiMeter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.analyzer.ROIMeter.serializeBinaryToWriter
    );
  }
  f = message.getTotalOpenTradeCount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTotalOpenPnl();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getEquity();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getInsightsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.analyzer.AIInsight.serializeBinaryToWriter
    );
  }
  f = message.getBestPerformingAccount();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.analyzer.PerformingAccountCard.serializeBinaryToWriter
    );
  }
  f = message.getWorstPerformingAccount();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.analyzer.PerformingAccountCard.serializeBinaryToWriter
    );
  }
  f = message.getWinRate();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.analyzer.WinRateCard.serializeBinaryToWriter
    );
  }
  f = message.getDailyDrawdown();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.analyzer.DailyDrawdownCard.serializeBinaryToWriter
    );
  }
  f = message.getAverageRoi();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.analyzer.PortfolioAverageRoiSummary.serializeBinaryToWriter
    );
  }
};


/**
 * optional PortfolioEquityCurve equity_curve = 1;
 * @return {?proto.analyzer.PortfolioEquityCurve}
 */
proto.analyzer.DashboardOverviewReply.prototype.getEquityCurve = function() {
  return /** @type{?proto.analyzer.PortfolioEquityCurve} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.PortfolioEquityCurve, 1));
};


/**
 * @param {?proto.analyzer.PortfolioEquityCurve|undefined} value
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
*/
proto.analyzer.DashboardOverviewReply.prototype.setEquityCurve = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
 */
proto.analyzer.DashboardOverviewReply.prototype.clearEquityCurve = function() {
  return this.setEquityCurve(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.DashboardOverviewReply.prototype.hasEquityCurve = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ROIMeter roi_meter = 2;
 * @return {?proto.analyzer.ROIMeter}
 */
proto.analyzer.DashboardOverviewReply.prototype.getRoiMeter = function() {
  return /** @type{?proto.analyzer.ROIMeter} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.ROIMeter, 2));
};


/**
 * @param {?proto.analyzer.ROIMeter|undefined} value
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
*/
proto.analyzer.DashboardOverviewReply.prototype.setRoiMeter = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
 */
proto.analyzer.DashboardOverviewReply.prototype.clearRoiMeter = function() {
  return this.setRoiMeter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.DashboardOverviewReply.prototype.hasRoiMeter = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 total_open_trade_count = 3;
 * @return {number}
 */
proto.analyzer.DashboardOverviewReply.prototype.getTotalOpenTradeCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
 */
proto.analyzer.DashboardOverviewReply.prototype.setTotalOpenTradeCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional common.v1.Money total_open_pnl = 4;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.DashboardOverviewReply.prototype.getTotalOpenPnl = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 4));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
*/
proto.analyzer.DashboardOverviewReply.prototype.setTotalOpenPnl = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
 */
proto.analyzer.DashboardOverviewReply.prototype.clearTotalOpenPnl = function() {
  return this.setTotalOpenPnl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.DashboardOverviewReply.prototype.hasTotalOpenPnl = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional common.v1.Money equity = 5;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.DashboardOverviewReply.prototype.getEquity = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 5));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
*/
proto.analyzer.DashboardOverviewReply.prototype.setEquity = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
 */
proto.analyzer.DashboardOverviewReply.prototype.clearEquity = function() {
  return this.setEquity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.DashboardOverviewReply.prototype.hasEquity = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated AIInsight insights = 6;
 * @return {!Array<!proto.analyzer.AIInsight>}
 */
proto.analyzer.DashboardOverviewReply.prototype.getInsightsList = function() {
  return /** @type{!Array<!proto.analyzer.AIInsight>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.AIInsight, 6));
};


/**
 * @param {!Array<!proto.analyzer.AIInsight>} value
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
*/
proto.analyzer.DashboardOverviewReply.prototype.setInsightsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.analyzer.AIInsight=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.AIInsight}
 */
proto.analyzer.DashboardOverviewReply.prototype.addInsights = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.analyzer.AIInsight, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
 */
proto.analyzer.DashboardOverviewReply.prototype.clearInsightsList = function() {
  return this.setInsightsList([]);
};


/**
 * optional PerformingAccountCard best_performing_account = 7;
 * @return {?proto.analyzer.PerformingAccountCard}
 */
proto.analyzer.DashboardOverviewReply.prototype.getBestPerformingAccount = function() {
  return /** @type{?proto.analyzer.PerformingAccountCard} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.PerformingAccountCard, 7));
};


/**
 * @param {?proto.analyzer.PerformingAccountCard|undefined} value
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
*/
proto.analyzer.DashboardOverviewReply.prototype.setBestPerformingAccount = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
 */
proto.analyzer.DashboardOverviewReply.prototype.clearBestPerformingAccount = function() {
  return this.setBestPerformingAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.DashboardOverviewReply.prototype.hasBestPerformingAccount = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional PerformingAccountCard worst_performing_account = 8;
 * @return {?proto.analyzer.PerformingAccountCard}
 */
proto.analyzer.DashboardOverviewReply.prototype.getWorstPerformingAccount = function() {
  return /** @type{?proto.analyzer.PerformingAccountCard} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.PerformingAccountCard, 8));
};


/**
 * @param {?proto.analyzer.PerformingAccountCard|undefined} value
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
*/
proto.analyzer.DashboardOverviewReply.prototype.setWorstPerformingAccount = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
 */
proto.analyzer.DashboardOverviewReply.prototype.clearWorstPerformingAccount = function() {
  return this.setWorstPerformingAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.DashboardOverviewReply.prototype.hasWorstPerformingAccount = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional WinRateCard win_rate = 9;
 * @return {?proto.analyzer.WinRateCard}
 */
proto.analyzer.DashboardOverviewReply.prototype.getWinRate = function() {
  return /** @type{?proto.analyzer.WinRateCard} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.WinRateCard, 9));
};


/**
 * @param {?proto.analyzer.WinRateCard|undefined} value
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
*/
proto.analyzer.DashboardOverviewReply.prototype.setWinRate = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
 */
proto.analyzer.DashboardOverviewReply.prototype.clearWinRate = function() {
  return this.setWinRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.DashboardOverviewReply.prototype.hasWinRate = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional DailyDrawdownCard daily_drawdown = 10;
 * @return {?proto.analyzer.DailyDrawdownCard}
 */
proto.analyzer.DashboardOverviewReply.prototype.getDailyDrawdown = function() {
  return /** @type{?proto.analyzer.DailyDrawdownCard} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.DailyDrawdownCard, 10));
};


/**
 * @param {?proto.analyzer.DailyDrawdownCard|undefined} value
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
*/
proto.analyzer.DashboardOverviewReply.prototype.setDailyDrawdown = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
 */
proto.analyzer.DashboardOverviewReply.prototype.clearDailyDrawdown = function() {
  return this.setDailyDrawdown(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.DashboardOverviewReply.prototype.hasDailyDrawdown = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional PortfolioAverageRoiSummary average_roi = 11;
 * @return {?proto.analyzer.PortfolioAverageRoiSummary}
 */
proto.analyzer.DashboardOverviewReply.prototype.getAverageRoi = function() {
  return /** @type{?proto.analyzer.PortfolioAverageRoiSummary} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.PortfolioAverageRoiSummary, 11));
};


/**
 * @param {?proto.analyzer.PortfolioAverageRoiSummary|undefined} value
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
*/
proto.analyzer.DashboardOverviewReply.prototype.setAverageRoi = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.DashboardOverviewReply} returns this
 */
proto.analyzer.DashboardOverviewReply.prototype.clearAverageRoi = function() {
  return this.setAverageRoi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.DashboardOverviewReply.prototype.hasAverageRoi = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.PortfolioAverageRoiSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.PortfolioAverageRoiSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.PortfolioAverageRoiSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PortfolioAverageRoiSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
averageThisMonth: jspb.Message.getFieldWithDefault(msg, 1, ""),
averageLastMonth: jspb.Message.getFieldWithDefault(msg, 2, ""),
change: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.PortfolioAverageRoiSummary}
 */
proto.analyzer.PortfolioAverageRoiSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.PortfolioAverageRoiSummary;
  return proto.analyzer.PortfolioAverageRoiSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.PortfolioAverageRoiSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.PortfolioAverageRoiSummary}
 */
proto.analyzer.PortfolioAverageRoiSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAverageThisMonth(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAverageLastMonth(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.PortfolioAverageRoiSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.PortfolioAverageRoiSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.PortfolioAverageRoiSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PortfolioAverageRoiSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAverageThisMonth();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAverageLastMonth();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChange();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string average_this_month = 1;
 * @return {string}
 */
proto.analyzer.PortfolioAverageRoiSummary.prototype.getAverageThisMonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.PortfolioAverageRoiSummary} returns this
 */
proto.analyzer.PortfolioAverageRoiSummary.prototype.setAverageThisMonth = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string average_last_month = 2;
 * @return {string}
 */
proto.analyzer.PortfolioAverageRoiSummary.prototype.getAverageLastMonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.PortfolioAverageRoiSummary} returns this
 */
proto.analyzer.PortfolioAverageRoiSummary.prototype.setAverageLastMonth = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string change = 3;
 * @return {string}
 */
proto.analyzer.PortfolioAverageRoiSummary.prototype.getChange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.PortfolioAverageRoiSummary} returns this
 */
proto.analyzer.PortfolioAverageRoiSummary.prototype.setChange = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.PerformingAccountCard.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.PerformingAccountCard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.PerformingAccountCard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PerformingAccountCard.toObject = function(includeInstance, msg) {
  var f, obj = {
current: jspb.Message.getFieldWithDefault(msg, 1, ""),
yesterday: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.PerformingAccountCard}
 */
proto.analyzer.PerformingAccountCard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.PerformingAccountCard;
  return proto.analyzer.PerformingAccountCard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.PerformingAccountCard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.PerformingAccountCard}
 */
proto.analyzer.PerformingAccountCard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setYesterday(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.PerformingAccountCard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.PerformingAccountCard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.PerformingAccountCard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PerformingAccountCard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getYesterday();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string current = 1;
 * @return {string}
 */
proto.analyzer.PerformingAccountCard.prototype.getCurrent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.PerformingAccountCard} returns this
 */
proto.analyzer.PerformingAccountCard.prototype.setCurrent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string yesterday = 2;
 * @return {string}
 */
proto.analyzer.PerformingAccountCard.prototype.getYesterday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.PerformingAccountCard} returns this
 */
proto.analyzer.PerformingAccountCard.prototype.setYesterday = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.WinRateCard.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.WinRateCard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.WinRateCard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.WinRateCard.toObject = function(includeInstance, msg) {
  var f, obj = {
todayPct: jspb.Message.getFieldWithDefault(msg, 1, ""),
yesterday: jspb.Message.getFieldWithDefault(msg, 2, ""),
change: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.WinRateCard}
 */
proto.analyzer.WinRateCard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.WinRateCard;
  return proto.analyzer.WinRateCard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.WinRateCard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.WinRateCard}
 */
proto.analyzer.WinRateCard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTodayPct(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setYesterday(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.WinRateCard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.WinRateCard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.WinRateCard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.WinRateCard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTodayPct();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getYesterday();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChange();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string today_pct = 1;
 * @return {string}
 */
proto.analyzer.WinRateCard.prototype.getTodayPct = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.WinRateCard} returns this
 */
proto.analyzer.WinRateCard.prototype.setTodayPct = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string yesterday = 2;
 * @return {string}
 */
proto.analyzer.WinRateCard.prototype.getYesterday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.WinRateCard} returns this
 */
proto.analyzer.WinRateCard.prototype.setYesterday = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string change = 3;
 * @return {string}
 */
proto.analyzer.WinRateCard.prototype.getChange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.WinRateCard} returns this
 */
proto.analyzer.WinRateCard.prototype.setChange = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.DailyDrawdownCard.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.DailyDrawdownCard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.DailyDrawdownCard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DailyDrawdownCard.toObject = function(includeInstance, msg) {
  var f, obj = {
currentDrawdownPct: jspb.Message.getFieldWithDefault(msg, 1, ""),
limitedToPct: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.DailyDrawdownCard}
 */
proto.analyzer.DailyDrawdownCard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.DailyDrawdownCard;
  return proto.analyzer.DailyDrawdownCard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.DailyDrawdownCard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.DailyDrawdownCard}
 */
proto.analyzer.DailyDrawdownCard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentDrawdownPct(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLimitedToPct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.DailyDrawdownCard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.DailyDrawdownCard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.DailyDrawdownCard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DailyDrawdownCard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentDrawdownPct();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLimitedToPct();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string current_drawdown_pct = 1;
 * @return {string}
 */
proto.analyzer.DailyDrawdownCard.prototype.getCurrentDrawdownPct = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.DailyDrawdownCard} returns this
 */
proto.analyzer.DailyDrawdownCard.prototype.setCurrentDrawdownPct = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string limited_to_pct = 2;
 * @return {string}
 */
proto.analyzer.DailyDrawdownCard.prototype.getLimitedToPct = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.DailyDrawdownCard} returns this
 */
proto.analyzer.DailyDrawdownCard.prototype.setLimitedToPct = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.RiskMonitor.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.RiskMonitor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.RiskMonitor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RiskMonitor.toObject = function(includeInstance, msg) {
  var f, obj = {
dailyLoss: (f = msg.getDailyLoss()) && proto.analyzer.DailyLossProgress.toObject(includeInstance, f),
lotSizeCompliance: (f = msg.getLotSizeCompliance()) && proto.analyzer.LotSizeCompliance.toObject(includeInstance, f),
profitTarget: (f = msg.getProfitTarget()) && proto.analyzer.ProfitTargetProgress.toObject(includeInstance, f),
rulesBreaches: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.RiskMonitor}
 */
proto.analyzer.RiskMonitor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.RiskMonitor;
  return proto.analyzer.RiskMonitor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.RiskMonitor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.RiskMonitor}
 */
proto.analyzer.RiskMonitor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.DailyLossProgress;
      reader.readMessage(value,proto.analyzer.DailyLossProgress.deserializeBinaryFromReader);
      msg.setDailyLoss(value);
      break;
    case 2:
      var value = new proto.analyzer.LotSizeCompliance;
      reader.readMessage(value,proto.analyzer.LotSizeCompliance.deserializeBinaryFromReader);
      msg.setLotSizeCompliance(value);
      break;
    case 3:
      var value = new proto.analyzer.ProfitTargetProgress;
      reader.readMessage(value,proto.analyzer.ProfitTargetProgress.deserializeBinaryFromReader);
      msg.setProfitTarget(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRulesBreaches(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.RiskMonitor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.RiskMonitor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.RiskMonitor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RiskMonitor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDailyLoss();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.analyzer.DailyLossProgress.serializeBinaryToWriter
    );
  }
  f = message.getLotSizeCompliance();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.analyzer.LotSizeCompliance.serializeBinaryToWriter
    );
  }
  f = message.getProfitTarget();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.analyzer.ProfitTargetProgress.serializeBinaryToWriter
    );
  }
  f = message.getRulesBreaches();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional DailyLossProgress daily_loss = 1;
 * @return {?proto.analyzer.DailyLossProgress}
 */
proto.analyzer.RiskMonitor.prototype.getDailyLoss = function() {
  return /** @type{?proto.analyzer.DailyLossProgress} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.DailyLossProgress, 1));
};


/**
 * @param {?proto.analyzer.DailyLossProgress|undefined} value
 * @return {!proto.analyzer.RiskMonitor} returns this
*/
proto.analyzer.RiskMonitor.prototype.setDailyLoss = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.RiskMonitor} returns this
 */
proto.analyzer.RiskMonitor.prototype.clearDailyLoss = function() {
  return this.setDailyLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.RiskMonitor.prototype.hasDailyLoss = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LotSizeCompliance lot_size_compliance = 2;
 * @return {?proto.analyzer.LotSizeCompliance}
 */
proto.analyzer.RiskMonitor.prototype.getLotSizeCompliance = function() {
  return /** @type{?proto.analyzer.LotSizeCompliance} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.LotSizeCompliance, 2));
};


/**
 * @param {?proto.analyzer.LotSizeCompliance|undefined} value
 * @return {!proto.analyzer.RiskMonitor} returns this
*/
proto.analyzer.RiskMonitor.prototype.setLotSizeCompliance = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.RiskMonitor} returns this
 */
proto.analyzer.RiskMonitor.prototype.clearLotSizeCompliance = function() {
  return this.setLotSizeCompliance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.RiskMonitor.prototype.hasLotSizeCompliance = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ProfitTargetProgress profit_target = 3;
 * @return {?proto.analyzer.ProfitTargetProgress}
 */
proto.analyzer.RiskMonitor.prototype.getProfitTarget = function() {
  return /** @type{?proto.analyzer.ProfitTargetProgress} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.ProfitTargetProgress, 3));
};


/**
 * @param {?proto.analyzer.ProfitTargetProgress|undefined} value
 * @return {!proto.analyzer.RiskMonitor} returns this
*/
proto.analyzer.RiskMonitor.prototype.setProfitTarget = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.RiskMonitor} returns this
 */
proto.analyzer.RiskMonitor.prototype.clearProfitTarget = function() {
  return this.setProfitTarget(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.RiskMonitor.prototype.hasProfitTarget = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 rules_breaches = 4;
 * @return {number}
 */
proto.analyzer.RiskMonitor.prototype.getRulesBreaches = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.RiskMonitor} returns this
 */
proto.analyzer.RiskMonitor.prototype.setRulesBreaches = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.DailyLossProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.DailyLossProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.DailyLossProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DailyLossProgress.toObject = function(includeInstance, msg) {
  var f, obj = {
currentPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
limitPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
realizedPnlPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
status: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.DailyLossProgress}
 */
proto.analyzer.DailyLossProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.DailyLossProgress;
  return proto.analyzer.DailyLossProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.DailyLossProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.DailyLossProgress}
 */
proto.analyzer.DailyLossProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCurrentPct(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLimitPct(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRealizedPnlPct(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.DailyLossProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.DailyLossProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.DailyLossProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DailyLossProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentPct();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLimitPct();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getRealizedPnlPct();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional double current_pct = 1;
 * @return {number}
 */
proto.analyzer.DailyLossProgress.prototype.getCurrentPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.DailyLossProgress} returns this
 */
proto.analyzer.DailyLossProgress.prototype.setCurrentPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double limit_pct = 2;
 * @return {number}
 */
proto.analyzer.DailyLossProgress.prototype.getLimitPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.DailyLossProgress} returns this
 */
proto.analyzer.DailyLossProgress.prototype.setLimitPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double realized_pnl_pct = 3;
 * @return {number}
 */
proto.analyzer.DailyLossProgress.prototype.getRealizedPnlPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.DailyLossProgress} returns this
 */
proto.analyzer.DailyLossProgress.prototype.setRealizedPnlPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string status = 4;
 * @return {string}
 */
proto.analyzer.DailyLossProgress.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.DailyLossProgress} returns this
 */
proto.analyzer.DailyLossProgress.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.LotSizeCompliance.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.LotSizeCompliance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.LotSizeCompliance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.LotSizeCompliance.toObject = function(includeInstance, msg) {
  var f, obj = {
breachesToday: jspb.Message.getFieldWithDefault(msg, 1, 0),
largestLotSymbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
largestLotSize: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
maxLotSize: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
status: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.LotSizeCompliance}
 */
proto.analyzer.LotSizeCompliance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.LotSizeCompliance;
  return proto.analyzer.LotSizeCompliance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.LotSizeCompliance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.LotSizeCompliance}
 */
proto.analyzer.LotSizeCompliance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBreachesToday(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLargestLotSymbol(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLargestLotSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxLotSize(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.LotSizeCompliance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.LotSizeCompliance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.LotSizeCompliance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.LotSizeCompliance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBreachesToday();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLargestLotSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLargestLotSize();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getMaxLotSize();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int32 breaches_today = 1;
 * @return {number}
 */
proto.analyzer.LotSizeCompliance.prototype.getBreachesToday = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.LotSizeCompliance} returns this
 */
proto.analyzer.LotSizeCompliance.prototype.setBreachesToday = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string largest_lot_symbol = 2;
 * @return {string}
 */
proto.analyzer.LotSizeCompliance.prototype.getLargestLotSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.LotSizeCompliance} returns this
 */
proto.analyzer.LotSizeCompliance.prototype.setLargestLotSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double largest_lot_size = 3;
 * @return {number}
 */
proto.analyzer.LotSizeCompliance.prototype.getLargestLotSize = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.LotSizeCompliance} returns this
 */
proto.analyzer.LotSizeCompliance.prototype.setLargestLotSize = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double max_lot_size = 4;
 * @return {number}
 */
proto.analyzer.LotSizeCompliance.prototype.getMaxLotSize = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.LotSizeCompliance} returns this
 */
proto.analyzer.LotSizeCompliance.prototype.setMaxLotSize = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.analyzer.LotSizeCompliance.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.LotSizeCompliance} returns this
 */
proto.analyzer.LotSizeCompliance.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ProfitTargetProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ProfitTargetProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ProfitTargetProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ProfitTargetProgress.toObject = function(includeInstance, msg) {
  var f, obj = {
currentPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
targetPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
currentProfit: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
targetProfit: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
status: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ProfitTargetProgress}
 */
proto.analyzer.ProfitTargetProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ProfitTargetProgress;
  return proto.analyzer.ProfitTargetProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ProfitTargetProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ProfitTargetProgress}
 */
proto.analyzer.ProfitTargetProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCurrentPct(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTargetPct(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCurrentProfit(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTargetProfit(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ProfitTargetProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ProfitTargetProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ProfitTargetProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ProfitTargetProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentPct();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getTargetPct();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getCurrentProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getTargetProfit();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional double current_pct = 1;
 * @return {number}
 */
proto.analyzer.ProfitTargetProgress.prototype.getCurrentPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ProfitTargetProgress} returns this
 */
proto.analyzer.ProfitTargetProgress.prototype.setCurrentPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double target_pct = 2;
 * @return {number}
 */
proto.analyzer.ProfitTargetProgress.prototype.getTargetPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ProfitTargetProgress} returns this
 */
proto.analyzer.ProfitTargetProgress.prototype.setTargetPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double current_profit = 3;
 * @return {number}
 */
proto.analyzer.ProfitTargetProgress.prototype.getCurrentProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ProfitTargetProgress} returns this
 */
proto.analyzer.ProfitTargetProgress.prototype.setCurrentProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double target_profit = 4;
 * @return {number}
 */
proto.analyzer.ProfitTargetProgress.prototype.getTargetProfit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ProfitTargetProgress} returns this
 */
proto.analyzer.ProfitTargetProgress.prototype.setTargetProfit = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.analyzer.ProfitTargetProgress.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.ProfitTargetProgress} returns this
 */
proto.analyzer.ProfitTargetProgress.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetPerformanceOverviewReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetPerformanceOverviewReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetPerformanceOverviewReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetPerformanceOverviewReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
dateRange: (f = msg.getDateRange()) && common_common_pb.DateRange.toObject(includeInstance, f),
currency: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetPerformanceOverviewReq}
 */
proto.analyzer.GetPerformanceOverviewReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetPerformanceOverviewReq;
  return proto.analyzer.GetPerformanceOverviewReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetPerformanceOverviewReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetPerformanceOverviewReq}
 */
proto.analyzer.GetPerformanceOverviewReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = new common_common_pb.DateRange;
      reader.readMessage(value,common_common_pb.DateRange.deserializeBinaryFromReader);
      msg.setDateRange(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetPerformanceOverviewReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetPerformanceOverviewReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetPerformanceOverviewReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetPerformanceOverviewReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDateRange();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_common_pb.DateRange.serializeBinaryToWriter
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.GetPerformanceOverviewReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetPerformanceOverviewReq} returns this
 */
proto.analyzer.GetPerformanceOverviewReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyzer.GetPerformanceOverviewReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetPerformanceOverviewReq} returns this
 */
proto.analyzer.GetPerformanceOverviewReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.v1.DateRange date_range = 3;
 * @return {?proto.analyzer.common.v1.DateRange}
 */
proto.analyzer.GetPerformanceOverviewReq.prototype.getDateRange = function() {
  return /** @type{?proto.analyzer.common.v1.DateRange} */ (
    jspb.Message.getWrapperField(this, common_common_pb.DateRange, 3));
};


/**
 * @param {?proto.analyzer.common.v1.DateRange|undefined} value
 * @return {!proto.analyzer.GetPerformanceOverviewReq} returns this
*/
proto.analyzer.GetPerformanceOverviewReq.prototype.setDateRange = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetPerformanceOverviewReq} returns this
 */
proto.analyzer.GetPerformanceOverviewReq.prototype.clearDateRange = function() {
  return this.setDateRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetPerformanceOverviewReq.prototype.hasDateRange = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string currency = 4;
 * @return {string}
 */
proto.analyzer.GetPerformanceOverviewReq.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetPerformanceOverviewReq} returns this
 */
proto.analyzer.GetPerformanceOverviewReq.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.PerformanceOverviewReply.repeatedFields_ = [5,10,13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.PerformanceOverviewReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.PerformanceOverviewReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.PerformanceOverviewReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PerformanceOverviewReply.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
overview: (f = msg.getOverview()) && proto.analyzer.PerformanceOverview.toObject(includeInstance, f),
keyMetrics: (f = msg.getKeyMetrics()) && proto.analyzer.KeyMetrics.toObject(includeInstance, f),
instrumentPatternsList: jspb.Message.toObjectList(msg.getInstrumentPatternsList(),
    proto.analyzer.InstrumentPattern.toObject, includeInstance),
roiChart: (f = msg.getRoiChart()) && proto.analyzer.PerformanceChart.toObject(includeInstance, f),
timeOfDayRoi: (f = msg.getTimeOfDayRoi()) && proto.analyzer.TimeOfDayROIHeatmap.toObject(includeInstance, f),
bestMonth: (f = msg.getBestMonth()) && proto.analyzer.PeriodSummary.toObject(includeInstance, f),
worstMonth: (f = msg.getWorstMonth()) && proto.analyzer.PeriodSummary.toObject(includeInstance, f),
insightsList: jspb.Message.toObjectList(msg.getInsightsList(),
    proto.analyzer.AIInsight.toObject, includeInstance),
lastSynced: jspb.Message.getFieldWithDefault(msg, 11, ""),
riskMonitor: (f = msg.getRiskMonitor()) && proto.analyzer.RiskMonitor.toObject(includeInstance, f),
recentAlertsList: jspb.Message.toObjectList(msg.getRecentAlertsList(),
    proto.analyzer.Alert.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.PerformanceOverviewReply}
 */
proto.analyzer.PerformanceOverviewReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.PerformanceOverviewReply;
  return proto.analyzer.PerformanceOverviewReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.PerformanceOverviewReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.PerformanceOverviewReply}
 */
proto.analyzer.PerformanceOverviewReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = new proto.analyzer.PerformanceOverview;
      reader.readMessage(value,proto.analyzer.PerformanceOverview.deserializeBinaryFromReader);
      msg.setOverview(value);
      break;
    case 4:
      var value = new proto.analyzer.KeyMetrics;
      reader.readMessage(value,proto.analyzer.KeyMetrics.deserializeBinaryFromReader);
      msg.setKeyMetrics(value);
      break;
    case 5:
      var value = new proto.analyzer.InstrumentPattern;
      reader.readMessage(value,proto.analyzer.InstrumentPattern.deserializeBinaryFromReader);
      msg.addInstrumentPatterns(value);
      break;
    case 6:
      var value = new proto.analyzer.PerformanceChart;
      reader.readMessage(value,proto.analyzer.PerformanceChart.deserializeBinaryFromReader);
      msg.setRoiChart(value);
      break;
    case 7:
      var value = new proto.analyzer.TimeOfDayROIHeatmap;
      reader.readMessage(value,proto.analyzer.TimeOfDayROIHeatmap.deserializeBinaryFromReader);
      msg.setTimeOfDayRoi(value);
      break;
    case 8:
      var value = new proto.analyzer.PeriodSummary;
      reader.readMessage(value,proto.analyzer.PeriodSummary.deserializeBinaryFromReader);
      msg.setBestMonth(value);
      break;
    case 9:
      var value = new proto.analyzer.PeriodSummary;
      reader.readMessage(value,proto.analyzer.PeriodSummary.deserializeBinaryFromReader);
      msg.setWorstMonth(value);
      break;
    case 10:
      var value = new proto.analyzer.AIInsight;
      reader.readMessage(value,proto.analyzer.AIInsight.deserializeBinaryFromReader);
      msg.addInsights(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastSynced(value);
      break;
    case 12:
      var value = new proto.analyzer.RiskMonitor;
      reader.readMessage(value,proto.analyzer.RiskMonitor.deserializeBinaryFromReader);
      msg.setRiskMonitor(value);
      break;
    case 13:
      var value = new proto.analyzer.Alert;
      reader.readMessage(value,proto.analyzer.Alert.deserializeBinaryFromReader);
      msg.addRecentAlerts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.PerformanceOverviewReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.PerformanceOverviewReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.PerformanceOverviewReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PerformanceOverviewReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOverview();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.analyzer.PerformanceOverview.serializeBinaryToWriter
    );
  }
  f = message.getKeyMetrics();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.analyzer.KeyMetrics.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentPatternsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.analyzer.InstrumentPattern.serializeBinaryToWriter
    );
  }
  f = message.getRoiChart();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.analyzer.PerformanceChart.serializeBinaryToWriter
    );
  }
  f = message.getTimeOfDayRoi();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.analyzer.TimeOfDayROIHeatmap.serializeBinaryToWriter
    );
  }
  f = message.getBestMonth();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.analyzer.PeriodSummary.serializeBinaryToWriter
    );
  }
  f = message.getWorstMonth();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.analyzer.PeriodSummary.serializeBinaryToWriter
    );
  }
  f = message.getInsightsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.analyzer.AIInsight.serializeBinaryToWriter
    );
  }
  f = message.getLastSynced();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getRiskMonitor();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.analyzer.RiskMonitor.serializeBinaryToWriter
    );
  }
  f = message.getRecentAlertsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.analyzer.Alert.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.PerformanceOverviewReply.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
 */
proto.analyzer.PerformanceOverviewReply.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyzer.PerformanceOverviewReply.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
 */
proto.analyzer.PerformanceOverviewReply.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional PerformanceOverview overview = 3;
 * @return {?proto.analyzer.PerformanceOverview}
 */
proto.analyzer.PerformanceOverviewReply.prototype.getOverview = function() {
  return /** @type{?proto.analyzer.PerformanceOverview} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.PerformanceOverview, 3));
};


/**
 * @param {?proto.analyzer.PerformanceOverview|undefined} value
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
*/
proto.analyzer.PerformanceOverviewReply.prototype.setOverview = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
 */
proto.analyzer.PerformanceOverviewReply.prototype.clearOverview = function() {
  return this.setOverview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceOverviewReply.prototype.hasOverview = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional KeyMetrics key_metrics = 4;
 * @return {?proto.analyzer.KeyMetrics}
 */
proto.analyzer.PerformanceOverviewReply.prototype.getKeyMetrics = function() {
  return /** @type{?proto.analyzer.KeyMetrics} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.KeyMetrics, 4));
};


/**
 * @param {?proto.analyzer.KeyMetrics|undefined} value
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
*/
proto.analyzer.PerformanceOverviewReply.prototype.setKeyMetrics = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
 */
proto.analyzer.PerformanceOverviewReply.prototype.clearKeyMetrics = function() {
  return this.setKeyMetrics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceOverviewReply.prototype.hasKeyMetrics = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated InstrumentPattern instrument_patterns = 5;
 * @return {!Array<!proto.analyzer.InstrumentPattern>}
 */
proto.analyzer.PerformanceOverviewReply.prototype.getInstrumentPatternsList = function() {
  return /** @type{!Array<!proto.analyzer.InstrumentPattern>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.InstrumentPattern, 5));
};


/**
 * @param {!Array<!proto.analyzer.InstrumentPattern>} value
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
*/
proto.analyzer.PerformanceOverviewReply.prototype.setInstrumentPatternsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.analyzer.InstrumentPattern=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.InstrumentPattern}
 */
proto.analyzer.PerformanceOverviewReply.prototype.addInstrumentPatterns = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.analyzer.InstrumentPattern, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
 */
proto.analyzer.PerformanceOverviewReply.prototype.clearInstrumentPatternsList = function() {
  return this.setInstrumentPatternsList([]);
};


/**
 * optional PerformanceChart roi_chart = 6;
 * @return {?proto.analyzer.PerformanceChart}
 */
proto.analyzer.PerformanceOverviewReply.prototype.getRoiChart = function() {
  return /** @type{?proto.analyzer.PerformanceChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.PerformanceChart, 6));
};


/**
 * @param {?proto.analyzer.PerformanceChart|undefined} value
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
*/
proto.analyzer.PerformanceOverviewReply.prototype.setRoiChart = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
 */
proto.analyzer.PerformanceOverviewReply.prototype.clearRoiChart = function() {
  return this.setRoiChart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceOverviewReply.prototype.hasRoiChart = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional TimeOfDayROIHeatmap time_of_day_roi = 7;
 * @return {?proto.analyzer.TimeOfDayROIHeatmap}
 */
proto.analyzer.PerformanceOverviewReply.prototype.getTimeOfDayRoi = function() {
  return /** @type{?proto.analyzer.TimeOfDayROIHeatmap} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.TimeOfDayROIHeatmap, 7));
};


/**
 * @param {?proto.analyzer.TimeOfDayROIHeatmap|undefined} value
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
*/
proto.analyzer.PerformanceOverviewReply.prototype.setTimeOfDayRoi = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
 */
proto.analyzer.PerformanceOverviewReply.prototype.clearTimeOfDayRoi = function() {
  return this.setTimeOfDayRoi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceOverviewReply.prototype.hasTimeOfDayRoi = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional PeriodSummary best_month = 8;
 * @return {?proto.analyzer.PeriodSummary}
 */
proto.analyzer.PerformanceOverviewReply.prototype.getBestMonth = function() {
  return /** @type{?proto.analyzer.PeriodSummary} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.PeriodSummary, 8));
};


/**
 * @param {?proto.analyzer.PeriodSummary|undefined} value
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
*/
proto.analyzer.PerformanceOverviewReply.prototype.setBestMonth = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
 */
proto.analyzer.PerformanceOverviewReply.prototype.clearBestMonth = function() {
  return this.setBestMonth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceOverviewReply.prototype.hasBestMonth = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional PeriodSummary worst_month = 9;
 * @return {?proto.analyzer.PeriodSummary}
 */
proto.analyzer.PerformanceOverviewReply.prototype.getWorstMonth = function() {
  return /** @type{?proto.analyzer.PeriodSummary} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.PeriodSummary, 9));
};


/**
 * @param {?proto.analyzer.PeriodSummary|undefined} value
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
*/
proto.analyzer.PerformanceOverviewReply.prototype.setWorstMonth = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
 */
proto.analyzer.PerformanceOverviewReply.prototype.clearWorstMonth = function() {
  return this.setWorstMonth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceOverviewReply.prototype.hasWorstMonth = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * repeated AIInsight insights = 10;
 * @return {!Array<!proto.analyzer.AIInsight>}
 */
proto.analyzer.PerformanceOverviewReply.prototype.getInsightsList = function() {
  return /** @type{!Array<!proto.analyzer.AIInsight>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.AIInsight, 10));
};


/**
 * @param {!Array<!proto.analyzer.AIInsight>} value
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
*/
proto.analyzer.PerformanceOverviewReply.prototype.setInsightsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.analyzer.AIInsight=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.AIInsight}
 */
proto.analyzer.PerformanceOverviewReply.prototype.addInsights = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.analyzer.AIInsight, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
 */
proto.analyzer.PerformanceOverviewReply.prototype.clearInsightsList = function() {
  return this.setInsightsList([]);
};


/**
 * optional string last_synced = 11;
 * @return {string}
 */
proto.analyzer.PerformanceOverviewReply.prototype.getLastSynced = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
 */
proto.analyzer.PerformanceOverviewReply.prototype.setLastSynced = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional RiskMonitor risk_monitor = 12;
 * @return {?proto.analyzer.RiskMonitor}
 */
proto.analyzer.PerformanceOverviewReply.prototype.getRiskMonitor = function() {
  return /** @type{?proto.analyzer.RiskMonitor} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.RiskMonitor, 12));
};


/**
 * @param {?proto.analyzer.RiskMonitor|undefined} value
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
*/
proto.analyzer.PerformanceOverviewReply.prototype.setRiskMonitor = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
 */
proto.analyzer.PerformanceOverviewReply.prototype.clearRiskMonitor = function() {
  return this.setRiskMonitor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceOverviewReply.prototype.hasRiskMonitor = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * repeated Alert recent_alerts = 13;
 * @return {!Array<!proto.analyzer.Alert>}
 */
proto.analyzer.PerformanceOverviewReply.prototype.getRecentAlertsList = function() {
  return /** @type{!Array<!proto.analyzer.Alert>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.Alert, 13));
};


/**
 * @param {!Array<!proto.analyzer.Alert>} value
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
*/
proto.analyzer.PerformanceOverviewReply.prototype.setRecentAlertsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.analyzer.Alert=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.Alert}
 */
proto.analyzer.PerformanceOverviewReply.prototype.addRecentAlerts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.analyzer.Alert, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.PerformanceOverviewReply} returns this
 */
proto.analyzer.PerformanceOverviewReply.prototype.clearRecentAlertsList = function() {
  return this.setRecentAlertsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.PerformanceOverview.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.PerformanceOverview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.PerformanceOverview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PerformanceOverview.toObject = function(includeInstance, msg) {
  var f, obj = {
roiMeter: (f = msg.getRoiMeter()) && proto.analyzer.ROIMeter.toObject(includeInstance, f),
totalPnl: (f = msg.getTotalPnl()) && common_common_pb.Money.toObject(includeInstance, f),
feeBreakdown: (f = msg.getFeeBreakdown()) && proto.analyzer.FeeBreakDown.toObject(includeInstance, f),
bestDayProfit: (f = msg.getBestDayProfit()) && common_common_pb.Money.toObject(includeInstance, f),
financialOverview: (f = msg.getFinancialOverview()) && proto.analyzer.FinancialOverview.toObject(includeInstance, f),
openTrades: (f = msg.getOpenTrades()) && proto.analyzer.OpenTradesSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.PerformanceOverview}
 */
proto.analyzer.PerformanceOverview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.PerformanceOverview;
  return proto.analyzer.PerformanceOverview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.PerformanceOverview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.PerformanceOverview}
 */
proto.analyzer.PerformanceOverview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.ROIMeter;
      reader.readMessage(value,proto.analyzer.ROIMeter.deserializeBinaryFromReader);
      msg.setRoiMeter(value);
      break;
    case 2:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setTotalPnl(value);
      break;
    case 3:
      var value = new proto.analyzer.FeeBreakDown;
      reader.readMessage(value,proto.analyzer.FeeBreakDown.deserializeBinaryFromReader);
      msg.setFeeBreakdown(value);
      break;
    case 4:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setBestDayProfit(value);
      break;
    case 5:
      var value = new proto.analyzer.FinancialOverview;
      reader.readMessage(value,proto.analyzer.FinancialOverview.deserializeBinaryFromReader);
      msg.setFinancialOverview(value);
      break;
    case 6:
      var value = new proto.analyzer.OpenTradesSummary;
      reader.readMessage(value,proto.analyzer.OpenTradesSummary.deserializeBinaryFromReader);
      msg.setOpenTrades(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.PerformanceOverview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.PerformanceOverview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.PerformanceOverview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PerformanceOverview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoiMeter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.analyzer.ROIMeter.serializeBinaryToWriter
    );
  }
  f = message.getTotalPnl();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getFeeBreakdown();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.analyzer.FeeBreakDown.serializeBinaryToWriter
    );
  }
  f = message.getBestDayProfit();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getFinancialOverview();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.analyzer.FinancialOverview.serializeBinaryToWriter
    );
  }
  f = message.getOpenTrades();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.analyzer.OpenTradesSummary.serializeBinaryToWriter
    );
  }
};


/**
 * optional ROIMeter roi_meter = 1;
 * @return {?proto.analyzer.ROIMeter}
 */
proto.analyzer.PerformanceOverview.prototype.getRoiMeter = function() {
  return /** @type{?proto.analyzer.ROIMeter} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.ROIMeter, 1));
};


/**
 * @param {?proto.analyzer.ROIMeter|undefined} value
 * @return {!proto.analyzer.PerformanceOverview} returns this
*/
proto.analyzer.PerformanceOverview.prototype.setRoiMeter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceOverview} returns this
 */
proto.analyzer.PerformanceOverview.prototype.clearRoiMeter = function() {
  return this.setRoiMeter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceOverview.prototype.hasRoiMeter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.v1.Money total_pnl = 2;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.PerformanceOverview.prototype.getTotalPnl = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 2));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.PerformanceOverview} returns this
*/
proto.analyzer.PerformanceOverview.prototype.setTotalPnl = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceOverview} returns this
 */
proto.analyzer.PerformanceOverview.prototype.clearTotalPnl = function() {
  return this.setTotalPnl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceOverview.prototype.hasTotalPnl = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional FeeBreakDown fee_breakdown = 3;
 * @return {?proto.analyzer.FeeBreakDown}
 */
proto.analyzer.PerformanceOverview.prototype.getFeeBreakdown = function() {
  return /** @type{?proto.analyzer.FeeBreakDown} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.FeeBreakDown, 3));
};


/**
 * @param {?proto.analyzer.FeeBreakDown|undefined} value
 * @return {!proto.analyzer.PerformanceOverview} returns this
*/
proto.analyzer.PerformanceOverview.prototype.setFeeBreakdown = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceOverview} returns this
 */
proto.analyzer.PerformanceOverview.prototype.clearFeeBreakdown = function() {
  return this.setFeeBreakdown(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceOverview.prototype.hasFeeBreakdown = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional common.v1.Money best_day_profit = 4;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.PerformanceOverview.prototype.getBestDayProfit = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 4));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.PerformanceOverview} returns this
*/
proto.analyzer.PerformanceOverview.prototype.setBestDayProfit = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceOverview} returns this
 */
proto.analyzer.PerformanceOverview.prototype.clearBestDayProfit = function() {
  return this.setBestDayProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceOverview.prototype.hasBestDayProfit = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional FinancialOverview financial_overview = 5;
 * @return {?proto.analyzer.FinancialOverview}
 */
proto.analyzer.PerformanceOverview.prototype.getFinancialOverview = function() {
  return /** @type{?proto.analyzer.FinancialOverview} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.FinancialOverview, 5));
};


/**
 * @param {?proto.analyzer.FinancialOverview|undefined} value
 * @return {!proto.analyzer.PerformanceOverview} returns this
*/
proto.analyzer.PerformanceOverview.prototype.setFinancialOverview = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceOverview} returns this
 */
proto.analyzer.PerformanceOverview.prototype.clearFinancialOverview = function() {
  return this.setFinancialOverview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceOverview.prototype.hasFinancialOverview = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional OpenTradesSummary open_trades = 6;
 * @return {?proto.analyzer.OpenTradesSummary}
 */
proto.analyzer.PerformanceOverview.prototype.getOpenTrades = function() {
  return /** @type{?proto.analyzer.OpenTradesSummary} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.OpenTradesSummary, 6));
};


/**
 * @param {?proto.analyzer.OpenTradesSummary|undefined} value
 * @return {!proto.analyzer.PerformanceOverview} returns this
*/
proto.analyzer.PerformanceOverview.prototype.setOpenTrades = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceOverview} returns this
 */
proto.analyzer.PerformanceOverview.prototype.clearOpenTrades = function() {
  return this.setOpenTrades(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceOverview.prototype.hasOpenTrades = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ROIMeter.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ROIMeter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ROIMeter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ROIMeter.toObject = function(includeInstance, msg) {
  var f, obj = {
percentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
changeFromLastMonth: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ROIMeter}
 */
proto.analyzer.ROIMeter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ROIMeter;
  return proto.analyzer.ROIMeter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ROIMeter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ROIMeter}
 */
proto.analyzer.ROIMeter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPercentage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChangeFromLastMonth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ROIMeter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ROIMeter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ROIMeter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ROIMeter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getChangeFromLastMonth();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional double percentage = 1;
 * @return {number}
 */
proto.analyzer.ROIMeter.prototype.getPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ROIMeter} returns this
 */
proto.analyzer.ROIMeter.prototype.setPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional string change_from_last_month = 2;
 * @return {string}
 */
proto.analyzer.ROIMeter.prototype.getChangeFromLastMonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.ROIMeter} returns this
 */
proto.analyzer.ROIMeter.prototype.setChangeFromLastMonth = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.FinancialOverview.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.FinancialOverview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.FinancialOverview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.FinancialOverview.toObject = function(includeInstance, msg) {
  var f, obj = {
balance: (f = msg.getBalance()) && common_common_pb.Money.toObject(includeInstance, f),
equity: (f = msg.getEquity()) && common_common_pb.Money.toObject(includeInstance, f),
equityFromPeak: (f = msg.getEquityFromPeak()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
freeMargin: (f = msg.getFreeMargin()) && common_common_pb.Money.toObject(includeInstance, f),
marginLevel: (f = msg.getMarginLevel()) && proto.analyzer.MetricValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.FinancialOverview}
 */
proto.analyzer.FinancialOverview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.FinancialOverview;
  return proto.analyzer.FinancialOverview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.FinancialOverview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.FinancialOverview}
 */
proto.analyzer.FinancialOverview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setBalance(value);
      break;
    case 2:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setEquity(value);
      break;
    case 3:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setEquityFromPeak(value);
      break;
    case 4:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setFreeMargin(value);
      break;
    case 5:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setMarginLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.FinancialOverview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.FinancialOverview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.FinancialOverview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.FinancialOverview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBalance();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getEquity();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getEquityFromPeak();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getFreeMargin();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getMarginLevel();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.v1.Money balance = 1;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.FinancialOverview.prototype.getBalance = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 1));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.FinancialOverview} returns this
*/
proto.analyzer.FinancialOverview.prototype.setBalance = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.FinancialOverview} returns this
 */
proto.analyzer.FinancialOverview.prototype.clearBalance = function() {
  return this.setBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.FinancialOverview.prototype.hasBalance = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.v1.Money equity = 2;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.FinancialOverview.prototype.getEquity = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 2));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.FinancialOverview} returns this
*/
proto.analyzer.FinancialOverview.prototype.setEquity = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.FinancialOverview} returns this
 */
proto.analyzer.FinancialOverview.prototype.clearEquity = function() {
  return this.setEquity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.FinancialOverview.prototype.hasEquity = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional MetricValue equity_from_peak = 3;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.FinancialOverview.prototype.getEquityFromPeak = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 3));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.FinancialOverview} returns this
*/
proto.analyzer.FinancialOverview.prototype.setEquityFromPeak = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.FinancialOverview} returns this
 */
proto.analyzer.FinancialOverview.prototype.clearEquityFromPeak = function() {
  return this.setEquityFromPeak(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.FinancialOverview.prototype.hasEquityFromPeak = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional common.v1.Money free_margin = 4;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.FinancialOverview.prototype.getFreeMargin = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 4));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.FinancialOverview} returns this
*/
proto.analyzer.FinancialOverview.prototype.setFreeMargin = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.FinancialOverview} returns this
 */
proto.analyzer.FinancialOverview.prototype.clearFreeMargin = function() {
  return this.setFreeMargin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.FinancialOverview.prototype.hasFreeMargin = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional MetricValue margin_level = 5;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.FinancialOverview.prototype.getMarginLevel = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 5));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.FinancialOverview} returns this
*/
proto.analyzer.FinancialOverview.prototype.setMarginLevel = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.FinancialOverview} returns this
 */
proto.analyzer.FinancialOverview.prototype.clearMarginLevel = function() {
  return this.setMarginLevel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.FinancialOverview.prototype.hasMarginLevel = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.FeeBreakDown.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.FeeBreakDown.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.FeeBreakDown} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.FeeBreakDown.toObject = function(includeInstance, msg) {
  var f, obj = {
totalFees: (f = msg.getTotalFees()) && common_common_pb.Money.toObject(includeInstance, f),
commissions: (f = msg.getCommissions()) && common_common_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.FeeBreakDown}
 */
proto.analyzer.FeeBreakDown.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.FeeBreakDown;
  return proto.analyzer.FeeBreakDown.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.FeeBreakDown} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.FeeBreakDown}
 */
proto.analyzer.FeeBreakDown.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setTotalFees(value);
      break;
    case 2:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setCommissions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.FeeBreakDown.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.FeeBreakDown.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.FeeBreakDown} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.FeeBreakDown.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalFees();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getCommissions();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.v1.Money total_fees = 1;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.FeeBreakDown.prototype.getTotalFees = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 1));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.FeeBreakDown} returns this
*/
proto.analyzer.FeeBreakDown.prototype.setTotalFees = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.FeeBreakDown} returns this
 */
proto.analyzer.FeeBreakDown.prototype.clearTotalFees = function() {
  return this.setTotalFees(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.FeeBreakDown.prototype.hasTotalFees = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.v1.Money commissions = 2;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.FeeBreakDown.prototype.getCommissions = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 2));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.FeeBreakDown} returns this
*/
proto.analyzer.FeeBreakDown.prototype.setCommissions = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.FeeBreakDown} returns this
 */
proto.analyzer.FeeBreakDown.prototype.clearCommissions = function() {
  return this.setCommissions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.FeeBreakDown.prototype.hasCommissions = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.OpenTradesSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.OpenTradesSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.OpenTradesSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.OpenTradesSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
count: jspb.Message.getFieldWithDefault(msg, 1, 0),
floatingPnl: (f = msg.getFloatingPnl()) && common_common_pb.Money.toObject(includeInstance, f),
biggestTradeSymbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
biggestTradePnl: (f = msg.getBiggestTradePnl()) && common_common_pb.Money.toObject(includeInstance, f),
avgRiskPerTrade: jspb.Message.getFieldWithDefault(msg, 5, ""),
avgHold: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.OpenTradesSummary}
 */
proto.analyzer.OpenTradesSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.OpenTradesSummary;
  return proto.analyzer.OpenTradesSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.OpenTradesSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.OpenTradesSummary}
 */
proto.analyzer.OpenTradesSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    case 2:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setFloatingPnl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBiggestTradeSymbol(value);
      break;
    case 4:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setBiggestTradePnl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvgRiskPerTrade(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvgHold(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.OpenTradesSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.OpenTradesSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.OpenTradesSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.OpenTradesSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFloatingPnl();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getBiggestTradeSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBiggestTradePnl();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getAvgRiskPerTrade();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAvgHold();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 count = 1;
 * @return {number}
 */
proto.analyzer.OpenTradesSummary.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.OpenTradesSummary} returns this
 */
proto.analyzer.OpenTradesSummary.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional common.v1.Money floating_pnl = 2;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.OpenTradesSummary.prototype.getFloatingPnl = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 2));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.OpenTradesSummary} returns this
*/
proto.analyzer.OpenTradesSummary.prototype.setFloatingPnl = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.OpenTradesSummary} returns this
 */
proto.analyzer.OpenTradesSummary.prototype.clearFloatingPnl = function() {
  return this.setFloatingPnl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.OpenTradesSummary.prototype.hasFloatingPnl = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string biggest_trade_symbol = 3;
 * @return {string}
 */
proto.analyzer.OpenTradesSummary.prototype.getBiggestTradeSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.OpenTradesSummary} returns this
 */
proto.analyzer.OpenTradesSummary.prototype.setBiggestTradeSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional common.v1.Money biggest_trade_pnl = 4;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.OpenTradesSummary.prototype.getBiggestTradePnl = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 4));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.OpenTradesSummary} returns this
*/
proto.analyzer.OpenTradesSummary.prototype.setBiggestTradePnl = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.OpenTradesSummary} returns this
 */
proto.analyzer.OpenTradesSummary.prototype.clearBiggestTradePnl = function() {
  return this.setBiggestTradePnl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.OpenTradesSummary.prototype.hasBiggestTradePnl = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string avg_risk_per_trade = 5;
 * @return {string}
 */
proto.analyzer.OpenTradesSummary.prototype.getAvgRiskPerTrade = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.OpenTradesSummary} returns this
 */
proto.analyzer.OpenTradesSummary.prototype.setAvgRiskPerTrade = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string avg_hold = 6;
 * @return {string}
 */
proto.analyzer.OpenTradesSummary.prototype.getAvgHold = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.OpenTradesSummary} returns this
 */
proto.analyzer.OpenTradesSummary.prototype.setAvgHold = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.KeyMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.KeyMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.KeyMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.KeyMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
profitFactor: (f = msg.getProfitFactor()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
sharpeRatio: (f = msg.getSharpeRatio()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
dailyDrawdown: (f = msg.getDailyDrawdown()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
winRate: (f = msg.getWinRate()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
expectancy: (f = msg.getExpectancy()) && proto.analyzer.ExpectancyMetrics.toObject(includeInstance, f),
tradeCounts: (f = msg.getTradeCounts()) && proto.analyzer.TradeCounts.toObject(includeInstance, f),
grossProfit: (f = msg.getGrossProfit()) && common_common_pb.Money.toObject(includeInstance, f),
grossLoss: (f = msg.getGrossLoss()) && common_common_pb.Money.toObject(includeInstance, f),
dailyDrawdownLimitedTo: (f = msg.getDailyDrawdownLimitedTo()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
riskFreeRate: (f = msg.getRiskFreeRate()) && proto.analyzer.MetricValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.KeyMetrics}
 */
proto.analyzer.KeyMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.KeyMetrics;
  return proto.analyzer.KeyMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.KeyMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.KeyMetrics}
 */
proto.analyzer.KeyMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setProfitFactor(value);
      break;
    case 2:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setSharpeRatio(value);
      break;
    case 3:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setDailyDrawdown(value);
      break;
    case 4:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setWinRate(value);
      break;
    case 5:
      var value = new proto.analyzer.ExpectancyMetrics;
      reader.readMessage(value,proto.analyzer.ExpectancyMetrics.deserializeBinaryFromReader);
      msg.setExpectancy(value);
      break;
    case 6:
      var value = new proto.analyzer.TradeCounts;
      reader.readMessage(value,proto.analyzer.TradeCounts.deserializeBinaryFromReader);
      msg.setTradeCounts(value);
      break;
    case 7:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setGrossProfit(value);
      break;
    case 8:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setGrossLoss(value);
      break;
    case 9:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setDailyDrawdownLimitedTo(value);
      break;
    case 10:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setRiskFreeRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.KeyMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.KeyMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.KeyMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.KeyMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfitFactor();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getSharpeRatio();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getDailyDrawdown();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getWinRate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getExpectancy();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.analyzer.ExpectancyMetrics.serializeBinaryToWriter
    );
  }
  f = message.getTradeCounts();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.analyzer.TradeCounts.serializeBinaryToWriter
    );
  }
  f = message.getGrossProfit();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getGrossLoss();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getDailyDrawdownLimitedTo();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getRiskFreeRate();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional MetricValue profit_factor = 1;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.KeyMetrics.prototype.getProfitFactor = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 1));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.KeyMetrics} returns this
*/
proto.analyzer.KeyMetrics.prototype.setProfitFactor = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.KeyMetrics} returns this
 */
proto.analyzer.KeyMetrics.prototype.clearProfitFactor = function() {
  return this.setProfitFactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.KeyMetrics.prototype.hasProfitFactor = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional MetricValue sharpe_ratio = 2;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.KeyMetrics.prototype.getSharpeRatio = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 2));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.KeyMetrics} returns this
*/
proto.analyzer.KeyMetrics.prototype.setSharpeRatio = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.KeyMetrics} returns this
 */
proto.analyzer.KeyMetrics.prototype.clearSharpeRatio = function() {
  return this.setSharpeRatio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.KeyMetrics.prototype.hasSharpeRatio = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional MetricValue daily_drawdown = 3;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.KeyMetrics.prototype.getDailyDrawdown = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 3));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.KeyMetrics} returns this
*/
proto.analyzer.KeyMetrics.prototype.setDailyDrawdown = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.KeyMetrics} returns this
 */
proto.analyzer.KeyMetrics.prototype.clearDailyDrawdown = function() {
  return this.setDailyDrawdown(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.KeyMetrics.prototype.hasDailyDrawdown = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional MetricValue win_rate = 4;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.KeyMetrics.prototype.getWinRate = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 4));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.KeyMetrics} returns this
*/
proto.analyzer.KeyMetrics.prototype.setWinRate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.KeyMetrics} returns this
 */
proto.analyzer.KeyMetrics.prototype.clearWinRate = function() {
  return this.setWinRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.KeyMetrics.prototype.hasWinRate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ExpectancyMetrics expectancy = 5;
 * @return {?proto.analyzer.ExpectancyMetrics}
 */
proto.analyzer.KeyMetrics.prototype.getExpectancy = function() {
  return /** @type{?proto.analyzer.ExpectancyMetrics} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.ExpectancyMetrics, 5));
};


/**
 * @param {?proto.analyzer.ExpectancyMetrics|undefined} value
 * @return {!proto.analyzer.KeyMetrics} returns this
*/
proto.analyzer.KeyMetrics.prototype.setExpectancy = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.KeyMetrics} returns this
 */
proto.analyzer.KeyMetrics.prototype.clearExpectancy = function() {
  return this.setExpectancy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.KeyMetrics.prototype.hasExpectancy = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional TradeCounts trade_counts = 6;
 * @return {?proto.analyzer.TradeCounts}
 */
proto.analyzer.KeyMetrics.prototype.getTradeCounts = function() {
  return /** @type{?proto.analyzer.TradeCounts} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.TradeCounts, 6));
};


/**
 * @param {?proto.analyzer.TradeCounts|undefined} value
 * @return {!proto.analyzer.KeyMetrics} returns this
*/
proto.analyzer.KeyMetrics.prototype.setTradeCounts = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.KeyMetrics} returns this
 */
proto.analyzer.KeyMetrics.prototype.clearTradeCounts = function() {
  return this.setTradeCounts(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.KeyMetrics.prototype.hasTradeCounts = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional common.v1.Money gross_profit = 7;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.KeyMetrics.prototype.getGrossProfit = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 7));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.KeyMetrics} returns this
*/
proto.analyzer.KeyMetrics.prototype.setGrossProfit = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.KeyMetrics} returns this
 */
proto.analyzer.KeyMetrics.prototype.clearGrossProfit = function() {
  return this.setGrossProfit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.KeyMetrics.prototype.hasGrossProfit = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional common.v1.Money gross_loss = 8;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.KeyMetrics.prototype.getGrossLoss = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 8));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.KeyMetrics} returns this
*/
proto.analyzer.KeyMetrics.prototype.setGrossLoss = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.KeyMetrics} returns this
 */
proto.analyzer.KeyMetrics.prototype.clearGrossLoss = function() {
  return this.setGrossLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.KeyMetrics.prototype.hasGrossLoss = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional MetricValue daily_drawdown_limited_to = 9;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.KeyMetrics.prototype.getDailyDrawdownLimitedTo = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 9));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.KeyMetrics} returns this
*/
proto.analyzer.KeyMetrics.prototype.setDailyDrawdownLimitedTo = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.KeyMetrics} returns this
 */
proto.analyzer.KeyMetrics.prototype.clearDailyDrawdownLimitedTo = function() {
  return this.setDailyDrawdownLimitedTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.KeyMetrics.prototype.hasDailyDrawdownLimitedTo = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional MetricValue risk_free_rate = 10;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.KeyMetrics.prototype.getRiskFreeRate = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 10));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.KeyMetrics} returns this
*/
proto.analyzer.KeyMetrics.prototype.setRiskFreeRate = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.KeyMetrics} returns this
 */
proto.analyzer.KeyMetrics.prototype.clearRiskFreeRate = function() {
  return this.setRiskFreeRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.KeyMetrics.prototype.hasRiskFreeRate = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.MetricValue.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.MetricValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.MetricValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.MetricValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
formatted: jspb.Message.getFieldWithDefault(msg, 2, ""),
indicator: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.MetricValue}
 */
proto.analyzer.MetricValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.MetricValue;
  return proto.analyzer.MetricValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.MetricValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.MetricValue}
 */
proto.analyzer.MetricValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormatted(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndicator(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.MetricValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.MetricValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.MetricValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.MetricValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getFormatted();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIndicator();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.analyzer.MetricValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.MetricValue} returns this
 */
proto.analyzer.MetricValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional string formatted = 2;
 * @return {string}
 */
proto.analyzer.MetricValue.prototype.getFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.MetricValue} returns this
 */
proto.analyzer.MetricValue.prototype.setFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string indicator = 3;
 * @return {string}
 */
proto.analyzer.MetricValue.prototype.getIndicator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.MetricValue} returns this
 */
proto.analyzer.MetricValue.prototype.setIndicator = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.TradeCounts.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.TradeCounts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.TradeCounts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TradeCounts.toObject = function(includeInstance, msg) {
  var f, obj = {
total: jspb.Message.getFieldWithDefault(msg, 1, 0),
wins: jspb.Message.getFieldWithDefault(msg, 2, 0),
losses: jspb.Message.getFieldWithDefault(msg, 3, 0),
lossPct: (f = msg.getLossPct()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
summary: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.TradeCounts}
 */
proto.analyzer.TradeCounts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.TradeCounts;
  return proto.analyzer.TradeCounts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.TradeCounts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.TradeCounts}
 */
proto.analyzer.TradeCounts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWins(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLosses(value);
      break;
    case 4:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setLossPct(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.TradeCounts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.TradeCounts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.TradeCounts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TradeCounts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getWins();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLosses();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLossPct();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int32 total = 1;
 * @return {number}
 */
proto.analyzer.TradeCounts.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TradeCounts} returns this
 */
proto.analyzer.TradeCounts.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 wins = 2;
 * @return {number}
 */
proto.analyzer.TradeCounts.prototype.getWins = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TradeCounts} returns this
 */
proto.analyzer.TradeCounts.prototype.setWins = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 losses = 3;
 * @return {number}
 */
proto.analyzer.TradeCounts.prototype.getLosses = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TradeCounts} returns this
 */
proto.analyzer.TradeCounts.prototype.setLosses = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional MetricValue loss_pct = 4;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.TradeCounts.prototype.getLossPct = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 4));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.TradeCounts} returns this
*/
proto.analyzer.TradeCounts.prototype.setLossPct = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.TradeCounts} returns this
 */
proto.analyzer.TradeCounts.prototype.clearLossPct = function() {
  return this.setLossPct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.TradeCounts.prototype.hasLossPct = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string summary = 5;
 * @return {string}
 */
proto.analyzer.TradeCounts.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.TradeCounts} returns this
 */
proto.analyzer.TradeCounts.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetInstrumentPatternsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetInstrumentPatternsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetInstrumentPatternsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
dateRangeStart: jspb.Message.getFieldWithDefault(msg, 3, ""),
dateRangeEnd: jspb.Message.getFieldWithDefault(msg, 4, ""),
sortBy: jspb.Message.getFieldWithDefault(msg, 5, ""),
sortDesc: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
limit: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetInstrumentPatternsRequest}
 */
proto.analyzer.GetInstrumentPatternsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetInstrumentPatternsRequest;
  return proto.analyzer.GetInstrumentPatternsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetInstrumentPatternsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetInstrumentPatternsRequest}
 */
proto.analyzer.GetInstrumentPatternsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateRangeStart(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateRangeEnd(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortBy(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSortDesc(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetInstrumentPatternsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetInstrumentPatternsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetInstrumentPatternsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDateRangeStart();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDateRangeEnd();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSortBy();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSortDesc();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetInstrumentPatternsRequest} returns this
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetInstrumentPatternsRequest} returns this
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string date_range_start = 3;
 * @return {string}
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.getDateRangeStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetInstrumentPatternsRequest} returns this
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.setDateRangeStart = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string date_range_end = 4;
 * @return {string}
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.getDateRangeEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetInstrumentPatternsRequest} returns this
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.setDateRangeEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string sort_by = 5;
 * @return {string}
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.getSortBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetInstrumentPatternsRequest} returns this
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.setSortBy = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool sort_desc = 6;
 * @return {boolean}
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.getSortDesc = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.analyzer.GetInstrumentPatternsRequest} returns this
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.setSortDesc = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int32 limit = 7;
 * @return {number}
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.GetInstrumentPatternsRequest} returns this
 */
proto.analyzer.GetInstrumentPatternsRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.InstrumentPattern.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.InstrumentPattern.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.InstrumentPattern} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.InstrumentPattern.toObject = function(includeInstance, msg) {
  var f, obj = {
symbol: jspb.Message.getFieldWithDefault(msg, 1, ""),
instrumentType: jspb.Message.getFieldWithDefault(msg, 2, ""),
roiPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
totalTrades: jspb.Message.getFieldWithDefault(msg, 4, 0),
winRate: (f = msg.getWinRate()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
pnl: (f = msg.getPnl()) && common_common_pb.Money.toObject(includeInstance, f),
avgR: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
note: jspb.Message.getFieldWithDefault(msg, 8, ""),
noteColor: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.InstrumentPattern}
 */
proto.analyzer.InstrumentPattern.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.InstrumentPattern;
  return proto.analyzer.InstrumentPattern.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.InstrumentPattern} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.InstrumentPattern}
 */
proto.analyzer.InstrumentPattern.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstrumentType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRoiPct(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalTrades(value);
      break;
    case 5:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setWinRate(value);
      break;
    case 6:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setPnl(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgR(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setNoteColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.InstrumentPattern.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.InstrumentPattern.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.InstrumentPattern} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.InstrumentPattern.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInstrumentType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoiPct();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getTotalTrades();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getWinRate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getPnl();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getAvgR();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getNoteColor();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string symbol = 1;
 * @return {string}
 */
proto.analyzer.InstrumentPattern.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.InstrumentPattern} returns this
 */
proto.analyzer.InstrumentPattern.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string instrument_type = 2;
 * @return {string}
 */
proto.analyzer.InstrumentPattern.prototype.getInstrumentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.InstrumentPattern} returns this
 */
proto.analyzer.InstrumentPattern.prototype.setInstrumentType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double roi_pct = 3;
 * @return {number}
 */
proto.analyzer.InstrumentPattern.prototype.getRoiPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.InstrumentPattern} returns this
 */
proto.analyzer.InstrumentPattern.prototype.setRoiPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional int32 total_trades = 4;
 * @return {number}
 */
proto.analyzer.InstrumentPattern.prototype.getTotalTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.InstrumentPattern} returns this
 */
proto.analyzer.InstrumentPattern.prototype.setTotalTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional MetricValue win_rate = 5;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.InstrumentPattern.prototype.getWinRate = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 5));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.InstrumentPattern} returns this
*/
proto.analyzer.InstrumentPattern.prototype.setWinRate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.InstrumentPattern} returns this
 */
proto.analyzer.InstrumentPattern.prototype.clearWinRate = function() {
  return this.setWinRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.InstrumentPattern.prototype.hasWinRate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional common.v1.Money pnl = 6;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.InstrumentPattern.prototype.getPnl = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 6));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.InstrumentPattern} returns this
*/
proto.analyzer.InstrumentPattern.prototype.setPnl = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.InstrumentPattern} returns this
 */
proto.analyzer.InstrumentPattern.prototype.clearPnl = function() {
  return this.setPnl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.InstrumentPattern.prototype.hasPnl = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional double avg_r = 7;
 * @return {number}
 */
proto.analyzer.InstrumentPattern.prototype.getAvgR = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.InstrumentPattern} returns this
 */
proto.analyzer.InstrumentPattern.prototype.setAvgR = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional string note = 8;
 * @return {string}
 */
proto.analyzer.InstrumentPattern.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.InstrumentPattern} returns this
 */
proto.analyzer.InstrumentPattern.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string note_color = 9;
 * @return {string}
 */
proto.analyzer.InstrumentPattern.prototype.getNoteColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.InstrumentPattern} returns this
 */
proto.analyzer.InstrumentPattern.prototype.setNoteColor = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetPerformanceChartRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetPerformanceChartRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetPerformanceChartRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetPerformanceChartRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
dateRangeStart: jspb.Message.getFieldWithDefault(msg, 3, ""),
dateRangeEnd: jspb.Message.getFieldWithDefault(msg, 4, ""),
granularity: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetPerformanceChartRequest}
 */
proto.analyzer.GetPerformanceChartRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetPerformanceChartRequest;
  return proto.analyzer.GetPerformanceChartRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetPerformanceChartRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetPerformanceChartRequest}
 */
proto.analyzer.GetPerformanceChartRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateRangeStart(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateRangeEnd(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setGranularity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetPerformanceChartRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetPerformanceChartRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetPerformanceChartRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetPerformanceChartRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDateRangeStart();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDateRangeEnd();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getGranularity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.GetPerformanceChartRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetPerformanceChartRequest} returns this
 */
proto.analyzer.GetPerformanceChartRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyzer.GetPerformanceChartRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetPerformanceChartRequest} returns this
 */
proto.analyzer.GetPerformanceChartRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string date_range_start = 3;
 * @return {string}
 */
proto.analyzer.GetPerformanceChartRequest.prototype.getDateRangeStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetPerformanceChartRequest} returns this
 */
proto.analyzer.GetPerformanceChartRequest.prototype.setDateRangeStart = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string date_range_end = 4;
 * @return {string}
 */
proto.analyzer.GetPerformanceChartRequest.prototype.getDateRangeEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetPerformanceChartRequest} returns this
 */
proto.analyzer.GetPerformanceChartRequest.prototype.setDateRangeEnd = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string granularity = 5;
 * @return {string}
 */
proto.analyzer.GetPerformanceChartRequest.prototype.getGranularity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetPerformanceChartRequest} returns this
 */
proto.analyzer.GetPerformanceChartRequest.prototype.setGranularity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.PerformanceChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.PerformanceChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.PerformanceChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.PerformanceChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PerformanceChart.toObject = function(includeInstance, msg) {
  var f, obj = {
dataPointsList: jspb.Message.toObjectList(msg.getDataPointsList(),
    proto.analyzer.PerformanceDataPoint.toObject, includeInstance),
minRoi: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
maxRoi: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.PerformanceChart}
 */
proto.analyzer.PerformanceChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.PerformanceChart;
  return proto.analyzer.PerformanceChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.PerformanceChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.PerformanceChart}
 */
proto.analyzer.PerformanceChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.PerformanceDataPoint;
      reader.readMessage(value,proto.analyzer.PerformanceDataPoint.deserializeBinaryFromReader);
      msg.addDataPoints(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinRoi(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxRoi(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.PerformanceChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.PerformanceChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.PerformanceChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PerformanceChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.PerformanceDataPoint.serializeBinaryToWriter
    );
  }
  f = message.getMinRoi();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getMaxRoi();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * repeated PerformanceDataPoint data_points = 1;
 * @return {!Array<!proto.analyzer.PerformanceDataPoint>}
 */
proto.analyzer.PerformanceChart.prototype.getDataPointsList = function() {
  return /** @type{!Array<!proto.analyzer.PerformanceDataPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.PerformanceDataPoint, 1));
};


/**
 * @param {!Array<!proto.analyzer.PerformanceDataPoint>} value
 * @return {!proto.analyzer.PerformanceChart} returns this
*/
proto.analyzer.PerformanceChart.prototype.setDataPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.PerformanceDataPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.PerformanceDataPoint}
 */
proto.analyzer.PerformanceChart.prototype.addDataPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.PerformanceDataPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.PerformanceChart} returns this
 */
proto.analyzer.PerformanceChart.prototype.clearDataPointsList = function() {
  return this.setDataPointsList([]);
};


/**
 * optional double min_roi = 2;
 * @return {number}
 */
proto.analyzer.PerformanceChart.prototype.getMinRoi = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.PerformanceChart} returns this
 */
proto.analyzer.PerformanceChart.prototype.setMinRoi = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double max_roi = 3;
 * @return {number}
 */
proto.analyzer.PerformanceChart.prototype.getMaxRoi = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.PerformanceChart} returns this
 */
proto.analyzer.PerformanceChart.prototype.setMaxRoi = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.PerformanceDataPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.PerformanceDataPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.PerformanceDataPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PerformanceDataPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
period: jspb.Message.getFieldWithDefault(msg, 1, ""),
roiPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.PerformanceDataPoint}
 */
proto.analyzer.PerformanceDataPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.PerformanceDataPoint;
  return proto.analyzer.PerformanceDataPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.PerformanceDataPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.PerformanceDataPoint}
 */
proto.analyzer.PerformanceDataPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeriod(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRoiPct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.PerformanceDataPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.PerformanceDataPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.PerformanceDataPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PerformanceDataPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPeriod();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoiPct();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string period = 1;
 * @return {string}
 */
proto.analyzer.PerformanceDataPoint.prototype.getPeriod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.PerformanceDataPoint} returns this
 */
proto.analyzer.PerformanceDataPoint.prototype.setPeriod = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double roi_pct = 2;
 * @return {number}
 */
proto.analyzer.PerformanceDataPoint.prototype.getRoiPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.PerformanceDataPoint} returns this
 */
proto.analyzer.PerformanceDataPoint.prototype.setRoiPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.PeriodSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.PeriodSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.PeriodSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PeriodSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
period: jspb.Message.getFieldWithDefault(msg, 1, ""),
monthYear: jspb.Message.getFieldWithDefault(msg, 2, ""),
roiPct: (f = msg.getRoiPct()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
trades: jspb.Message.getFieldWithDefault(msg, 4, 0),
pnl: (f = msg.getPnl()) && common_common_pb.Money.toObject(includeInstance, f),
lossRate: (f = msg.getLossRate()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
winRate: (f = msg.getWinRate()) && proto.analyzer.MetricValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.PeriodSummary}
 */
proto.analyzer.PeriodSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.PeriodSummary;
  return proto.analyzer.PeriodSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.PeriodSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.PeriodSummary}
 */
proto.analyzer.PeriodSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeriod(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonthYear(value);
      break;
    case 3:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setRoiPct(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrades(value);
      break;
    case 5:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setPnl(value);
      break;
    case 6:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setLossRate(value);
      break;
    case 7:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setWinRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.PeriodSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.PeriodSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.PeriodSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PeriodSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPeriod();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMonthYear();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoiPct();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getTrades();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPnl();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getLossRate();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getWinRate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string period = 1;
 * @return {string}
 */
proto.analyzer.PeriodSummary.prototype.getPeriod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.PeriodSummary} returns this
 */
proto.analyzer.PeriodSummary.prototype.setPeriod = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string month_year = 2;
 * @return {string}
 */
proto.analyzer.PeriodSummary.prototype.getMonthYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.PeriodSummary} returns this
 */
proto.analyzer.PeriodSummary.prototype.setMonthYear = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional MetricValue roi_pct = 3;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.PeriodSummary.prototype.getRoiPct = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 3));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.PeriodSummary} returns this
*/
proto.analyzer.PeriodSummary.prototype.setRoiPct = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PeriodSummary} returns this
 */
proto.analyzer.PeriodSummary.prototype.clearRoiPct = function() {
  return this.setRoiPct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PeriodSummary.prototype.hasRoiPct = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 trades = 4;
 * @return {number}
 */
proto.analyzer.PeriodSummary.prototype.getTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.PeriodSummary} returns this
 */
proto.analyzer.PeriodSummary.prototype.setTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional common.v1.Money pnl = 5;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.PeriodSummary.prototype.getPnl = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 5));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.PeriodSummary} returns this
*/
proto.analyzer.PeriodSummary.prototype.setPnl = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PeriodSummary} returns this
 */
proto.analyzer.PeriodSummary.prototype.clearPnl = function() {
  return this.setPnl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PeriodSummary.prototype.hasPnl = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional MetricValue loss_rate = 6;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.PeriodSummary.prototype.getLossRate = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 6));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.PeriodSummary} returns this
*/
proto.analyzer.PeriodSummary.prototype.setLossRate = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PeriodSummary} returns this
 */
proto.analyzer.PeriodSummary.prototype.clearLossRate = function() {
  return this.setLossRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PeriodSummary.prototype.hasLossRate = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional MetricValue win_rate = 7;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.PeriodSummary.prototype.getWinRate = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 7));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.PeriodSummary} returns this
*/
proto.analyzer.PeriodSummary.prototype.setWinRate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PeriodSummary} returns this
 */
proto.analyzer.PeriodSummary.prototype.clearWinRate = function() {
  return this.setWinRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PeriodSummary.prototype.hasWinRate = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetWeeklyHeatmapRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetWeeklyHeatmapRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetWeeklyHeatmapRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetWeeklyHeatmapRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetWeeklyHeatmapRequest}
 */
proto.analyzer.GetWeeklyHeatmapRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetWeeklyHeatmapRequest;
  return proto.analyzer.GetWeeklyHeatmapRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetWeeklyHeatmapRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetWeeklyHeatmapRequest}
 */
proto.analyzer.GetWeeklyHeatmapRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetWeeklyHeatmapRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetWeeklyHeatmapRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetWeeklyHeatmapRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetWeeklyHeatmapRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.GetWeeklyHeatmapRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetWeeklyHeatmapRequest} returns this
 */
proto.analyzer.GetWeeklyHeatmapRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyzer.GetWeeklyHeatmapRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetWeeklyHeatmapRequest} returns this
 */
proto.analyzer.GetWeeklyHeatmapRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetAccountPerformanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetAccountPerformanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetAccountPerformanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetAccountPerformanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
currency: jspb.Message.getFieldWithDefault(msg, 3, ""),
dateRange: (f = msg.getDateRange()) && common_common_pb.DateRange.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetAccountPerformanceRequest}
 */
proto.analyzer.GetAccountPerformanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetAccountPerformanceRequest;
  return proto.analyzer.GetAccountPerformanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetAccountPerformanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetAccountPerformanceRequest}
 */
proto.analyzer.GetAccountPerformanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 4:
      var value = new common_common_pb.DateRange;
      reader.readMessage(value,common_common_pb.DateRange.deserializeBinaryFromReader);
      msg.setDateRange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetAccountPerformanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetAccountPerformanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetAccountPerformanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetAccountPerformanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDateRange();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_common_pb.DateRange.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.GetAccountPerformanceRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetAccountPerformanceRequest} returns this
 */
proto.analyzer.GetAccountPerformanceRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyzer.GetAccountPerformanceRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetAccountPerformanceRequest} returns this
 */
proto.analyzer.GetAccountPerformanceRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string currency = 3;
 * @return {string}
 */
proto.analyzer.GetAccountPerformanceRequest.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetAccountPerformanceRequest} returns this
 */
proto.analyzer.GetAccountPerformanceRequest.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional common.v1.DateRange date_range = 4;
 * @return {?proto.analyzer.common.v1.DateRange}
 */
proto.analyzer.GetAccountPerformanceRequest.prototype.getDateRange = function() {
  return /** @type{?proto.analyzer.common.v1.DateRange} */ (
    jspb.Message.getWrapperField(this, common_common_pb.DateRange, 4));
};


/**
 * @param {?proto.analyzer.common.v1.DateRange|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceRequest} returns this
*/
proto.analyzer.GetAccountPerformanceRequest.prototype.setDateRange = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceRequest} returns this
 */
proto.analyzer.GetAccountPerformanceRequest.prototype.clearDateRange = function() {
  return this.setDateRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceRequest.prototype.hasDateRange = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.GetAccountPerformanceResponse.repeatedFields_ = [21];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetAccountPerformanceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetAccountPerformanceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetAccountPerformanceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
metrics: (f = msg.getMetrics()) && proto.analyzer.PerformanceMetrics.toObject(includeInstance, f),
equityCurve: (f = msg.getEquityCurve()) && proto.analyzer.EquityCurveChart.toObject(includeInstance, f),
returnDistribution: (f = msg.getReturnDistribution()) && proto.analyzer.ReturnDistributionChart.toObject(includeInstance, f),
drawdownSeries: (f = msg.getDrawdownSeries()) && proto.analyzer.DrawdownSeriesChart.toObject(includeInstance, f),
rollingWinRate: (f = msg.getRollingWinRate()) && proto.analyzer.RollingWinRateChart.toObject(includeInstance, f),
rollingProfitFactor: (f = msg.getRollingProfitFactor()) && proto.analyzer.RollingProfitFactorChart.toObject(includeInstance, f),
rollingDrawdown: (f = msg.getRollingDrawdown()) && proto.analyzer.RollingDrawdownChart.toObject(includeInstance, f),
riskPerTrade: (f = msg.getRiskPerTrade()) && proto.analyzer.RiskPerTradeVsOutcomeChart.toObject(includeInstance, f),
losingStreaks: (f = msg.getLosingStreaks()) && proto.analyzer.LosingStreaksRecoveryCard.toObject(includeInstance, f),
propRuleUsage: (f = msg.getPropRuleUsage()) && proto.analyzer.PropRuleUsageCard.toObject(includeInstance, f),
instrumentRoiTable: (f = msg.getInstrumentRoiTable()) && proto.analyzer.InstrumentROITable.toObject(includeInstance, f),
dayOfWeekRoi: (f = msg.getDayOfWeekRoi()) && proto.analyzer.DayOfWeekROIChart.toObject(includeInstance, f),
sessionAnalysis: (f = msg.getSessionAnalysis()) && proto.analyzer.SessionAnalysisChart.toObject(includeInstance, f),
holdingTimeVsReturn: (f = msg.getHoldingTimeVsReturn()) && proto.analyzer.HoldingTimeVsReturnChart.toObject(includeInstance, f),
timeOfDayRoi: (f = msg.getTimeOfDayRoi()) && proto.analyzer.TimeOfDayROIHeatmap.toObject(includeInstance, f),
tagPerformance: (f = msg.getTagPerformance()) && proto.analyzer.TagPerformanceTable.toObject(includeInstance, f),
entryExitTypes: (f = msg.getEntryExitTypes()) && proto.analyzer.EntryExitTypesChart.toObject(includeInstance, f),
timeInTradeBands: (f = msg.getTimeInTradeBands()) && proto.analyzer.TimeInTradeBandsChart.toObject(includeInstance, f),
newsProximityEffect: (f = msg.getNewsProximityEffect()) && proto.analyzer.NewsProximityEffectChart.toObject(includeInstance, f),
scaledInTrades: (f = msg.getScaledInTrades()) && proto.analyzer.ScaledInTradesCard.toObject(includeInstance, f),
insightsList: jspb.Message.toObjectList(msg.getInsightsList(),
    proto.analyzer.AIInsight.toObject, includeInstance),
lastSynced: jspb.Message.getFieldWithDefault(msg, 22, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetAccountPerformanceResponse}
 */
proto.analyzer.GetAccountPerformanceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetAccountPerformanceResponse;
  return proto.analyzer.GetAccountPerformanceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetAccountPerformanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetAccountPerformanceResponse}
 */
proto.analyzer.GetAccountPerformanceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.PerformanceMetrics;
      reader.readMessage(value,proto.analyzer.PerformanceMetrics.deserializeBinaryFromReader);
      msg.setMetrics(value);
      break;
    case 2:
      var value = new proto.analyzer.EquityCurveChart;
      reader.readMessage(value,proto.analyzer.EquityCurveChart.deserializeBinaryFromReader);
      msg.setEquityCurve(value);
      break;
    case 3:
      var value = new proto.analyzer.ReturnDistributionChart;
      reader.readMessage(value,proto.analyzer.ReturnDistributionChart.deserializeBinaryFromReader);
      msg.setReturnDistribution(value);
      break;
    case 4:
      var value = new proto.analyzer.DrawdownSeriesChart;
      reader.readMessage(value,proto.analyzer.DrawdownSeriesChart.deserializeBinaryFromReader);
      msg.setDrawdownSeries(value);
      break;
    case 5:
      var value = new proto.analyzer.RollingWinRateChart;
      reader.readMessage(value,proto.analyzer.RollingWinRateChart.deserializeBinaryFromReader);
      msg.setRollingWinRate(value);
      break;
    case 6:
      var value = new proto.analyzer.RollingProfitFactorChart;
      reader.readMessage(value,proto.analyzer.RollingProfitFactorChart.deserializeBinaryFromReader);
      msg.setRollingProfitFactor(value);
      break;
    case 7:
      var value = new proto.analyzer.RollingDrawdownChart;
      reader.readMessage(value,proto.analyzer.RollingDrawdownChart.deserializeBinaryFromReader);
      msg.setRollingDrawdown(value);
      break;
    case 8:
      var value = new proto.analyzer.RiskPerTradeVsOutcomeChart;
      reader.readMessage(value,proto.analyzer.RiskPerTradeVsOutcomeChart.deserializeBinaryFromReader);
      msg.setRiskPerTrade(value);
      break;
    case 9:
      var value = new proto.analyzer.LosingStreaksRecoveryCard;
      reader.readMessage(value,proto.analyzer.LosingStreaksRecoveryCard.deserializeBinaryFromReader);
      msg.setLosingStreaks(value);
      break;
    case 10:
      var value = new proto.analyzer.PropRuleUsageCard;
      reader.readMessage(value,proto.analyzer.PropRuleUsageCard.deserializeBinaryFromReader);
      msg.setPropRuleUsage(value);
      break;
    case 11:
      var value = new proto.analyzer.InstrumentROITable;
      reader.readMessage(value,proto.analyzer.InstrumentROITable.deserializeBinaryFromReader);
      msg.setInstrumentRoiTable(value);
      break;
    case 12:
      var value = new proto.analyzer.DayOfWeekROIChart;
      reader.readMessage(value,proto.analyzer.DayOfWeekROIChart.deserializeBinaryFromReader);
      msg.setDayOfWeekRoi(value);
      break;
    case 13:
      var value = new proto.analyzer.SessionAnalysisChart;
      reader.readMessage(value,proto.analyzer.SessionAnalysisChart.deserializeBinaryFromReader);
      msg.setSessionAnalysis(value);
      break;
    case 14:
      var value = new proto.analyzer.HoldingTimeVsReturnChart;
      reader.readMessage(value,proto.analyzer.HoldingTimeVsReturnChart.deserializeBinaryFromReader);
      msg.setHoldingTimeVsReturn(value);
      break;
    case 15:
      var value = new proto.analyzer.TimeOfDayROIHeatmap;
      reader.readMessage(value,proto.analyzer.TimeOfDayROIHeatmap.deserializeBinaryFromReader);
      msg.setTimeOfDayRoi(value);
      break;
    case 16:
      var value = new proto.analyzer.TagPerformanceTable;
      reader.readMessage(value,proto.analyzer.TagPerformanceTable.deserializeBinaryFromReader);
      msg.setTagPerformance(value);
      break;
    case 17:
      var value = new proto.analyzer.EntryExitTypesChart;
      reader.readMessage(value,proto.analyzer.EntryExitTypesChart.deserializeBinaryFromReader);
      msg.setEntryExitTypes(value);
      break;
    case 18:
      var value = new proto.analyzer.TimeInTradeBandsChart;
      reader.readMessage(value,proto.analyzer.TimeInTradeBandsChart.deserializeBinaryFromReader);
      msg.setTimeInTradeBands(value);
      break;
    case 19:
      var value = new proto.analyzer.NewsProximityEffectChart;
      reader.readMessage(value,proto.analyzer.NewsProximityEffectChart.deserializeBinaryFromReader);
      msg.setNewsProximityEffect(value);
      break;
    case 20:
      var value = new proto.analyzer.ScaledInTradesCard;
      reader.readMessage(value,proto.analyzer.ScaledInTradesCard.deserializeBinaryFromReader);
      msg.setScaledInTrades(value);
      break;
    case 21:
      var value = new proto.analyzer.AIInsight;
      reader.readMessage(value,proto.analyzer.AIInsight.deserializeBinaryFromReader);
      msg.addInsights(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastSynced(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetAccountPerformanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetAccountPerformanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetAccountPerformanceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetrics();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.analyzer.PerformanceMetrics.serializeBinaryToWriter
    );
  }
  f = message.getEquityCurve();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.analyzer.EquityCurveChart.serializeBinaryToWriter
    );
  }
  f = message.getReturnDistribution();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.analyzer.ReturnDistributionChart.serializeBinaryToWriter
    );
  }
  f = message.getDrawdownSeries();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.analyzer.DrawdownSeriesChart.serializeBinaryToWriter
    );
  }
  f = message.getRollingWinRate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.analyzer.RollingWinRateChart.serializeBinaryToWriter
    );
  }
  f = message.getRollingProfitFactor();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.analyzer.RollingProfitFactorChart.serializeBinaryToWriter
    );
  }
  f = message.getRollingDrawdown();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.analyzer.RollingDrawdownChart.serializeBinaryToWriter
    );
  }
  f = message.getRiskPerTrade();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.analyzer.RiskPerTradeVsOutcomeChart.serializeBinaryToWriter
    );
  }
  f = message.getLosingStreaks();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.analyzer.LosingStreaksRecoveryCard.serializeBinaryToWriter
    );
  }
  f = message.getPropRuleUsage();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.analyzer.PropRuleUsageCard.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentRoiTable();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.analyzer.InstrumentROITable.serializeBinaryToWriter
    );
  }
  f = message.getDayOfWeekRoi();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.analyzer.DayOfWeekROIChart.serializeBinaryToWriter
    );
  }
  f = message.getSessionAnalysis();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.analyzer.SessionAnalysisChart.serializeBinaryToWriter
    );
  }
  f = message.getHoldingTimeVsReturn();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.analyzer.HoldingTimeVsReturnChart.serializeBinaryToWriter
    );
  }
  f = message.getTimeOfDayRoi();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.analyzer.TimeOfDayROIHeatmap.serializeBinaryToWriter
    );
  }
  f = message.getTagPerformance();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.analyzer.TagPerformanceTable.serializeBinaryToWriter
    );
  }
  f = message.getEntryExitTypes();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.analyzer.EntryExitTypesChart.serializeBinaryToWriter
    );
  }
  f = message.getTimeInTradeBands();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.analyzer.TimeInTradeBandsChart.serializeBinaryToWriter
    );
  }
  f = message.getNewsProximityEffect();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.analyzer.NewsProximityEffectChart.serializeBinaryToWriter
    );
  }
  f = message.getScaledInTrades();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.analyzer.ScaledInTradesCard.serializeBinaryToWriter
    );
  }
  f = message.getInsightsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      21,
      f,
      proto.analyzer.AIInsight.serializeBinaryToWriter
    );
  }
  f = message.getLastSynced();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
};


/**
 * optional PerformanceMetrics metrics = 1;
 * @return {?proto.analyzer.PerformanceMetrics}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getMetrics = function() {
  return /** @type{?proto.analyzer.PerformanceMetrics} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.PerformanceMetrics, 1));
};


/**
 * @param {?proto.analyzer.PerformanceMetrics|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setMetrics = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearMetrics = function() {
  return this.setMetrics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasMetrics = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EquityCurveChart equity_curve = 2;
 * @return {?proto.analyzer.EquityCurveChart}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getEquityCurve = function() {
  return /** @type{?proto.analyzer.EquityCurveChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.EquityCurveChart, 2));
};


/**
 * @param {?proto.analyzer.EquityCurveChart|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setEquityCurve = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearEquityCurve = function() {
  return this.setEquityCurve(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasEquityCurve = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ReturnDistributionChart return_distribution = 3;
 * @return {?proto.analyzer.ReturnDistributionChart}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getReturnDistribution = function() {
  return /** @type{?proto.analyzer.ReturnDistributionChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.ReturnDistributionChart, 3));
};


/**
 * @param {?proto.analyzer.ReturnDistributionChart|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setReturnDistribution = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearReturnDistribution = function() {
  return this.setReturnDistribution(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasReturnDistribution = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional DrawdownSeriesChart drawdown_series = 4;
 * @return {?proto.analyzer.DrawdownSeriesChart}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getDrawdownSeries = function() {
  return /** @type{?proto.analyzer.DrawdownSeriesChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.DrawdownSeriesChart, 4));
};


/**
 * @param {?proto.analyzer.DrawdownSeriesChart|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setDrawdownSeries = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearDrawdownSeries = function() {
  return this.setDrawdownSeries(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasDrawdownSeries = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional RollingWinRateChart rolling_win_rate = 5;
 * @return {?proto.analyzer.RollingWinRateChart}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getRollingWinRate = function() {
  return /** @type{?proto.analyzer.RollingWinRateChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.RollingWinRateChart, 5));
};


/**
 * @param {?proto.analyzer.RollingWinRateChart|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setRollingWinRate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearRollingWinRate = function() {
  return this.setRollingWinRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasRollingWinRate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional RollingProfitFactorChart rolling_profit_factor = 6;
 * @return {?proto.analyzer.RollingProfitFactorChart}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getRollingProfitFactor = function() {
  return /** @type{?proto.analyzer.RollingProfitFactorChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.RollingProfitFactorChart, 6));
};


/**
 * @param {?proto.analyzer.RollingProfitFactorChart|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setRollingProfitFactor = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearRollingProfitFactor = function() {
  return this.setRollingProfitFactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasRollingProfitFactor = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional RollingDrawdownChart rolling_drawdown = 7;
 * @return {?proto.analyzer.RollingDrawdownChart}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getRollingDrawdown = function() {
  return /** @type{?proto.analyzer.RollingDrawdownChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.RollingDrawdownChart, 7));
};


/**
 * @param {?proto.analyzer.RollingDrawdownChart|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setRollingDrawdown = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearRollingDrawdown = function() {
  return this.setRollingDrawdown(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasRollingDrawdown = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional RiskPerTradeVsOutcomeChart risk_per_trade = 8;
 * @return {?proto.analyzer.RiskPerTradeVsOutcomeChart}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getRiskPerTrade = function() {
  return /** @type{?proto.analyzer.RiskPerTradeVsOutcomeChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.RiskPerTradeVsOutcomeChart, 8));
};


/**
 * @param {?proto.analyzer.RiskPerTradeVsOutcomeChart|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setRiskPerTrade = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearRiskPerTrade = function() {
  return this.setRiskPerTrade(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasRiskPerTrade = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional LosingStreaksRecoveryCard losing_streaks = 9;
 * @return {?proto.analyzer.LosingStreaksRecoveryCard}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getLosingStreaks = function() {
  return /** @type{?proto.analyzer.LosingStreaksRecoveryCard} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.LosingStreaksRecoveryCard, 9));
};


/**
 * @param {?proto.analyzer.LosingStreaksRecoveryCard|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setLosingStreaks = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearLosingStreaks = function() {
  return this.setLosingStreaks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasLosingStreaks = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional PropRuleUsageCard prop_rule_usage = 10;
 * @return {?proto.analyzer.PropRuleUsageCard}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getPropRuleUsage = function() {
  return /** @type{?proto.analyzer.PropRuleUsageCard} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.PropRuleUsageCard, 10));
};


/**
 * @param {?proto.analyzer.PropRuleUsageCard|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setPropRuleUsage = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearPropRuleUsage = function() {
  return this.setPropRuleUsage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasPropRuleUsage = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional InstrumentROITable instrument_roi_table = 11;
 * @return {?proto.analyzer.InstrumentROITable}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getInstrumentRoiTable = function() {
  return /** @type{?proto.analyzer.InstrumentROITable} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.InstrumentROITable, 11));
};


/**
 * @param {?proto.analyzer.InstrumentROITable|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setInstrumentRoiTable = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearInstrumentRoiTable = function() {
  return this.setInstrumentRoiTable(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasInstrumentRoiTable = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional DayOfWeekROIChart day_of_week_roi = 12;
 * @return {?proto.analyzer.DayOfWeekROIChart}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getDayOfWeekRoi = function() {
  return /** @type{?proto.analyzer.DayOfWeekROIChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.DayOfWeekROIChart, 12));
};


/**
 * @param {?proto.analyzer.DayOfWeekROIChart|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setDayOfWeekRoi = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearDayOfWeekRoi = function() {
  return this.setDayOfWeekRoi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasDayOfWeekRoi = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional SessionAnalysisChart session_analysis = 13;
 * @return {?proto.analyzer.SessionAnalysisChart}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getSessionAnalysis = function() {
  return /** @type{?proto.analyzer.SessionAnalysisChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.SessionAnalysisChart, 13));
};


/**
 * @param {?proto.analyzer.SessionAnalysisChart|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setSessionAnalysis = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearSessionAnalysis = function() {
  return this.setSessionAnalysis(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasSessionAnalysis = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional HoldingTimeVsReturnChart holding_time_vs_return = 14;
 * @return {?proto.analyzer.HoldingTimeVsReturnChart}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getHoldingTimeVsReturn = function() {
  return /** @type{?proto.analyzer.HoldingTimeVsReturnChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.HoldingTimeVsReturnChart, 14));
};


/**
 * @param {?proto.analyzer.HoldingTimeVsReturnChart|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setHoldingTimeVsReturn = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearHoldingTimeVsReturn = function() {
  return this.setHoldingTimeVsReturn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasHoldingTimeVsReturn = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional TimeOfDayROIHeatmap time_of_day_roi = 15;
 * @return {?proto.analyzer.TimeOfDayROIHeatmap}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getTimeOfDayRoi = function() {
  return /** @type{?proto.analyzer.TimeOfDayROIHeatmap} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.TimeOfDayROIHeatmap, 15));
};


/**
 * @param {?proto.analyzer.TimeOfDayROIHeatmap|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setTimeOfDayRoi = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearTimeOfDayRoi = function() {
  return this.setTimeOfDayRoi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasTimeOfDayRoi = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional TagPerformanceTable tag_performance = 16;
 * @return {?proto.analyzer.TagPerformanceTable}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getTagPerformance = function() {
  return /** @type{?proto.analyzer.TagPerformanceTable} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.TagPerformanceTable, 16));
};


/**
 * @param {?proto.analyzer.TagPerformanceTable|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setTagPerformance = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearTagPerformance = function() {
  return this.setTagPerformance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasTagPerformance = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional EntryExitTypesChart entry_exit_types = 17;
 * @return {?proto.analyzer.EntryExitTypesChart}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getEntryExitTypes = function() {
  return /** @type{?proto.analyzer.EntryExitTypesChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.EntryExitTypesChart, 17));
};


/**
 * @param {?proto.analyzer.EntryExitTypesChart|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setEntryExitTypes = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearEntryExitTypes = function() {
  return this.setEntryExitTypes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasEntryExitTypes = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional TimeInTradeBandsChart time_in_trade_bands = 18;
 * @return {?proto.analyzer.TimeInTradeBandsChart}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getTimeInTradeBands = function() {
  return /** @type{?proto.analyzer.TimeInTradeBandsChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.TimeInTradeBandsChart, 18));
};


/**
 * @param {?proto.analyzer.TimeInTradeBandsChart|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setTimeInTradeBands = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearTimeInTradeBands = function() {
  return this.setTimeInTradeBands(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasTimeInTradeBands = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional NewsProximityEffectChart news_proximity_effect = 19;
 * @return {?proto.analyzer.NewsProximityEffectChart}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getNewsProximityEffect = function() {
  return /** @type{?proto.analyzer.NewsProximityEffectChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.NewsProximityEffectChart, 19));
};


/**
 * @param {?proto.analyzer.NewsProximityEffectChart|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setNewsProximityEffect = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearNewsProximityEffect = function() {
  return this.setNewsProximityEffect(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasNewsProximityEffect = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional ScaledInTradesCard scaled_in_trades = 20;
 * @return {?proto.analyzer.ScaledInTradesCard}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getScaledInTrades = function() {
  return /** @type{?proto.analyzer.ScaledInTradesCard} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.ScaledInTradesCard, 20));
};


/**
 * @param {?proto.analyzer.ScaledInTradesCard|undefined} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setScaledInTrades = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearScaledInTrades = function() {
  return this.setScaledInTrades(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.hasScaledInTrades = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * repeated AIInsight insights = 21;
 * @return {!Array<!proto.analyzer.AIInsight>}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getInsightsList = function() {
  return /** @type{!Array<!proto.analyzer.AIInsight>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.AIInsight, 21));
};


/**
 * @param {!Array<!proto.analyzer.AIInsight>} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
*/
proto.analyzer.GetAccountPerformanceResponse.prototype.setInsightsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 21, value);
};


/**
 * @param {!proto.analyzer.AIInsight=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.AIInsight}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.addInsights = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.analyzer.AIInsight, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.clearInsightsList = function() {
  return this.setInsightsList([]);
};


/**
 * optional string last_synced = 22;
 * @return {string}
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.getLastSynced = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetAccountPerformanceResponse} returns this
 */
proto.analyzer.GetAccountPerformanceResponse.prototype.setLastSynced = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.PerformanceMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.PerformanceMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.PerformanceMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PerformanceMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
roi: (f = msg.getRoi()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
pnl: (f = msg.getPnl()) && common_common_pb.Money.toObject(includeInstance, f),
winRate: (f = msg.getWinRate()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
profitFactor: (f = msg.getProfitFactor()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
expectancy: (f = msg.getExpectancy()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
maxDrawdown: (f = msg.getMaxDrawdown()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
sharpe: (f = msg.getSharpe()) && proto.analyzer.MetricValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.PerformanceMetrics}
 */
proto.analyzer.PerformanceMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.PerformanceMetrics;
  return proto.analyzer.PerformanceMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.PerformanceMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.PerformanceMetrics}
 */
proto.analyzer.PerformanceMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setRoi(value);
      break;
    case 2:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setPnl(value);
      break;
    case 3:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setWinRate(value);
      break;
    case 4:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setProfitFactor(value);
      break;
    case 5:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setExpectancy(value);
      break;
    case 6:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setMaxDrawdown(value);
      break;
    case 7:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setSharpe(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.PerformanceMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.PerformanceMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.PerformanceMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PerformanceMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoi();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getPnl();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getWinRate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitFactor();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getExpectancy();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxDrawdown();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getSharpe();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional MetricValue roi = 1;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.PerformanceMetrics.prototype.getRoi = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 1));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.PerformanceMetrics} returns this
*/
proto.analyzer.PerformanceMetrics.prototype.setRoi = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceMetrics} returns this
 */
proto.analyzer.PerformanceMetrics.prototype.clearRoi = function() {
  return this.setRoi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceMetrics.prototype.hasRoi = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.v1.Money pnl = 2;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.PerformanceMetrics.prototype.getPnl = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 2));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.PerformanceMetrics} returns this
*/
proto.analyzer.PerformanceMetrics.prototype.setPnl = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceMetrics} returns this
 */
proto.analyzer.PerformanceMetrics.prototype.clearPnl = function() {
  return this.setPnl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceMetrics.prototype.hasPnl = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional MetricValue win_rate = 3;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.PerformanceMetrics.prototype.getWinRate = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 3));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.PerformanceMetrics} returns this
*/
proto.analyzer.PerformanceMetrics.prototype.setWinRate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceMetrics} returns this
 */
proto.analyzer.PerformanceMetrics.prototype.clearWinRate = function() {
  return this.setWinRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceMetrics.prototype.hasWinRate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional MetricValue profit_factor = 4;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.PerformanceMetrics.prototype.getProfitFactor = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 4));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.PerformanceMetrics} returns this
*/
proto.analyzer.PerformanceMetrics.prototype.setProfitFactor = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceMetrics} returns this
 */
proto.analyzer.PerformanceMetrics.prototype.clearProfitFactor = function() {
  return this.setProfitFactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceMetrics.prototype.hasProfitFactor = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional MetricValue expectancy = 5;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.PerformanceMetrics.prototype.getExpectancy = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 5));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.PerformanceMetrics} returns this
*/
proto.analyzer.PerformanceMetrics.prototype.setExpectancy = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceMetrics} returns this
 */
proto.analyzer.PerformanceMetrics.prototype.clearExpectancy = function() {
  return this.setExpectancy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceMetrics.prototype.hasExpectancy = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional MetricValue max_drawdown = 6;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.PerformanceMetrics.prototype.getMaxDrawdown = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 6));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.PerformanceMetrics} returns this
*/
proto.analyzer.PerformanceMetrics.prototype.setMaxDrawdown = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceMetrics} returns this
 */
proto.analyzer.PerformanceMetrics.prototype.clearMaxDrawdown = function() {
  return this.setMaxDrawdown(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceMetrics.prototype.hasMaxDrawdown = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional MetricValue sharpe = 7;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.PerformanceMetrics.prototype.getSharpe = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 7));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.PerformanceMetrics} returns this
*/
proto.analyzer.PerformanceMetrics.prototype.setSharpe = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PerformanceMetrics} returns this
 */
proto.analyzer.PerformanceMetrics.prototype.clearSharpe = function() {
  return this.setSharpe(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PerformanceMetrics.prototype.hasSharpe = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ExpectancyMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ExpectancyMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ExpectancyMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ExpectancyMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
expectancyR: (f = msg.getExpectancyR()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
expectancyMoney: (f = msg.getExpectancyMoney()) && common_common_pb.Money.toObject(includeInstance, f),
expectancyPct: (f = msg.getExpectancyPct()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
currentExpectancyR: (f = msg.getCurrentExpectancyR()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
targetExpectancyR: (f = msg.getTargetExpectancyR()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
progress: (f = msg.getProgress()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
rating: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ExpectancyMetrics}
 */
proto.analyzer.ExpectancyMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ExpectancyMetrics;
  return proto.analyzer.ExpectancyMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ExpectancyMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ExpectancyMetrics}
 */
proto.analyzer.ExpectancyMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setExpectancyR(value);
      break;
    case 2:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setExpectancyMoney(value);
      break;
    case 3:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setExpectancyPct(value);
      break;
    case 4:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setCurrentExpectancyR(value);
      break;
    case 5:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setTargetExpectancyR(value);
      break;
    case 6:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setProgress(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRating(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ExpectancyMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ExpectancyMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ExpectancyMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ExpectancyMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExpectancyR();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getExpectancyMoney();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getExpectancyPct();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getCurrentExpectancyR();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getTargetExpectancyR();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getProgress();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getRating();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional MetricValue expectancy_r = 1;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.ExpectancyMetrics.prototype.getExpectancyR = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 1));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.ExpectancyMetrics} returns this
*/
proto.analyzer.ExpectancyMetrics.prototype.setExpectancyR = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.ExpectancyMetrics} returns this
 */
proto.analyzer.ExpectancyMetrics.prototype.clearExpectancyR = function() {
  return this.setExpectancyR(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.ExpectancyMetrics.prototype.hasExpectancyR = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.v1.Money expectancy_money = 2;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.ExpectancyMetrics.prototype.getExpectancyMoney = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 2));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.ExpectancyMetrics} returns this
*/
proto.analyzer.ExpectancyMetrics.prototype.setExpectancyMoney = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.ExpectancyMetrics} returns this
 */
proto.analyzer.ExpectancyMetrics.prototype.clearExpectancyMoney = function() {
  return this.setExpectancyMoney(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.ExpectancyMetrics.prototype.hasExpectancyMoney = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional MetricValue expectancy_pct = 3;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.ExpectancyMetrics.prototype.getExpectancyPct = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 3));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.ExpectancyMetrics} returns this
*/
proto.analyzer.ExpectancyMetrics.prototype.setExpectancyPct = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.ExpectancyMetrics} returns this
 */
proto.analyzer.ExpectancyMetrics.prototype.clearExpectancyPct = function() {
  return this.setExpectancyPct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.ExpectancyMetrics.prototype.hasExpectancyPct = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional MetricValue current_expectancy_r = 4;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.ExpectancyMetrics.prototype.getCurrentExpectancyR = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 4));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.ExpectancyMetrics} returns this
*/
proto.analyzer.ExpectancyMetrics.prototype.setCurrentExpectancyR = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.ExpectancyMetrics} returns this
 */
proto.analyzer.ExpectancyMetrics.prototype.clearCurrentExpectancyR = function() {
  return this.setCurrentExpectancyR(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.ExpectancyMetrics.prototype.hasCurrentExpectancyR = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional MetricValue target_expectancy_r = 5;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.ExpectancyMetrics.prototype.getTargetExpectancyR = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 5));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.ExpectancyMetrics} returns this
*/
proto.analyzer.ExpectancyMetrics.prototype.setTargetExpectancyR = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.ExpectancyMetrics} returns this
 */
proto.analyzer.ExpectancyMetrics.prototype.clearTargetExpectancyR = function() {
  return this.setTargetExpectancyR(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.ExpectancyMetrics.prototype.hasTargetExpectancyR = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional MetricValue progress = 6;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.ExpectancyMetrics.prototype.getProgress = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 6));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.ExpectancyMetrics} returns this
*/
proto.analyzer.ExpectancyMetrics.prototype.setProgress = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.ExpectancyMetrics} returns this
 */
proto.analyzer.ExpectancyMetrics.prototype.clearProgress = function() {
  return this.setProgress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.ExpectancyMetrics.prototype.hasProgress = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string rating = 7;
 * @return {string}
 */
proto.analyzer.ExpectancyMetrics.prototype.getRating = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.ExpectancyMetrics} returns this
 */
proto.analyzer.ExpectancyMetrics.prototype.setRating = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.EquityCurveChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.EquityCurveChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.EquityCurveChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.EquityCurveChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.EquityCurveChart.toObject = function(includeInstance, msg) {
  var f, obj = {
pointsList: jspb.Message.toObjectList(msg.getPointsList(),
    proto.analyzer.EquityPoint.toObject, includeInstance),
minValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
maxValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.EquityCurveChart}
 */
proto.analyzer.EquityCurveChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.EquityCurveChart;
  return proto.analyzer.EquityCurveChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.EquityCurveChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.EquityCurveChart}
 */
proto.analyzer.EquityCurveChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.EquityPoint;
      reader.readMessage(value,proto.analyzer.EquityPoint.deserializeBinaryFromReader);
      msg.addPoints(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinValue(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.EquityCurveChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.EquityCurveChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.EquityCurveChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.EquityCurveChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.EquityPoint.serializeBinaryToWriter
    );
  }
  f = message.getMinValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getMaxValue();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * repeated EquityPoint points = 1;
 * @return {!Array<!proto.analyzer.EquityPoint>}
 */
proto.analyzer.EquityCurveChart.prototype.getPointsList = function() {
  return /** @type{!Array<!proto.analyzer.EquityPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.EquityPoint, 1));
};


/**
 * @param {!Array<!proto.analyzer.EquityPoint>} value
 * @return {!proto.analyzer.EquityCurveChart} returns this
*/
proto.analyzer.EquityCurveChart.prototype.setPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.EquityPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.EquityPoint}
 */
proto.analyzer.EquityCurveChart.prototype.addPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.EquityPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.EquityCurveChart} returns this
 */
proto.analyzer.EquityCurveChart.prototype.clearPointsList = function() {
  return this.setPointsList([]);
};


/**
 * optional double min_value = 2;
 * @return {number}
 */
proto.analyzer.EquityCurveChart.prototype.getMinValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.EquityCurveChart} returns this
 */
proto.analyzer.EquityCurveChart.prototype.setMinValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double max_value = 3;
 * @return {number}
 */
proto.analyzer.EquityCurveChart.prototype.getMaxValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.EquityCurveChart} returns this
 */
proto.analyzer.EquityCurveChart.prototype.setMaxValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.EquityPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.EquityPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.EquityPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.EquityPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
equity: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
trades: jspb.Message.getFieldWithDefault(msg, 3, 0),
timestamp: (f = msg.getTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.EquityPoint}
 */
proto.analyzer.EquityPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.EquityPoint;
  return proto.analyzer.EquityPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.EquityPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.EquityPoint}
 */
proto.analyzer.EquityPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEquity(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrades(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.EquityPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.EquityPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.EquityPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.EquityPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEquity();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getTrades();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.analyzer.EquityPoint.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.EquityPoint} returns this
 */
proto.analyzer.EquityPoint.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double equity = 2;
 * @return {number}
 */
proto.analyzer.EquityPoint.prototype.getEquity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.EquityPoint} returns this
 */
proto.analyzer.EquityPoint.prototype.setEquity = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 trades = 3;
 * @return {number}
 */
proto.analyzer.EquityPoint.prototype.getTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.EquityPoint} returns this
 */
proto.analyzer.EquityPoint.prototype.setTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp timestamp = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.analyzer.EquityPoint.prototype.getTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.analyzer.EquityPoint} returns this
*/
proto.analyzer.EquityPoint.prototype.setTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.EquityPoint} returns this
 */
proto.analyzer.EquityPoint.prototype.clearTimestamp = function() {
  return this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.EquityPoint.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.ReturnDistributionChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ReturnDistributionChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ReturnDistributionChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ReturnDistributionChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ReturnDistributionChart.toObject = function(includeInstance, msg) {
  var f, obj = {
bucketsList: jspb.Message.toObjectList(msg.getBucketsList(),
    proto.analyzer.ReturnBucket.toObject, includeInstance),
maxTrades: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ReturnDistributionChart}
 */
proto.analyzer.ReturnDistributionChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ReturnDistributionChart;
  return proto.analyzer.ReturnDistributionChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ReturnDistributionChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ReturnDistributionChart}
 */
proto.analyzer.ReturnDistributionChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.ReturnBucket;
      reader.readMessage(value,proto.analyzer.ReturnBucket.deserializeBinaryFromReader);
      msg.addBuckets(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxTrades(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ReturnDistributionChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ReturnDistributionChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ReturnDistributionChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ReturnDistributionChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBucketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.ReturnBucket.serializeBinaryToWriter
    );
  }
  f = message.getMaxTrades();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated ReturnBucket buckets = 1;
 * @return {!Array<!proto.analyzer.ReturnBucket>}
 */
proto.analyzer.ReturnDistributionChart.prototype.getBucketsList = function() {
  return /** @type{!Array<!proto.analyzer.ReturnBucket>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.ReturnBucket, 1));
};


/**
 * @param {!Array<!proto.analyzer.ReturnBucket>} value
 * @return {!proto.analyzer.ReturnDistributionChart} returns this
*/
proto.analyzer.ReturnDistributionChart.prototype.setBucketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.ReturnBucket=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.ReturnBucket}
 */
proto.analyzer.ReturnDistributionChart.prototype.addBuckets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.ReturnBucket, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.ReturnDistributionChart} returns this
 */
proto.analyzer.ReturnDistributionChart.prototype.clearBucketsList = function() {
  return this.setBucketsList([]);
};


/**
 * optional int32 max_trades = 2;
 * @return {number}
 */
proto.analyzer.ReturnDistributionChart.prototype.getMaxTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ReturnDistributionChart} returns this
 */
proto.analyzer.ReturnDistributionChart.prototype.setMaxTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.ReturnBucket.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ReturnBucket.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ReturnBucket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ReturnBucket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ReturnBucket.toObject = function(includeInstance, msg) {
  var f, obj = {
label: jspb.Message.getFieldWithDefault(msg, 1, ""),
bucketValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
tradeCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
rrr: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
topSymbolsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ReturnBucket}
 */
proto.analyzer.ReturnBucket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ReturnBucket;
  return proto.analyzer.ReturnBucket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ReturnBucket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ReturnBucket}
 */
proto.analyzer.ReturnBucket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBucketValue(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTradeCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRrr(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addTopSymbols(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ReturnBucket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ReturnBucket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ReturnBucket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ReturnBucket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBucketValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getTradeCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRrr();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getTopSymbolsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.analyzer.ReturnBucket.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.ReturnBucket} returns this
 */
proto.analyzer.ReturnBucket.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double bucket_value = 2;
 * @return {number}
 */
proto.analyzer.ReturnBucket.prototype.getBucketValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ReturnBucket} returns this
 */
proto.analyzer.ReturnBucket.prototype.setBucketValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 trade_count = 3;
 * @return {number}
 */
proto.analyzer.ReturnBucket.prototype.getTradeCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ReturnBucket} returns this
 */
proto.analyzer.ReturnBucket.prototype.setTradeCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double rrr = 4;
 * @return {number}
 */
proto.analyzer.ReturnBucket.prototype.getRrr = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ReturnBucket} returns this
 */
proto.analyzer.ReturnBucket.prototype.setRrr = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * repeated string top_symbols = 5;
 * @return {!Array<string>}
 */
proto.analyzer.ReturnBucket.prototype.getTopSymbolsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.analyzer.ReturnBucket} returns this
 */
proto.analyzer.ReturnBucket.prototype.setTopSymbolsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.analyzer.ReturnBucket} returns this
 */
proto.analyzer.ReturnBucket.prototype.addTopSymbols = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.ReturnBucket} returns this
 */
proto.analyzer.ReturnBucket.prototype.clearTopSymbolsList = function() {
  return this.setTopSymbolsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.DrawdownSeriesChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.DrawdownSeriesChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.DrawdownSeriesChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.DrawdownSeriesChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DrawdownSeriesChart.toObject = function(includeInstance, msg) {
  var f, obj = {
pointsList: jspb.Message.toObjectList(msg.getPointsList(),
    proto.analyzer.DrawdownPoint.toObject, includeInstance),
minDrawdown: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.DrawdownSeriesChart}
 */
proto.analyzer.DrawdownSeriesChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.DrawdownSeriesChart;
  return proto.analyzer.DrawdownSeriesChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.DrawdownSeriesChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.DrawdownSeriesChart}
 */
proto.analyzer.DrawdownSeriesChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.DrawdownPoint;
      reader.readMessage(value,proto.analyzer.DrawdownPoint.deserializeBinaryFromReader);
      msg.addPoints(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinDrawdown(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.DrawdownSeriesChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.DrawdownSeriesChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.DrawdownSeriesChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DrawdownSeriesChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.DrawdownPoint.serializeBinaryToWriter
    );
  }
  f = message.getMinDrawdown();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * repeated DrawdownPoint points = 1;
 * @return {!Array<!proto.analyzer.DrawdownPoint>}
 */
proto.analyzer.DrawdownSeriesChart.prototype.getPointsList = function() {
  return /** @type{!Array<!proto.analyzer.DrawdownPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.DrawdownPoint, 1));
};


/**
 * @param {!Array<!proto.analyzer.DrawdownPoint>} value
 * @return {!proto.analyzer.DrawdownSeriesChart} returns this
*/
proto.analyzer.DrawdownSeriesChart.prototype.setPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.DrawdownPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.DrawdownPoint}
 */
proto.analyzer.DrawdownSeriesChart.prototype.addPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.DrawdownPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.DrawdownSeriesChart} returns this
 */
proto.analyzer.DrawdownSeriesChart.prototype.clearPointsList = function() {
  return this.setPointsList([]);
};


/**
 * optional double min_drawdown = 2;
 * @return {number}
 */
proto.analyzer.DrawdownSeriesChart.prototype.getMinDrawdown = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.DrawdownSeriesChart} returns this
 */
proto.analyzer.DrawdownSeriesChart.prototype.setMinDrawdown = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.DrawdownPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.DrawdownPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.DrawdownPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DrawdownPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
drawdownPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
timestamp: (f = msg.getTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.DrawdownPoint}
 */
proto.analyzer.DrawdownPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.DrawdownPoint;
  return proto.analyzer.DrawdownPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.DrawdownPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.DrawdownPoint}
 */
proto.analyzer.DrawdownPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDrawdownPct(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.DrawdownPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.DrawdownPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.DrawdownPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DrawdownPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDrawdownPct();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.analyzer.DrawdownPoint.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.DrawdownPoint} returns this
 */
proto.analyzer.DrawdownPoint.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double drawdown_pct = 2;
 * @return {number}
 */
proto.analyzer.DrawdownPoint.prototype.getDrawdownPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.DrawdownPoint} returns this
 */
proto.analyzer.DrawdownPoint.prototype.setDrawdownPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp timestamp = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.analyzer.DrawdownPoint.prototype.getTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.analyzer.DrawdownPoint} returns this
*/
proto.analyzer.DrawdownPoint.prototype.setTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.DrawdownPoint} returns this
 */
proto.analyzer.DrawdownPoint.prototype.clearTimestamp = function() {
  return this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.DrawdownPoint.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.InstrumentROITable.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.InstrumentROITable.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.InstrumentROITable.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.InstrumentROITable} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.InstrumentROITable.toObject = function(includeInstance, msg) {
  var f, obj = {
rowsList: jspb.Message.toObjectList(msg.getRowsList(),
    proto.analyzer.InstrumentROIRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.InstrumentROITable}
 */
proto.analyzer.InstrumentROITable.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.InstrumentROITable;
  return proto.analyzer.InstrumentROITable.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.InstrumentROITable} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.InstrumentROITable}
 */
proto.analyzer.InstrumentROITable.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.InstrumentROIRow;
      reader.readMessage(value,proto.analyzer.InstrumentROIRow.deserializeBinaryFromReader);
      msg.addRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.InstrumentROITable.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.InstrumentROITable.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.InstrumentROITable} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.InstrumentROITable.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.InstrumentROIRow.serializeBinaryToWriter
    );
  }
};


/**
 * repeated InstrumentROIRow rows = 1;
 * @return {!Array<!proto.analyzer.InstrumentROIRow>}
 */
proto.analyzer.InstrumentROITable.prototype.getRowsList = function() {
  return /** @type{!Array<!proto.analyzer.InstrumentROIRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.InstrumentROIRow, 1));
};


/**
 * @param {!Array<!proto.analyzer.InstrumentROIRow>} value
 * @return {!proto.analyzer.InstrumentROITable} returns this
*/
proto.analyzer.InstrumentROITable.prototype.setRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.InstrumentROIRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.InstrumentROIRow}
 */
proto.analyzer.InstrumentROITable.prototype.addRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.InstrumentROIRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.InstrumentROITable} returns this
 */
proto.analyzer.InstrumentROITable.prototype.clearRowsList = function() {
  return this.setRowsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.InstrumentROIRow.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.InstrumentROIRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.InstrumentROIRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.InstrumentROIRow.toObject = function(includeInstance, msg) {
  var f, obj = {
symbol: jspb.Message.getFieldWithDefault(msg, 1, ""),
roiPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
pnl: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
trades: jspb.Message.getFieldWithDefault(msg, 4, 0),
winPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
profitFactor: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
avgHold: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.InstrumentROIRow}
 */
proto.analyzer.InstrumentROIRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.InstrumentROIRow;
  return proto.analyzer.InstrumentROIRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.InstrumentROIRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.InstrumentROIRow}
 */
proto.analyzer.InstrumentROIRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRoiPct(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPnl(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrades(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWinPct(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfitFactor(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvgHold(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.InstrumentROIRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.InstrumentROIRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.InstrumentROIRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.InstrumentROIRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoiPct();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getPnl();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getTrades();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getWinPct();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getProfitFactor();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getAvgHold();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string symbol = 1;
 * @return {string}
 */
proto.analyzer.InstrumentROIRow.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.InstrumentROIRow} returns this
 */
proto.analyzer.InstrumentROIRow.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double roi_pct = 2;
 * @return {number}
 */
proto.analyzer.InstrumentROIRow.prototype.getRoiPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.InstrumentROIRow} returns this
 */
proto.analyzer.InstrumentROIRow.prototype.setRoiPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double pnl = 3;
 * @return {number}
 */
proto.analyzer.InstrumentROIRow.prototype.getPnl = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.InstrumentROIRow} returns this
 */
proto.analyzer.InstrumentROIRow.prototype.setPnl = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional int32 trades = 4;
 * @return {number}
 */
proto.analyzer.InstrumentROIRow.prototype.getTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.InstrumentROIRow} returns this
 */
proto.analyzer.InstrumentROIRow.prototype.setTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double win_pct = 5;
 * @return {number}
 */
proto.analyzer.InstrumentROIRow.prototype.getWinPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.InstrumentROIRow} returns this
 */
proto.analyzer.InstrumentROIRow.prototype.setWinPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double profit_factor = 6;
 * @return {number}
 */
proto.analyzer.InstrumentROIRow.prototype.getProfitFactor = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.InstrumentROIRow} returns this
 */
proto.analyzer.InstrumentROIRow.prototype.setProfitFactor = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional string avg_hold = 7;
 * @return {string}
 */
proto.analyzer.InstrumentROIRow.prototype.getAvgHold = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.InstrumentROIRow} returns this
 */
proto.analyzer.InstrumentROIRow.prototype.setAvgHold = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.DayOfWeekROIChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.DayOfWeekROIChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.DayOfWeekROIChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.DayOfWeekROIChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DayOfWeekROIChart.toObject = function(includeInstance, msg) {
  var f, obj = {
pointsList: jspb.Message.toObjectList(msg.getPointsList(),
    proto.analyzer.DayOfWeekROIPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.DayOfWeekROIChart}
 */
proto.analyzer.DayOfWeekROIChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.DayOfWeekROIChart;
  return proto.analyzer.DayOfWeekROIChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.DayOfWeekROIChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.DayOfWeekROIChart}
 */
proto.analyzer.DayOfWeekROIChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.DayOfWeekROIPoint;
      reader.readMessage(value,proto.analyzer.DayOfWeekROIPoint.deserializeBinaryFromReader);
      msg.addPoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.DayOfWeekROIChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.DayOfWeekROIChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.DayOfWeekROIChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DayOfWeekROIChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.DayOfWeekROIPoint.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DayOfWeekROIPoint points = 1;
 * @return {!Array<!proto.analyzer.DayOfWeekROIPoint>}
 */
proto.analyzer.DayOfWeekROIChart.prototype.getPointsList = function() {
  return /** @type{!Array<!proto.analyzer.DayOfWeekROIPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.DayOfWeekROIPoint, 1));
};


/**
 * @param {!Array<!proto.analyzer.DayOfWeekROIPoint>} value
 * @return {!proto.analyzer.DayOfWeekROIChart} returns this
*/
proto.analyzer.DayOfWeekROIChart.prototype.setPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.DayOfWeekROIPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.DayOfWeekROIPoint}
 */
proto.analyzer.DayOfWeekROIChart.prototype.addPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.DayOfWeekROIPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.DayOfWeekROIChart} returns this
 */
proto.analyzer.DayOfWeekROIChart.prototype.clearPointsList = function() {
  return this.setPointsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.DayOfWeekROIPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.DayOfWeekROIPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.DayOfWeekROIPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DayOfWeekROIPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
day: jspb.Message.getFieldWithDefault(msg, 1, ""),
roiPct: (f = msg.getRoiPct()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
trades: jspb.Message.getFieldWithDefault(msg, 3, 0),
pnl: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
winRate: (f = msg.getWinRate()) && proto.analyzer.MetricValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.DayOfWeekROIPoint}
 */
proto.analyzer.DayOfWeekROIPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.DayOfWeekROIPoint;
  return proto.analyzer.DayOfWeekROIPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.DayOfWeekROIPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.DayOfWeekROIPoint}
 */
proto.analyzer.DayOfWeekROIPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDay(value);
      break;
    case 2:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setRoiPct(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrades(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPnl(value);
      break;
    case 5:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setWinRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.DayOfWeekROIPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.DayOfWeekROIPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.DayOfWeekROIPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DayOfWeekROIPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDay();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoiPct();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getTrades();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPnl();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getWinRate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string day = 1;
 * @return {string}
 */
proto.analyzer.DayOfWeekROIPoint.prototype.getDay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.DayOfWeekROIPoint} returns this
 */
proto.analyzer.DayOfWeekROIPoint.prototype.setDay = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional MetricValue roi_pct = 2;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.DayOfWeekROIPoint.prototype.getRoiPct = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 2));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.DayOfWeekROIPoint} returns this
*/
proto.analyzer.DayOfWeekROIPoint.prototype.setRoiPct = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.DayOfWeekROIPoint} returns this
 */
proto.analyzer.DayOfWeekROIPoint.prototype.clearRoiPct = function() {
  return this.setRoiPct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.DayOfWeekROIPoint.prototype.hasRoiPct = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 trades = 3;
 * @return {number}
 */
proto.analyzer.DayOfWeekROIPoint.prototype.getTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.DayOfWeekROIPoint} returns this
 */
proto.analyzer.DayOfWeekROIPoint.prototype.setTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double pnl = 4;
 * @return {number}
 */
proto.analyzer.DayOfWeekROIPoint.prototype.getPnl = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.DayOfWeekROIPoint} returns this
 */
proto.analyzer.DayOfWeekROIPoint.prototype.setPnl = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional MetricValue win_rate = 5;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.DayOfWeekROIPoint.prototype.getWinRate = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 5));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.DayOfWeekROIPoint} returns this
*/
proto.analyzer.DayOfWeekROIPoint.prototype.setWinRate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.DayOfWeekROIPoint} returns this
 */
proto.analyzer.DayOfWeekROIPoint.prototype.clearWinRate = function() {
  return this.setWinRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.DayOfWeekROIPoint.prototype.hasWinRate = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.SessionAnalysisChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.SessionAnalysisChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.SessionAnalysisChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.SessionAnalysisChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.SessionAnalysisChart.toObject = function(includeInstance, msg) {
  var f, obj = {
barsList: jspb.Message.toObjectList(msg.getBarsList(),
    proto.analyzer.SessionROIBar.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.SessionAnalysisChart}
 */
proto.analyzer.SessionAnalysisChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.SessionAnalysisChart;
  return proto.analyzer.SessionAnalysisChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.SessionAnalysisChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.SessionAnalysisChart}
 */
proto.analyzer.SessionAnalysisChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.SessionROIBar;
      reader.readMessage(value,proto.analyzer.SessionROIBar.deserializeBinaryFromReader);
      msg.addBars(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.SessionAnalysisChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.SessionAnalysisChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.SessionAnalysisChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.SessionAnalysisChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBarsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.SessionROIBar.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SessionROIBar bars = 1;
 * @return {!Array<!proto.analyzer.SessionROIBar>}
 */
proto.analyzer.SessionAnalysisChart.prototype.getBarsList = function() {
  return /** @type{!Array<!proto.analyzer.SessionROIBar>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.SessionROIBar, 1));
};


/**
 * @param {!Array<!proto.analyzer.SessionROIBar>} value
 * @return {!proto.analyzer.SessionAnalysisChart} returns this
*/
proto.analyzer.SessionAnalysisChart.prototype.setBarsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.SessionROIBar=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.SessionROIBar}
 */
proto.analyzer.SessionAnalysisChart.prototype.addBars = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.SessionROIBar, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.SessionAnalysisChart} returns this
 */
proto.analyzer.SessionAnalysisChart.prototype.clearBarsList = function() {
  return this.setBarsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.SessionROIBar.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.SessionROIBar.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.SessionROIBar} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.SessionROIBar.toObject = function(includeInstance, msg) {
  var f, obj = {
session: jspb.Message.getFieldWithDefault(msg, 1, ""),
roiPct: (f = msg.getRoiPct()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
trades: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.SessionROIBar}
 */
proto.analyzer.SessionROIBar.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.SessionROIBar;
  return proto.analyzer.SessionROIBar.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.SessionROIBar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.SessionROIBar}
 */
proto.analyzer.SessionROIBar.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSession(value);
      break;
    case 2:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setRoiPct(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrades(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.SessionROIBar.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.SessionROIBar.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.SessionROIBar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.SessionROIBar.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSession();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoiPct();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getTrades();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string session = 1;
 * @return {string}
 */
proto.analyzer.SessionROIBar.prototype.getSession = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.SessionROIBar} returns this
 */
proto.analyzer.SessionROIBar.prototype.setSession = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional MetricValue roi_pct = 2;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.SessionROIBar.prototype.getRoiPct = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 2));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.SessionROIBar} returns this
*/
proto.analyzer.SessionROIBar.prototype.setRoiPct = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.SessionROIBar} returns this
 */
proto.analyzer.SessionROIBar.prototype.clearRoiPct = function() {
  return this.setRoiPct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.SessionROIBar.prototype.hasRoiPct = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 trades = 3;
 * @return {number}
 */
proto.analyzer.SessionROIBar.prototype.getTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.SessionROIBar} returns this
 */
proto.analyzer.SessionROIBar.prototype.setTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.HoldingTimeVsReturnChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.HoldingTimeVsReturnChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.HoldingTimeVsReturnChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.HoldingTimeVsReturnChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.HoldingTimeVsReturnChart.toObject = function(includeInstance, msg) {
  var f, obj = {
bucketsList: jspb.Message.toObjectList(msg.getBucketsList(),
    proto.analyzer.HoldingTimeBucket.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.HoldingTimeVsReturnChart}
 */
proto.analyzer.HoldingTimeVsReturnChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.HoldingTimeVsReturnChart;
  return proto.analyzer.HoldingTimeVsReturnChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.HoldingTimeVsReturnChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.HoldingTimeVsReturnChart}
 */
proto.analyzer.HoldingTimeVsReturnChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.HoldingTimeBucket;
      reader.readMessage(value,proto.analyzer.HoldingTimeBucket.deserializeBinaryFromReader);
      msg.addBuckets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.HoldingTimeVsReturnChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.HoldingTimeVsReturnChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.HoldingTimeVsReturnChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.HoldingTimeVsReturnChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBucketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.HoldingTimeBucket.serializeBinaryToWriter
    );
  }
};


/**
 * repeated HoldingTimeBucket buckets = 1;
 * @return {!Array<!proto.analyzer.HoldingTimeBucket>}
 */
proto.analyzer.HoldingTimeVsReturnChart.prototype.getBucketsList = function() {
  return /** @type{!Array<!proto.analyzer.HoldingTimeBucket>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.HoldingTimeBucket, 1));
};


/**
 * @param {!Array<!proto.analyzer.HoldingTimeBucket>} value
 * @return {!proto.analyzer.HoldingTimeVsReturnChart} returns this
*/
proto.analyzer.HoldingTimeVsReturnChart.prototype.setBucketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.HoldingTimeBucket=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.HoldingTimeBucket}
 */
proto.analyzer.HoldingTimeVsReturnChart.prototype.addBuckets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.HoldingTimeBucket, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.HoldingTimeVsReturnChart} returns this
 */
proto.analyzer.HoldingTimeVsReturnChart.prototype.clearBucketsList = function() {
  return this.setBucketsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.HoldingTimeBucket.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.HoldingTimeBucket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.HoldingTimeBucket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.HoldingTimeBucket.toObject = function(includeInstance, msg) {
  var f, obj = {
timeRange: jspb.Message.getFieldWithDefault(msg, 1, ""),
roiPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
trades: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.HoldingTimeBucket}
 */
proto.analyzer.HoldingTimeBucket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.HoldingTimeBucket;
  return proto.analyzer.HoldingTimeBucket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.HoldingTimeBucket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.HoldingTimeBucket}
 */
proto.analyzer.HoldingTimeBucket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeRange(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRoiPct(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrades(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.HoldingTimeBucket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.HoldingTimeBucket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.HoldingTimeBucket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.HoldingTimeBucket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRange();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoiPct();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getTrades();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string time_range = 1;
 * @return {string}
 */
proto.analyzer.HoldingTimeBucket.prototype.getTimeRange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.HoldingTimeBucket} returns this
 */
proto.analyzer.HoldingTimeBucket.prototype.setTimeRange = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double roi_pct = 2;
 * @return {number}
 */
proto.analyzer.HoldingTimeBucket.prototype.getRoiPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.HoldingTimeBucket} returns this
 */
proto.analyzer.HoldingTimeBucket.prototype.setRoiPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 trades = 3;
 * @return {number}
 */
proto.analyzer.HoldingTimeBucket.prototype.getTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.HoldingTimeBucket} returns this
 */
proto.analyzer.HoldingTimeBucket.prototype.setTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.TimeOfDayROIHeatmap.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.TimeOfDayROIHeatmap.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.TimeOfDayROIHeatmap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.TimeOfDayROIHeatmap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TimeOfDayROIHeatmap.toObject = function(includeInstance, msg) {
  var f, obj = {
rowsList: jspb.Message.toObjectList(msg.getRowsList(),
    proto.analyzer.TimeOfDayRow.toObject, includeInstance),
minRoi: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
maxRoi: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.TimeOfDayROIHeatmap}
 */
proto.analyzer.TimeOfDayROIHeatmap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.TimeOfDayROIHeatmap;
  return proto.analyzer.TimeOfDayROIHeatmap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.TimeOfDayROIHeatmap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.TimeOfDayROIHeatmap}
 */
proto.analyzer.TimeOfDayROIHeatmap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.TimeOfDayRow;
      reader.readMessage(value,proto.analyzer.TimeOfDayRow.deserializeBinaryFromReader);
      msg.addRows(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinRoi(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxRoi(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.TimeOfDayROIHeatmap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.TimeOfDayROIHeatmap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.TimeOfDayROIHeatmap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TimeOfDayROIHeatmap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.TimeOfDayRow.serializeBinaryToWriter
    );
  }
  f = message.getMinRoi();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getMaxRoi();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * repeated TimeOfDayRow rows = 1;
 * @return {!Array<!proto.analyzer.TimeOfDayRow>}
 */
proto.analyzer.TimeOfDayROIHeatmap.prototype.getRowsList = function() {
  return /** @type{!Array<!proto.analyzer.TimeOfDayRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.TimeOfDayRow, 1));
};


/**
 * @param {!Array<!proto.analyzer.TimeOfDayRow>} value
 * @return {!proto.analyzer.TimeOfDayROIHeatmap} returns this
*/
proto.analyzer.TimeOfDayROIHeatmap.prototype.setRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.TimeOfDayRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.TimeOfDayRow}
 */
proto.analyzer.TimeOfDayROIHeatmap.prototype.addRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.TimeOfDayRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.TimeOfDayROIHeatmap} returns this
 */
proto.analyzer.TimeOfDayROIHeatmap.prototype.clearRowsList = function() {
  return this.setRowsList([]);
};


/**
 * optional double min_roi = 2;
 * @return {number}
 */
proto.analyzer.TimeOfDayROIHeatmap.prototype.getMinRoi = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TimeOfDayROIHeatmap} returns this
 */
proto.analyzer.TimeOfDayROIHeatmap.prototype.setMinRoi = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double max_roi = 3;
 * @return {number}
 */
proto.analyzer.TimeOfDayROIHeatmap.prototype.getMaxRoi = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TimeOfDayROIHeatmap} returns this
 */
proto.analyzer.TimeOfDayROIHeatmap.prototype.setMaxRoi = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.TimeOfDayRow.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.TimeOfDayRow.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.TimeOfDayRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.TimeOfDayRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TimeOfDayRow.toObject = function(includeInstance, msg) {
  var f, obj = {
timeRange: jspb.Message.getFieldWithDefault(msg, 1, ""),
cellsList: jspb.Message.toObjectList(msg.getCellsList(),
    proto.analyzer.TimeOfDayCell.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.TimeOfDayRow}
 */
proto.analyzer.TimeOfDayRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.TimeOfDayRow;
  return proto.analyzer.TimeOfDayRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.TimeOfDayRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.TimeOfDayRow}
 */
proto.analyzer.TimeOfDayRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeRange(value);
      break;
    case 2:
      var value = new proto.analyzer.TimeOfDayCell;
      reader.readMessage(value,proto.analyzer.TimeOfDayCell.deserializeBinaryFromReader);
      msg.addCells(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.TimeOfDayRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.TimeOfDayRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.TimeOfDayRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TimeOfDayRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRange();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCellsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.analyzer.TimeOfDayCell.serializeBinaryToWriter
    );
  }
};


/**
 * optional string time_range = 1;
 * @return {string}
 */
proto.analyzer.TimeOfDayRow.prototype.getTimeRange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.TimeOfDayRow} returns this
 */
proto.analyzer.TimeOfDayRow.prototype.setTimeRange = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated TimeOfDayCell cells = 2;
 * @return {!Array<!proto.analyzer.TimeOfDayCell>}
 */
proto.analyzer.TimeOfDayRow.prototype.getCellsList = function() {
  return /** @type{!Array<!proto.analyzer.TimeOfDayCell>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.TimeOfDayCell, 2));
};


/**
 * @param {!Array<!proto.analyzer.TimeOfDayCell>} value
 * @return {!proto.analyzer.TimeOfDayRow} returns this
*/
proto.analyzer.TimeOfDayRow.prototype.setCellsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.analyzer.TimeOfDayCell=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.TimeOfDayCell}
 */
proto.analyzer.TimeOfDayRow.prototype.addCells = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.analyzer.TimeOfDayCell, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.TimeOfDayRow} returns this
 */
proto.analyzer.TimeOfDayRow.prototype.clearCellsList = function() {
  return this.setCellsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.TimeOfDayCell.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.TimeOfDayCell.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.TimeOfDayCell} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TimeOfDayCell.toObject = function(includeInstance, msg) {
  var f, obj = {
day: jspb.Message.getFieldWithDefault(msg, 1, ""),
roiPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
trades: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.TimeOfDayCell}
 */
proto.analyzer.TimeOfDayCell.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.TimeOfDayCell;
  return proto.analyzer.TimeOfDayCell.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.TimeOfDayCell} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.TimeOfDayCell}
 */
proto.analyzer.TimeOfDayCell.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDay(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRoiPct(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTrades(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.TimeOfDayCell.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.TimeOfDayCell.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.TimeOfDayCell} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TimeOfDayCell.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDay();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoiPct();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getTrades();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string day = 1;
 * @return {string}
 */
proto.analyzer.TimeOfDayCell.prototype.getDay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.TimeOfDayCell} returns this
 */
proto.analyzer.TimeOfDayCell.prototype.setDay = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double roi_pct = 2;
 * @return {number}
 */
proto.analyzer.TimeOfDayCell.prototype.getRoiPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TimeOfDayCell} returns this
 */
proto.analyzer.TimeOfDayCell.prototype.setRoiPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int64 trades = 3;
 * @return {number}
 */
proto.analyzer.TimeOfDayCell.prototype.getTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TimeOfDayCell} returns this
 */
proto.analyzer.TimeOfDayCell.prototype.setTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.RollingWinRateChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.RollingWinRateChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.RollingWinRateChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.RollingWinRateChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RollingWinRateChart.toObject = function(includeInstance, msg) {
  var f, obj = {
pointsList: jspb.Message.toObjectList(msg.getPointsList(),
    proto.analyzer.RollingMetricPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.RollingWinRateChart}
 */
proto.analyzer.RollingWinRateChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.RollingWinRateChart;
  return proto.analyzer.RollingWinRateChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.RollingWinRateChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.RollingWinRateChart}
 */
proto.analyzer.RollingWinRateChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.RollingMetricPoint;
      reader.readMessage(value,proto.analyzer.RollingMetricPoint.deserializeBinaryFromReader);
      msg.addPoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.RollingWinRateChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.RollingWinRateChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.RollingWinRateChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RollingWinRateChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.RollingMetricPoint.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RollingMetricPoint points = 1;
 * @return {!Array<!proto.analyzer.RollingMetricPoint>}
 */
proto.analyzer.RollingWinRateChart.prototype.getPointsList = function() {
  return /** @type{!Array<!proto.analyzer.RollingMetricPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.RollingMetricPoint, 1));
};


/**
 * @param {!Array<!proto.analyzer.RollingMetricPoint>} value
 * @return {!proto.analyzer.RollingWinRateChart} returns this
*/
proto.analyzer.RollingWinRateChart.prototype.setPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.RollingMetricPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.RollingMetricPoint}
 */
proto.analyzer.RollingWinRateChart.prototype.addPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.RollingMetricPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.RollingWinRateChart} returns this
 */
proto.analyzer.RollingWinRateChart.prototype.clearPointsList = function() {
  return this.setPointsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.RollingProfitFactorChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.RollingProfitFactorChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.RollingProfitFactorChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.RollingProfitFactorChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RollingProfitFactorChart.toObject = function(includeInstance, msg) {
  var f, obj = {
pointsList: jspb.Message.toObjectList(msg.getPointsList(),
    proto.analyzer.RollingMetricPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.RollingProfitFactorChart}
 */
proto.analyzer.RollingProfitFactorChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.RollingProfitFactorChart;
  return proto.analyzer.RollingProfitFactorChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.RollingProfitFactorChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.RollingProfitFactorChart}
 */
proto.analyzer.RollingProfitFactorChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.RollingMetricPoint;
      reader.readMessage(value,proto.analyzer.RollingMetricPoint.deserializeBinaryFromReader);
      msg.addPoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.RollingProfitFactorChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.RollingProfitFactorChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.RollingProfitFactorChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RollingProfitFactorChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.RollingMetricPoint.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RollingMetricPoint points = 1;
 * @return {!Array<!proto.analyzer.RollingMetricPoint>}
 */
proto.analyzer.RollingProfitFactorChart.prototype.getPointsList = function() {
  return /** @type{!Array<!proto.analyzer.RollingMetricPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.RollingMetricPoint, 1));
};


/**
 * @param {!Array<!proto.analyzer.RollingMetricPoint>} value
 * @return {!proto.analyzer.RollingProfitFactorChart} returns this
*/
proto.analyzer.RollingProfitFactorChart.prototype.setPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.RollingMetricPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.RollingMetricPoint}
 */
proto.analyzer.RollingProfitFactorChart.prototype.addPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.RollingMetricPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.RollingProfitFactorChart} returns this
 */
proto.analyzer.RollingProfitFactorChart.prototype.clearPointsList = function() {
  return this.setPointsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.RollingDrawdownChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.RollingDrawdownChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.RollingDrawdownChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.RollingDrawdownChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RollingDrawdownChart.toObject = function(includeInstance, msg) {
  var f, obj = {
pointsList: jspb.Message.toObjectList(msg.getPointsList(),
    proto.analyzer.RollingMetricPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.RollingDrawdownChart}
 */
proto.analyzer.RollingDrawdownChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.RollingDrawdownChart;
  return proto.analyzer.RollingDrawdownChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.RollingDrawdownChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.RollingDrawdownChart}
 */
proto.analyzer.RollingDrawdownChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.RollingMetricPoint;
      reader.readMessage(value,proto.analyzer.RollingMetricPoint.deserializeBinaryFromReader);
      msg.addPoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.RollingDrawdownChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.RollingDrawdownChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.RollingDrawdownChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RollingDrawdownChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.RollingMetricPoint.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RollingMetricPoint points = 1;
 * @return {!Array<!proto.analyzer.RollingMetricPoint>}
 */
proto.analyzer.RollingDrawdownChart.prototype.getPointsList = function() {
  return /** @type{!Array<!proto.analyzer.RollingMetricPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.RollingMetricPoint, 1));
};


/**
 * @param {!Array<!proto.analyzer.RollingMetricPoint>} value
 * @return {!proto.analyzer.RollingDrawdownChart} returns this
*/
proto.analyzer.RollingDrawdownChart.prototype.setPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.RollingMetricPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.RollingMetricPoint}
 */
proto.analyzer.RollingDrawdownChart.prototype.addPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.RollingMetricPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.RollingDrawdownChart} returns this
 */
proto.analyzer.RollingDrawdownChart.prototype.clearPointsList = function() {
  return this.setPointsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.RollingMetricPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.RollingMetricPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.RollingMetricPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RollingMetricPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
trades: jspb.Message.getFieldWithDefault(msg, 2, 0),
value: (f = msg.getValue()) && proto.analyzer.MetricValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.RollingMetricPoint}
 */
proto.analyzer.RollingMetricPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.RollingMetricPoint;
  return proto.analyzer.RollingMetricPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.RollingMetricPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.RollingMetricPoint}
 */
proto.analyzer.RollingMetricPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrades(value);
      break;
    case 3:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.RollingMetricPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.RollingMetricPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.RollingMetricPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RollingMetricPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTrades();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.analyzer.RollingMetricPoint.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.RollingMetricPoint} returns this
 */
proto.analyzer.RollingMetricPoint.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 trades = 2;
 * @return {number}
 */
proto.analyzer.RollingMetricPoint.prototype.getTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.RollingMetricPoint} returns this
 */
proto.analyzer.RollingMetricPoint.prototype.setTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional MetricValue value = 3;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.RollingMetricPoint.prototype.getValue = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 3));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.RollingMetricPoint} returns this
*/
proto.analyzer.RollingMetricPoint.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.RollingMetricPoint} returns this
 */
proto.analyzer.RollingMetricPoint.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.RollingMetricPoint.prototype.hasValue = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.RiskPerTradeVsOutcomeChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.RiskPerTradeVsOutcomeChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.RiskPerTradeVsOutcomeChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.RiskPerTradeVsOutcomeChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RiskPerTradeVsOutcomeChart.toObject = function(includeInstance, msg) {
  var f, obj = {
bucketsList: jspb.Message.toObjectList(msg.getBucketsList(),
    proto.analyzer.RiskBucket.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.RiskPerTradeVsOutcomeChart}
 */
proto.analyzer.RiskPerTradeVsOutcomeChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.RiskPerTradeVsOutcomeChart;
  return proto.analyzer.RiskPerTradeVsOutcomeChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.RiskPerTradeVsOutcomeChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.RiskPerTradeVsOutcomeChart}
 */
proto.analyzer.RiskPerTradeVsOutcomeChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.RiskBucket;
      reader.readMessage(value,proto.analyzer.RiskBucket.deserializeBinaryFromReader);
      msg.addBuckets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.RiskPerTradeVsOutcomeChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.RiskPerTradeVsOutcomeChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.RiskPerTradeVsOutcomeChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RiskPerTradeVsOutcomeChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBucketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.RiskBucket.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RiskBucket buckets = 1;
 * @return {!Array<!proto.analyzer.RiskBucket>}
 */
proto.analyzer.RiskPerTradeVsOutcomeChart.prototype.getBucketsList = function() {
  return /** @type{!Array<!proto.analyzer.RiskBucket>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.RiskBucket, 1));
};


/**
 * @param {!Array<!proto.analyzer.RiskBucket>} value
 * @return {!proto.analyzer.RiskPerTradeVsOutcomeChart} returns this
*/
proto.analyzer.RiskPerTradeVsOutcomeChart.prototype.setBucketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.RiskBucket=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.RiskBucket}
 */
proto.analyzer.RiskPerTradeVsOutcomeChart.prototype.addBuckets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.RiskBucket, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.RiskPerTradeVsOutcomeChart} returns this
 */
proto.analyzer.RiskPerTradeVsOutcomeChart.prototype.clearBucketsList = function() {
  return this.setBucketsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.RiskBucket.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.RiskBucket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.RiskBucket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RiskBucket.toObject = function(includeInstance, msg) {
  var f, obj = {
riskLabel: jspb.Message.getFieldWithDefault(msg, 1, ""),
winRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
outcome: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
risk: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.RiskBucket}
 */
proto.analyzer.RiskBucket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.RiskBucket;
  return proto.analyzer.RiskBucket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.RiskBucket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.RiskBucket}
 */
proto.analyzer.RiskBucket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskLabel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWinRate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOutcome(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRisk(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.RiskBucket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.RiskBucket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.RiskBucket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RiskBucket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWinRate();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getOutcome();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getRisk();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional string risk_label = 1;
 * @return {string}
 */
proto.analyzer.RiskBucket.prototype.getRiskLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.RiskBucket} returns this
 */
proto.analyzer.RiskBucket.prototype.setRiskLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double win_rate = 2;
 * @return {number}
 */
proto.analyzer.RiskBucket.prototype.getWinRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.RiskBucket} returns this
 */
proto.analyzer.RiskBucket.prototype.setWinRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double outcome = 3;
 * @return {number}
 */
proto.analyzer.RiskBucket.prototype.getOutcome = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.RiskBucket} returns this
 */
proto.analyzer.RiskBucket.prototype.setOutcome = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double risk = 4;
 * @return {number}
 */
proto.analyzer.RiskBucket.prototype.getRisk = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.RiskBucket} returns this
 */
proto.analyzer.RiskBucket.prototype.setRisk = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.LosingStreaksRecoveryCard.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.LosingStreaksRecoveryCard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.LosingStreaksRecoveryCard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.LosingStreaksRecoveryCard.toObject = function(includeInstance, msg) {
  var f, obj = {
worstStreakDays: jspb.Message.getFieldWithDefault(msg, 1, 0),
avgRecoveryDays: jspb.Message.getFieldWithDefault(msg, 2, 0),
recoveredAfterWorst: jspb.Message.getFieldWithDefault(msg, 3, 0),
consistencyScore: jspb.Message.getFieldWithDefault(msg, 4, 0),
trades: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.LosingStreaksRecoveryCard}
 */
proto.analyzer.LosingStreaksRecoveryCard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.LosingStreaksRecoveryCard;
  return proto.analyzer.LosingStreaksRecoveryCard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.LosingStreaksRecoveryCard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.LosingStreaksRecoveryCard}
 */
proto.analyzer.LosingStreaksRecoveryCard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWorstStreakDays(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAvgRecoveryDays(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRecoveredAfterWorst(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setConsistencyScore(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrades(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.LosingStreaksRecoveryCard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.LosingStreaksRecoveryCard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.LosingStreaksRecoveryCard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.LosingStreaksRecoveryCard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorstStreakDays();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAvgRecoveryDays();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getRecoveredAfterWorst();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getConsistencyScore();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTrades();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 worst_streak_days = 1;
 * @return {number}
 */
proto.analyzer.LosingStreaksRecoveryCard.prototype.getWorstStreakDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.LosingStreaksRecoveryCard} returns this
 */
proto.analyzer.LosingStreaksRecoveryCard.prototype.setWorstStreakDays = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 avg_recovery_days = 2;
 * @return {number}
 */
proto.analyzer.LosingStreaksRecoveryCard.prototype.getAvgRecoveryDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.LosingStreaksRecoveryCard} returns this
 */
proto.analyzer.LosingStreaksRecoveryCard.prototype.setAvgRecoveryDays = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 recovered_after_worst = 3;
 * @return {number}
 */
proto.analyzer.LosingStreaksRecoveryCard.prototype.getRecoveredAfterWorst = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.LosingStreaksRecoveryCard} returns this
 */
proto.analyzer.LosingStreaksRecoveryCard.prototype.setRecoveredAfterWorst = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 consistency_score = 4;
 * @return {number}
 */
proto.analyzer.LosingStreaksRecoveryCard.prototype.getConsistencyScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.LosingStreaksRecoveryCard} returns this
 */
proto.analyzer.LosingStreaksRecoveryCard.prototype.setConsistencyScore = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 trades = 5;
 * @return {number}
 */
proto.analyzer.LosingStreaksRecoveryCard.prototype.getTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.LosingStreaksRecoveryCard} returns this
 */
proto.analyzer.LosingStreaksRecoveryCard.prototype.setTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.PropRuleUsageCard.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.PropRuleUsageCard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.PropRuleUsageCard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PropRuleUsageCard.toObject = function(includeInstance, msg) {
  var f, obj = {
avgDailyLossUsed: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
daysOver80Limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
timesRuleBreached: jspb.Message.getFieldWithDefault(msg, 3, 0),
profitTargetProgress: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
trades: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.PropRuleUsageCard}
 */
proto.analyzer.PropRuleUsageCard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.PropRuleUsageCard;
  return proto.analyzer.PropRuleUsageCard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.PropRuleUsageCard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.PropRuleUsageCard}
 */
proto.analyzer.PropRuleUsageCard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgDailyLossUsed(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDaysOver80Limit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimesRuleBreached(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfitTargetProgress(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrades(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.PropRuleUsageCard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.PropRuleUsageCard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.PropRuleUsageCard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PropRuleUsageCard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvgDailyLossUsed();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getDaysOver80Limit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTimesRuleBreached();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getProfitTargetProgress();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getTrades();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional double avg_daily_loss_used = 1;
 * @return {number}
 */
proto.analyzer.PropRuleUsageCard.prototype.getAvgDailyLossUsed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.PropRuleUsageCard} returns this
 */
proto.analyzer.PropRuleUsageCard.prototype.setAvgDailyLossUsed = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional int32 days_over_80_limit = 2;
 * @return {number}
 */
proto.analyzer.PropRuleUsageCard.prototype.getDaysOver80Limit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.PropRuleUsageCard} returns this
 */
proto.analyzer.PropRuleUsageCard.prototype.setDaysOver80Limit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 times_rule_breached = 3;
 * @return {number}
 */
proto.analyzer.PropRuleUsageCard.prototype.getTimesRuleBreached = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.PropRuleUsageCard} returns this
 */
proto.analyzer.PropRuleUsageCard.prototype.setTimesRuleBreached = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double profit_target_progress = 4;
 * @return {number}
 */
proto.analyzer.PropRuleUsageCard.prototype.getProfitTargetProgress = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.PropRuleUsageCard} returns this
 */
proto.analyzer.PropRuleUsageCard.prototype.setProfitTargetProgress = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int32 trades = 5;
 * @return {number}
 */
proto.analyzer.PropRuleUsageCard.prototype.getTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.PropRuleUsageCard} returns this
 */
proto.analyzer.PropRuleUsageCard.prototype.setTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.TagPerformanceTable.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.TagPerformanceTable.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.TagPerformanceTable.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.TagPerformanceTable} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TagPerformanceTable.toObject = function(includeInstance, msg) {
  var f, obj = {
rowsList: jspb.Message.toObjectList(msg.getRowsList(),
    proto.analyzer.TagPerformanceRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.TagPerformanceTable}
 */
proto.analyzer.TagPerformanceTable.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.TagPerformanceTable;
  return proto.analyzer.TagPerformanceTable.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.TagPerformanceTable} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.TagPerformanceTable}
 */
proto.analyzer.TagPerformanceTable.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.TagPerformanceRow;
      reader.readMessage(value,proto.analyzer.TagPerformanceRow.deserializeBinaryFromReader);
      msg.addRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.TagPerformanceTable.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.TagPerformanceTable.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.TagPerformanceTable} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TagPerformanceTable.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.TagPerformanceRow.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TagPerformanceRow rows = 1;
 * @return {!Array<!proto.analyzer.TagPerformanceRow>}
 */
proto.analyzer.TagPerformanceTable.prototype.getRowsList = function() {
  return /** @type{!Array<!proto.analyzer.TagPerformanceRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.TagPerformanceRow, 1));
};


/**
 * @param {!Array<!proto.analyzer.TagPerformanceRow>} value
 * @return {!proto.analyzer.TagPerformanceTable} returns this
*/
proto.analyzer.TagPerformanceTable.prototype.setRowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.TagPerformanceRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.TagPerformanceRow}
 */
proto.analyzer.TagPerformanceTable.prototype.addRows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.TagPerformanceRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.TagPerformanceTable} returns this
 */
proto.analyzer.TagPerformanceTable.prototype.clearRowsList = function() {
  return this.setRowsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.TagPerformanceRow.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.TagPerformanceRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.TagPerformanceRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TagPerformanceRow.toObject = function(includeInstance, msg) {
  var f, obj = {
tag: jspb.Message.getFieldWithDefault(msg, 1, ""),
roiPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
profitFactor: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
expectancyR: jspb.Message.getFieldWithDefault(msg, 4, ""),
trades: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.TagPerformanceRow}
 */
proto.analyzer.TagPerformanceRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.TagPerformanceRow;
  return proto.analyzer.TagPerformanceRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.TagPerformanceRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.TagPerformanceRow}
 */
proto.analyzer.TagPerformanceRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTag(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRoiPct(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfitFactor(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpectancyR(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrades(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.TagPerformanceRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.TagPerformanceRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.TagPerformanceRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TagPerformanceRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTag();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoiPct();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getProfitFactor();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getExpectancyR();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTrades();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string tag = 1;
 * @return {string}
 */
proto.analyzer.TagPerformanceRow.prototype.getTag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.TagPerformanceRow} returns this
 */
proto.analyzer.TagPerformanceRow.prototype.setTag = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double roi_pct = 2;
 * @return {number}
 */
proto.analyzer.TagPerformanceRow.prototype.getRoiPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TagPerformanceRow} returns this
 */
proto.analyzer.TagPerformanceRow.prototype.setRoiPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double profit_factor = 3;
 * @return {number}
 */
proto.analyzer.TagPerformanceRow.prototype.getProfitFactor = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TagPerformanceRow} returns this
 */
proto.analyzer.TagPerformanceRow.prototype.setProfitFactor = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string expectancy_r = 4;
 * @return {string}
 */
proto.analyzer.TagPerformanceRow.prototype.getExpectancyR = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.TagPerformanceRow} returns this
 */
proto.analyzer.TagPerformanceRow.prototype.setExpectancyR = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 trades = 5;
 * @return {number}
 */
proto.analyzer.TagPerformanceRow.prototype.getTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TagPerformanceRow} returns this
 */
proto.analyzer.TagPerformanceRow.prototype.setTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.EntryExitTypesChart.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.EntryExitTypesChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.EntryExitTypesChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.EntryExitTypesChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.EntryExitTypesChart.toObject = function(includeInstance, msg) {
  var f, obj = {
entryTypesList: jspb.Message.toObjectList(msg.getEntryTypesList(),
    proto.analyzer.EntryExitType.toObject, includeInstance),
exitTypesList: jspb.Message.toObjectList(msg.getExitTypesList(),
    proto.analyzer.EntryExitType.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.EntryExitTypesChart}
 */
proto.analyzer.EntryExitTypesChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.EntryExitTypesChart;
  return proto.analyzer.EntryExitTypesChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.EntryExitTypesChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.EntryExitTypesChart}
 */
proto.analyzer.EntryExitTypesChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.EntryExitType;
      reader.readMessage(value,proto.analyzer.EntryExitType.deserializeBinaryFromReader);
      msg.addEntryTypes(value);
      break;
    case 2:
      var value = new proto.analyzer.EntryExitType;
      reader.readMessage(value,proto.analyzer.EntryExitType.deserializeBinaryFromReader);
      msg.addExitTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.EntryExitTypesChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.EntryExitTypesChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.EntryExitTypesChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.EntryExitTypesChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntryTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.EntryExitType.serializeBinaryToWriter
    );
  }
  f = message.getExitTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.analyzer.EntryExitType.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EntryExitType entry_types = 1;
 * @return {!Array<!proto.analyzer.EntryExitType>}
 */
proto.analyzer.EntryExitTypesChart.prototype.getEntryTypesList = function() {
  return /** @type{!Array<!proto.analyzer.EntryExitType>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.EntryExitType, 1));
};


/**
 * @param {!Array<!proto.analyzer.EntryExitType>} value
 * @return {!proto.analyzer.EntryExitTypesChart} returns this
*/
proto.analyzer.EntryExitTypesChart.prototype.setEntryTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.EntryExitType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.EntryExitType}
 */
proto.analyzer.EntryExitTypesChart.prototype.addEntryTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.EntryExitType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.EntryExitTypesChart} returns this
 */
proto.analyzer.EntryExitTypesChart.prototype.clearEntryTypesList = function() {
  return this.setEntryTypesList([]);
};


/**
 * repeated EntryExitType exit_types = 2;
 * @return {!Array<!proto.analyzer.EntryExitType>}
 */
proto.analyzer.EntryExitTypesChart.prototype.getExitTypesList = function() {
  return /** @type{!Array<!proto.analyzer.EntryExitType>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.EntryExitType, 2));
};


/**
 * @param {!Array<!proto.analyzer.EntryExitType>} value
 * @return {!proto.analyzer.EntryExitTypesChart} returns this
*/
proto.analyzer.EntryExitTypesChart.prototype.setExitTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.analyzer.EntryExitType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.EntryExitType}
 */
proto.analyzer.EntryExitTypesChart.prototype.addExitTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.analyzer.EntryExitType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.EntryExitTypesChart} returns this
 */
proto.analyzer.EntryExitTypesChart.prototype.clearExitTypesList = function() {
  return this.setExitTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.EntryExitType.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.EntryExitType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.EntryExitType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.EntryExitType.toObject = function(includeInstance, msg) {
  var f, obj = {
method: jspb.Message.getFieldWithDefault(msg, 1, ""),
count: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.EntryExitType}
 */
proto.analyzer.EntryExitType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.EntryExitType;
  return proto.analyzer.EntryExitType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.EntryExitType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.EntryExitType}
 */
proto.analyzer.EntryExitType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMethod(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.EntryExitType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.EntryExitType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.EntryExitType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.EntryExitType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMethod();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string method = 1;
 * @return {string}
 */
proto.analyzer.EntryExitType.prototype.getMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.EntryExitType} returns this
 */
proto.analyzer.EntryExitType.prototype.setMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 count = 2;
 * @return {number}
 */
proto.analyzer.EntryExitType.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.EntryExitType} returns this
 */
proto.analyzer.EntryExitType.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.TimeInTradeBandsChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.TimeInTradeBandsChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.TimeInTradeBandsChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.TimeInTradeBandsChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TimeInTradeBandsChart.toObject = function(includeInstance, msg) {
  var f, obj = {
bandsList: jspb.Message.toObjectList(msg.getBandsList(),
    proto.analyzer.TimeInTradeBand.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.TimeInTradeBandsChart}
 */
proto.analyzer.TimeInTradeBandsChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.TimeInTradeBandsChart;
  return proto.analyzer.TimeInTradeBandsChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.TimeInTradeBandsChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.TimeInTradeBandsChart}
 */
proto.analyzer.TimeInTradeBandsChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.TimeInTradeBand;
      reader.readMessage(value,proto.analyzer.TimeInTradeBand.deserializeBinaryFromReader);
      msg.addBands(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.TimeInTradeBandsChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.TimeInTradeBandsChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.TimeInTradeBandsChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TimeInTradeBandsChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBandsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.TimeInTradeBand.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TimeInTradeBand bands = 1;
 * @return {!Array<!proto.analyzer.TimeInTradeBand>}
 */
proto.analyzer.TimeInTradeBandsChart.prototype.getBandsList = function() {
  return /** @type{!Array<!proto.analyzer.TimeInTradeBand>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.TimeInTradeBand, 1));
};


/**
 * @param {!Array<!proto.analyzer.TimeInTradeBand>} value
 * @return {!proto.analyzer.TimeInTradeBandsChart} returns this
*/
proto.analyzer.TimeInTradeBandsChart.prototype.setBandsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.TimeInTradeBand=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.TimeInTradeBand}
 */
proto.analyzer.TimeInTradeBandsChart.prototype.addBands = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.TimeInTradeBand, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.TimeInTradeBandsChart} returns this
 */
proto.analyzer.TimeInTradeBandsChart.prototype.clearBandsList = function() {
  return this.setBandsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.TimeInTradeBand.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.TimeInTradeBand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.TimeInTradeBand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TimeInTradeBand.toObject = function(includeInstance, msg) {
  var f, obj = {
durationRange: jspb.Message.getFieldWithDefault(msg, 1, ""),
tradeCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.TimeInTradeBand}
 */
proto.analyzer.TimeInTradeBand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.TimeInTradeBand;
  return proto.analyzer.TimeInTradeBand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.TimeInTradeBand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.TimeInTradeBand}
 */
proto.analyzer.TimeInTradeBand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDurationRange(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTradeCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.TimeInTradeBand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.TimeInTradeBand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.TimeInTradeBand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TimeInTradeBand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDurationRange();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTradeCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string duration_range = 1;
 * @return {string}
 */
proto.analyzer.TimeInTradeBand.prototype.getDurationRange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.TimeInTradeBand} returns this
 */
proto.analyzer.TimeInTradeBand.prototype.setDurationRange = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 trade_count = 2;
 * @return {number}
 */
proto.analyzer.TimeInTradeBand.prototype.getTradeCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TimeInTradeBand} returns this
 */
proto.analyzer.TimeInTradeBand.prototype.setTradeCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.NewsProximityEffectChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.NewsProximityEffectChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.NewsProximityEffectChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.NewsProximityEffectChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.NewsProximityEffectChart.toObject = function(includeInstance, msg) {
  var f, obj = {
bucketsList: jspb.Message.toObjectList(msg.getBucketsList(),
    proto.analyzer.NewsProximityBucket.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.NewsProximityEffectChart}
 */
proto.analyzer.NewsProximityEffectChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.NewsProximityEffectChart;
  return proto.analyzer.NewsProximityEffectChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.NewsProximityEffectChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.NewsProximityEffectChart}
 */
proto.analyzer.NewsProximityEffectChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.NewsProximityBucket;
      reader.readMessage(value,proto.analyzer.NewsProximityBucket.deserializeBinaryFromReader);
      msg.addBuckets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.NewsProximityEffectChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.NewsProximityEffectChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.NewsProximityEffectChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.NewsProximityEffectChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBucketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.NewsProximityBucket.serializeBinaryToWriter
    );
  }
};


/**
 * repeated NewsProximityBucket buckets = 1;
 * @return {!Array<!proto.analyzer.NewsProximityBucket>}
 */
proto.analyzer.NewsProximityEffectChart.prototype.getBucketsList = function() {
  return /** @type{!Array<!proto.analyzer.NewsProximityBucket>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.NewsProximityBucket, 1));
};


/**
 * @param {!Array<!proto.analyzer.NewsProximityBucket>} value
 * @return {!proto.analyzer.NewsProximityEffectChart} returns this
*/
proto.analyzer.NewsProximityEffectChart.prototype.setBucketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.NewsProximityBucket=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.NewsProximityBucket}
 */
proto.analyzer.NewsProximityEffectChart.prototype.addBuckets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.NewsProximityBucket, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.NewsProximityEffectChart} returns this
 */
proto.analyzer.NewsProximityEffectChart.prototype.clearBucketsList = function() {
  return this.setBucketsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.NewsProximityBucket.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.NewsProximityBucket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.NewsProximityBucket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.NewsProximityBucket.toObject = function(includeInstance, msg) {
  var f, obj = {
timeRange: jspb.Message.getFieldWithDefault(msg, 1, ""),
roiPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.NewsProximityBucket}
 */
proto.analyzer.NewsProximityBucket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.NewsProximityBucket;
  return proto.analyzer.NewsProximityBucket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.NewsProximityBucket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.NewsProximityBucket}
 */
proto.analyzer.NewsProximityBucket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeRange(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRoiPct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.NewsProximityBucket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.NewsProximityBucket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.NewsProximityBucket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.NewsProximityBucket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeRange();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoiPct();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string time_range = 1;
 * @return {string}
 */
proto.analyzer.NewsProximityBucket.prototype.getTimeRange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.NewsProximityBucket} returns this
 */
proto.analyzer.NewsProximityBucket.prototype.setTimeRange = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double roi_pct = 2;
 * @return {number}
 */
proto.analyzer.NewsProximityBucket.prototype.getRoiPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.NewsProximityBucket} returns this
 */
proto.analyzer.NewsProximityBucket.prototype.setRoiPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.ScaledInTradesCard.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ScaledInTradesCard.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ScaledInTradesCard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ScaledInTradesCard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ScaledInTradesCard.toObject = function(includeInstance, msg) {
  var f, obj = {
scaledInTrades: jspb.Message.getFieldWithDefault(msg, 1, 0),
avgAddsPerTrade: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
impactOnPnl: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
dailyAddList: jspb.Message.toObjectList(msg.getDailyAddList(),
    proto.analyzer.ScalingMetrics.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ScaledInTradesCard}
 */
proto.analyzer.ScaledInTradesCard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ScaledInTradesCard;
  return proto.analyzer.ScaledInTradesCard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ScaledInTradesCard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ScaledInTradesCard}
 */
proto.analyzer.ScaledInTradesCard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScaledInTrades(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgAddsPerTrade(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setImpactOnPnl(value);
      break;
    case 4:
      var value = new proto.analyzer.ScalingMetrics;
      reader.readMessage(value,proto.analyzer.ScalingMetrics.deserializeBinaryFromReader);
      msg.addDailyAdd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ScaledInTradesCard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ScaledInTradesCard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ScaledInTradesCard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ScaledInTradesCard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScaledInTrades();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAvgAddsPerTrade();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getImpactOnPnl();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getDailyAddList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.analyzer.ScalingMetrics.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 scaled_in_trades = 1;
 * @return {number}
 */
proto.analyzer.ScaledInTradesCard.prototype.getScaledInTrades = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ScaledInTradesCard} returns this
 */
proto.analyzer.ScaledInTradesCard.prototype.setScaledInTrades = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double avg_adds_per_trade = 2;
 * @return {number}
 */
proto.analyzer.ScaledInTradesCard.prototype.getAvgAddsPerTrade = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ScaledInTradesCard} returns this
 */
proto.analyzer.ScaledInTradesCard.prototype.setAvgAddsPerTrade = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double impact_on_pnl = 3;
 * @return {number}
 */
proto.analyzer.ScaledInTradesCard.prototype.getImpactOnPnl = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ScaledInTradesCard} returns this
 */
proto.analyzer.ScaledInTradesCard.prototype.setImpactOnPnl = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * repeated ScalingMetrics daily_add = 4;
 * @return {!Array<!proto.analyzer.ScalingMetrics>}
 */
proto.analyzer.ScaledInTradesCard.prototype.getDailyAddList = function() {
  return /** @type{!Array<!proto.analyzer.ScalingMetrics>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.ScalingMetrics, 4));
};


/**
 * @param {!Array<!proto.analyzer.ScalingMetrics>} value
 * @return {!proto.analyzer.ScaledInTradesCard} returns this
*/
proto.analyzer.ScaledInTradesCard.prototype.setDailyAddList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.analyzer.ScalingMetrics=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.ScalingMetrics}
 */
proto.analyzer.ScaledInTradesCard.prototype.addDailyAdd = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.analyzer.ScalingMetrics, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.ScaledInTradesCard} returns this
 */
proto.analyzer.ScaledInTradesCard.prototype.clearDailyAddList = function() {
  return this.setDailyAddList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ScalingMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ScalingMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ScalingMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ScalingMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
count: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ScalingMetrics}
 */
proto.analyzer.ScalingMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ScalingMetrics;
  return proto.analyzer.ScalingMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ScalingMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ScalingMetrics}
 */
proto.analyzer.ScalingMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ScalingMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ScalingMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ScalingMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ScalingMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.analyzer.ScalingMetrics.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.ScalingMetrics} returns this
 */
proto.analyzer.ScalingMetrics.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 count = 2;
 * @return {number}
 */
proto.analyzer.ScalingMetrics.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ScalingMetrics} returns this
 */
proto.analyzer.ScalingMetrics.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetAccountTradeListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetAccountTradeListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetAccountTradeListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetAccountTradeListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
dateRange: (f = msg.getDateRange()) && common_common_pb.DateRange.toObject(includeInstance, f),
limit: jspb.Message.getFieldWithDefault(msg, 4, 0),
sortBy: jspb.Message.getFieldWithDefault(msg, 5, ""),
sortDesc: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
page: jspb.Message.getFieldWithDefault(msg, 7, 0),
search: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetAccountTradeListRequest}
 */
proto.analyzer.GetAccountTradeListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetAccountTradeListRequest;
  return proto.analyzer.GetAccountTradeListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetAccountTradeListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetAccountTradeListRequest}
 */
proto.analyzer.GetAccountTradeListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = new common_common_pb.DateRange;
      reader.readMessage(value,common_common_pb.DateRange.deserializeBinaryFromReader);
      msg.setDateRange(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortBy(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSortDesc(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetAccountTradeListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetAccountTradeListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetAccountTradeListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetAccountTradeListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDateRange();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_common_pb.DateRange.serializeBinaryToWriter
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSortBy();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSortDesc();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getSearch();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.GetAccountTradeListRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetAccountTradeListRequest} returns this
 */
proto.analyzer.GetAccountTradeListRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyzer.GetAccountTradeListRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetAccountTradeListRequest} returns this
 */
proto.analyzer.GetAccountTradeListRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.v1.DateRange date_range = 3;
 * @return {?proto.analyzer.common.v1.DateRange}
 */
proto.analyzer.GetAccountTradeListRequest.prototype.getDateRange = function() {
  return /** @type{?proto.analyzer.common.v1.DateRange} */ (
    jspb.Message.getWrapperField(this, common_common_pb.DateRange, 3));
};


/**
 * @param {?proto.analyzer.common.v1.DateRange|undefined} value
 * @return {!proto.analyzer.GetAccountTradeListRequest} returns this
*/
proto.analyzer.GetAccountTradeListRequest.prototype.setDateRange = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountTradeListRequest} returns this
 */
proto.analyzer.GetAccountTradeListRequest.prototype.clearDateRange = function() {
  return this.setDateRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountTradeListRequest.prototype.hasDateRange = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 limit = 4;
 * @return {number}
 */
proto.analyzer.GetAccountTradeListRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.GetAccountTradeListRequest} returns this
 */
proto.analyzer.GetAccountTradeListRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string sort_by = 5;
 * @return {string}
 */
proto.analyzer.GetAccountTradeListRequest.prototype.getSortBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetAccountTradeListRequest} returns this
 */
proto.analyzer.GetAccountTradeListRequest.prototype.setSortBy = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool sort_desc = 6;
 * @return {boolean}
 */
proto.analyzer.GetAccountTradeListRequest.prototype.getSortDesc = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.analyzer.GetAccountTradeListRequest} returns this
 */
proto.analyzer.GetAccountTradeListRequest.prototype.setSortDesc = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int32 page = 7;
 * @return {number}
 */
proto.analyzer.GetAccountTradeListRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.GetAccountTradeListRequest} returns this
 */
proto.analyzer.GetAccountTradeListRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string search = 8;
 * @return {string}
 */
proto.analyzer.GetAccountTradeListRequest.prototype.getSearch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetAccountTradeListRequest} returns this
 */
proto.analyzer.GetAccountTradeListRequest.prototype.setSearch = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetAccountTradeListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetAccountTradeListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetAccountTradeListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetAccountTradeListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
tradeList: (f = msg.getTradeList()) && proto.analyzer.TradeList.toObject(includeInstance, f),
totalCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetAccountTradeListResponse}
 */
proto.analyzer.GetAccountTradeListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetAccountTradeListResponse;
  return proto.analyzer.GetAccountTradeListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetAccountTradeListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetAccountTradeListResponse}
 */
proto.analyzer.GetAccountTradeListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.TradeList;
      reader.readMessage(value,proto.analyzer.TradeList.deserializeBinaryFromReader);
      msg.setTradeList(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetAccountTradeListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetAccountTradeListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetAccountTradeListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetAccountTradeListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTradeList();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.analyzer.TradeList.serializeBinaryToWriter
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional TradeList trade_list = 1;
 * @return {?proto.analyzer.TradeList}
 */
proto.analyzer.GetAccountTradeListResponse.prototype.getTradeList = function() {
  return /** @type{?proto.analyzer.TradeList} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.TradeList, 1));
};


/**
 * @param {?proto.analyzer.TradeList|undefined} value
 * @return {!proto.analyzer.GetAccountTradeListResponse} returns this
*/
proto.analyzer.GetAccountTradeListResponse.prototype.setTradeList = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountTradeListResponse} returns this
 */
proto.analyzer.GetAccountTradeListResponse.prototype.clearTradeList = function() {
  return this.setTradeList(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountTradeListResponse.prototype.hasTradeList = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 total_count = 2;
 * @return {number}
 */
proto.analyzer.GetAccountTradeListResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.GetAccountTradeListResponse} returns this
 */
proto.analyzer.GetAccountTradeListResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.analyzer.GetAccountTradeListResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.GetAccountTradeListResponse} returns this
 */
proto.analyzer.GetAccountTradeListResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 page_size = 4;
 * @return {number}
 */
proto.analyzer.GetAccountTradeListResponse.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.GetAccountTradeListResponse} returns this
 */
proto.analyzer.GetAccountTradeListResponse.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.TradeList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.TradeList.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.TradeList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.TradeList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TradeList.toObject = function(includeInstance, msg) {
  var f, obj = {
tradesList: jspb.Message.toObjectList(msg.getTradesList(),
    proto.analyzer.TradeRow.toObject, includeInstance),
summary: (f = msg.getSummary()) && proto.analyzer.TradeSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.TradeList}
 */
proto.analyzer.TradeList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.TradeList;
  return proto.analyzer.TradeList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.TradeList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.TradeList}
 */
proto.analyzer.TradeList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.TradeRow;
      reader.readMessage(value,proto.analyzer.TradeRow.deserializeBinaryFromReader);
      msg.addTrades(value);
      break;
    case 2:
      var value = new proto.analyzer.TradeSummary;
      reader.readMessage(value,proto.analyzer.TradeSummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.TradeList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.TradeList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.TradeList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TradeList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTradesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.TradeRow.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.analyzer.TradeSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TradeRow trades = 1;
 * @return {!Array<!proto.analyzer.TradeRow>}
 */
proto.analyzer.TradeList.prototype.getTradesList = function() {
  return /** @type{!Array<!proto.analyzer.TradeRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.TradeRow, 1));
};


/**
 * @param {!Array<!proto.analyzer.TradeRow>} value
 * @return {!proto.analyzer.TradeList} returns this
*/
proto.analyzer.TradeList.prototype.setTradesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.TradeRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.TradeRow}
 */
proto.analyzer.TradeList.prototype.addTrades = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.TradeRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.TradeList} returns this
 */
proto.analyzer.TradeList.prototype.clearTradesList = function() {
  return this.setTradesList([]);
};


/**
 * optional TradeSummary summary = 2;
 * @return {?proto.analyzer.TradeSummary}
 */
proto.analyzer.TradeList.prototype.getSummary = function() {
  return /** @type{?proto.analyzer.TradeSummary} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.TradeSummary, 2));
};


/**
 * @param {?proto.analyzer.TradeSummary|undefined} value
 * @return {!proto.analyzer.TradeList} returns this
*/
proto.analyzer.TradeList.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.TradeList} returns this
 */
proto.analyzer.TradeList.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.TradeList.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.TradeRow.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.TradeRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.TradeRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TradeRow.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
account: jspb.Message.getFieldWithDefault(msg, 2, ""),
symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
side: jspb.Message.getFieldWithDefault(msg, 4, ""),
lot: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
entryPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
exitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
pnl: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
r: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
tag: jspb.Message.getFieldWithDefault(msg, 10, ""),
tradeId: jspb.Message.getFieldWithDefault(msg, 11, ""),
tagId: jspb.Message.getFieldWithDefault(msg, 12, 0),
id: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.TradeRow}
 */
proto.analyzer.TradeRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.TradeRow;
  return proto.analyzer.TradeRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.TradeRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.TradeRow}
 */
proto.analyzer.TradeRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSide(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLot(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEntryPrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setExitPrice(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPnl(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setR(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTag(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradeId(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTagId(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.TradeRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.TradeRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.TradeRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TradeRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSide();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLot();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getEntryPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getExitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getPnl();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getR();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getTag();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTradeId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getTagId();
  if (f !== 0) {
    writer.writeUint64(
      12,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      13,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.analyzer.TradeRow.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.TradeRow} returns this
 */
proto.analyzer.TradeRow.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account = 2;
 * @return {string}
 */
proto.analyzer.TradeRow.prototype.getAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.TradeRow} returns this
 */
proto.analyzer.TradeRow.prototype.setAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.analyzer.TradeRow.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.TradeRow} returns this
 */
proto.analyzer.TradeRow.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string side = 4;
 * @return {string}
 */
proto.analyzer.TradeRow.prototype.getSide = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.TradeRow} returns this
 */
proto.analyzer.TradeRow.prototype.setSide = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double lot = 5;
 * @return {number}
 */
proto.analyzer.TradeRow.prototype.getLot = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TradeRow} returns this
 */
proto.analyzer.TradeRow.prototype.setLot = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double entry_price = 6;
 * @return {number}
 */
proto.analyzer.TradeRow.prototype.getEntryPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TradeRow} returns this
 */
proto.analyzer.TradeRow.prototype.setEntryPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double exit_price = 7;
 * @return {number}
 */
proto.analyzer.TradeRow.prototype.getExitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TradeRow} returns this
 */
proto.analyzer.TradeRow.prototype.setExitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double pnl = 8;
 * @return {number}
 */
proto.analyzer.TradeRow.prototype.getPnl = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TradeRow} returns this
 */
proto.analyzer.TradeRow.prototype.setPnl = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double r = 9;
 * @return {number}
 */
proto.analyzer.TradeRow.prototype.getR = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TradeRow} returns this
 */
proto.analyzer.TradeRow.prototype.setR = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional string tag = 10;
 * @return {string}
 */
proto.analyzer.TradeRow.prototype.getTag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.TradeRow} returns this
 */
proto.analyzer.TradeRow.prototype.setTag = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string trade_id = 11;
 * @return {string}
 */
proto.analyzer.TradeRow.prototype.getTradeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.TradeRow} returns this
 */
proto.analyzer.TradeRow.prototype.setTradeId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional uint64 tag_id = 12;
 * @return {number}
 */
proto.analyzer.TradeRow.prototype.getTagId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TradeRow} returns this
 */
proto.analyzer.TradeRow.prototype.setTagId = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional uint64 id = 13;
 * @return {number}
 */
proto.analyzer.TradeRow.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TradeRow} returns this
 */
proto.analyzer.TradeRow.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.TradeSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.TradeSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.TradeSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TradeSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
totalPnl: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
totalR: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.TradeSummary}
 */
proto.analyzer.TradeSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.TradeSummary;
  return proto.analyzer.TradeSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.TradeSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.TradeSummary}
 */
proto.analyzer.TradeSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalPnl(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalR(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.TradeSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.TradeSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.TradeSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TradeSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalPnl();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getTotalR();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double total_pnl = 1;
 * @return {number}
 */
proto.analyzer.TradeSummary.prototype.getTotalPnl = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TradeSummary} returns this
 */
proto.analyzer.TradeSummary.prototype.setTotalPnl = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double total_r = 2;
 * @return {number}
 */
proto.analyzer.TradeSummary.prototype.getTotalR = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TradeSummary} returns this
 */
proto.analyzer.TradeSummary.prototype.setTotalR = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetPortfolioOverviewReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetPortfolioOverviewReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetPortfolioOverviewReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetPortfolioOverviewReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
currency: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetPortfolioOverviewReq}
 */
proto.analyzer.GetPortfolioOverviewReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetPortfolioOverviewReq;
  return proto.analyzer.GetPortfolioOverviewReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetPortfolioOverviewReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetPortfolioOverviewReq}
 */
proto.analyzer.GetPortfolioOverviewReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetPortfolioOverviewReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetPortfolioOverviewReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetPortfolioOverviewReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetPortfolioOverviewReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.GetPortfolioOverviewReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetPortfolioOverviewReq} returns this
 */
proto.analyzer.GetPortfolioOverviewReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.analyzer.GetPortfolioOverviewReq.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetPortfolioOverviewReq} returns this
 */
proto.analyzer.GetPortfolioOverviewReq.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetPortfolioOverviewReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetPortfolioOverviewReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetPortfolioOverviewReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetPortfolioOverviewReply.toObject = function(includeInstance, msg) {
  var f, obj = {
summary: (f = msg.getSummary()) && proto.analyzer.PortfolioSummary.toObject(includeInstance, f),
lastSynced: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetPortfolioOverviewReply}
 */
proto.analyzer.GetPortfolioOverviewReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetPortfolioOverviewReply;
  return proto.analyzer.GetPortfolioOverviewReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetPortfolioOverviewReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetPortfolioOverviewReply}
 */
proto.analyzer.GetPortfolioOverviewReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.PortfolioSummary;
      reader.readMessage(value,proto.analyzer.PortfolioSummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastSynced(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetPortfolioOverviewReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetPortfolioOverviewReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetPortfolioOverviewReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetPortfolioOverviewReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.analyzer.PortfolioSummary.serializeBinaryToWriter
    );
  }
  f = message.getLastSynced();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional PortfolioSummary summary = 1;
 * @return {?proto.analyzer.PortfolioSummary}
 */
proto.analyzer.GetPortfolioOverviewReply.prototype.getSummary = function() {
  return /** @type{?proto.analyzer.PortfolioSummary} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.PortfolioSummary, 1));
};


/**
 * @param {?proto.analyzer.PortfolioSummary|undefined} value
 * @return {!proto.analyzer.GetPortfolioOverviewReply} returns this
*/
proto.analyzer.GetPortfolioOverviewReply.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetPortfolioOverviewReply} returns this
 */
proto.analyzer.GetPortfolioOverviewReply.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetPortfolioOverviewReply.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string last_synced = 2;
 * @return {string}
 */
proto.analyzer.GetPortfolioOverviewReply.prototype.getLastSynced = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetPortfolioOverviewReply} returns this
 */
proto.analyzer.GetPortfolioOverviewReply.prototype.setLastSynced = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.PortfolioSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.PortfolioSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.PortfolioSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PortfolioSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
totalAccounts: jspb.Message.getFieldWithDefault(msg, 1, 0),
accountsChange: jspb.Message.getFieldWithDefault(msg, 2, 0),
previousDayAccountTotal: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalBalance: (f = msg.getTotalBalance()) && common_common_pb.Money.toObject(includeInstance, f),
balanceChangePct: (f = msg.getBalanceChangePct()) && common_common_pb.FormattedDoubleValue.toObject(includeInstance, f),
previousBalance: (f = msg.getPreviousBalance()) && common_common_pb.Money.toObject(includeInstance, f),
roiMetrics: (f = msg.getRoiMetrics()) && proto.analyzer.ROIMetrics.toObject(includeInstance, f),
bestPerforming: (f = msg.getBestPerforming()) && proto.analyzer.AccountPerformance.toObject(includeInstance, f),
worstPerforming: (f = msg.getWorstPerforming()) && proto.analyzer.AccountPerformance.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.PortfolioSummary}
 */
proto.analyzer.PortfolioSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.PortfolioSummary;
  return proto.analyzer.PortfolioSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.PortfolioSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.PortfolioSummary}
 */
proto.analyzer.PortfolioSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalAccounts(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAccountsChange(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPreviousDayAccountTotal(value);
      break;
    case 4:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setTotalBalance(value);
      break;
    case 5:
      var value = new common_common_pb.FormattedDoubleValue;
      reader.readMessage(value,common_common_pb.FormattedDoubleValue.deserializeBinaryFromReader);
      msg.setBalanceChangePct(value);
      break;
    case 6:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setPreviousBalance(value);
      break;
    case 7:
      var value = new proto.analyzer.ROIMetrics;
      reader.readMessage(value,proto.analyzer.ROIMetrics.deserializeBinaryFromReader);
      msg.setRoiMetrics(value);
      break;
    case 8:
      var value = new proto.analyzer.AccountPerformance;
      reader.readMessage(value,proto.analyzer.AccountPerformance.deserializeBinaryFromReader);
      msg.setBestPerforming(value);
      break;
    case 9:
      var value = new proto.analyzer.AccountPerformance;
      reader.readMessage(value,proto.analyzer.AccountPerformance.deserializeBinaryFromReader);
      msg.setWorstPerforming(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.PortfolioSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.PortfolioSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.PortfolioSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PortfolioSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalAccounts();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAccountsChange();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPreviousDayAccountTotal();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalBalance();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getBalanceChangePct();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_common_pb.FormattedDoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getPreviousBalance();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getRoiMetrics();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.analyzer.ROIMetrics.serializeBinaryToWriter
    );
  }
  f = message.getBestPerforming();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.analyzer.AccountPerformance.serializeBinaryToWriter
    );
  }
  f = message.getWorstPerforming();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.analyzer.AccountPerformance.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 total_accounts = 1;
 * @return {number}
 */
proto.analyzer.PortfolioSummary.prototype.getTotalAccounts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.PortfolioSummary} returns this
 */
proto.analyzer.PortfolioSummary.prototype.setTotalAccounts = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 accounts_change = 2;
 * @return {number}
 */
proto.analyzer.PortfolioSummary.prototype.getAccountsChange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.PortfolioSummary} returns this
 */
proto.analyzer.PortfolioSummary.prototype.setAccountsChange = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 previous_day_account_total = 3;
 * @return {number}
 */
proto.analyzer.PortfolioSummary.prototype.getPreviousDayAccountTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.PortfolioSummary} returns this
 */
proto.analyzer.PortfolioSummary.prototype.setPreviousDayAccountTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional common.v1.Money total_balance = 4;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.PortfolioSummary.prototype.getTotalBalance = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 4));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.PortfolioSummary} returns this
*/
proto.analyzer.PortfolioSummary.prototype.setTotalBalance = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PortfolioSummary} returns this
 */
proto.analyzer.PortfolioSummary.prototype.clearTotalBalance = function() {
  return this.setTotalBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PortfolioSummary.prototype.hasTotalBalance = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional common.v1.FormattedDoubleValue balance_change_pct = 5;
 * @return {?proto.analyzer.common.v1.FormattedDoubleValue}
 */
proto.analyzer.PortfolioSummary.prototype.getBalanceChangePct = function() {
  return /** @type{?proto.analyzer.common.v1.FormattedDoubleValue} */ (
    jspb.Message.getWrapperField(this, common_common_pb.FormattedDoubleValue, 5));
};


/**
 * @param {?proto.analyzer.common.v1.FormattedDoubleValue|undefined} value
 * @return {!proto.analyzer.PortfolioSummary} returns this
*/
proto.analyzer.PortfolioSummary.prototype.setBalanceChangePct = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PortfolioSummary} returns this
 */
proto.analyzer.PortfolioSummary.prototype.clearBalanceChangePct = function() {
  return this.setBalanceChangePct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PortfolioSummary.prototype.hasBalanceChangePct = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional common.v1.Money previous_balance = 6;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.PortfolioSummary.prototype.getPreviousBalance = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 6));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.PortfolioSummary} returns this
*/
proto.analyzer.PortfolioSummary.prototype.setPreviousBalance = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PortfolioSummary} returns this
 */
proto.analyzer.PortfolioSummary.prototype.clearPreviousBalance = function() {
  return this.setPreviousBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PortfolioSummary.prototype.hasPreviousBalance = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ROIMetrics roi_metrics = 7;
 * @return {?proto.analyzer.ROIMetrics}
 */
proto.analyzer.PortfolioSummary.prototype.getRoiMetrics = function() {
  return /** @type{?proto.analyzer.ROIMetrics} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.ROIMetrics, 7));
};


/**
 * @param {?proto.analyzer.ROIMetrics|undefined} value
 * @return {!proto.analyzer.PortfolioSummary} returns this
*/
proto.analyzer.PortfolioSummary.prototype.setRoiMetrics = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PortfolioSummary} returns this
 */
proto.analyzer.PortfolioSummary.prototype.clearRoiMetrics = function() {
  return this.setRoiMetrics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PortfolioSummary.prototype.hasRoiMetrics = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional AccountPerformance best_performing = 8;
 * @return {?proto.analyzer.AccountPerformance}
 */
proto.analyzer.PortfolioSummary.prototype.getBestPerforming = function() {
  return /** @type{?proto.analyzer.AccountPerformance} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.AccountPerformance, 8));
};


/**
 * @param {?proto.analyzer.AccountPerformance|undefined} value
 * @return {!proto.analyzer.PortfolioSummary} returns this
*/
proto.analyzer.PortfolioSummary.prototype.setBestPerforming = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PortfolioSummary} returns this
 */
proto.analyzer.PortfolioSummary.prototype.clearBestPerforming = function() {
  return this.setBestPerforming(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PortfolioSummary.prototype.hasBestPerforming = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional AccountPerformance worst_performing = 9;
 * @return {?proto.analyzer.AccountPerformance}
 */
proto.analyzer.PortfolioSummary.prototype.getWorstPerforming = function() {
  return /** @type{?proto.analyzer.AccountPerformance} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.AccountPerformance, 9));
};


/**
 * @param {?proto.analyzer.AccountPerformance|undefined} value
 * @return {!proto.analyzer.PortfolioSummary} returns this
*/
proto.analyzer.PortfolioSummary.prototype.setWorstPerforming = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PortfolioSummary} returns this
 */
proto.analyzer.PortfolioSummary.prototype.clearWorstPerforming = function() {
  return this.setWorstPerforming(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PortfolioSummary.prototype.hasWorstPerforming = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ROIMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ROIMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ROIMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ROIMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
averageRoiPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
roiChangePct: (f = msg.getRoiChangePct()) && common_common_pb.FormattedDoubleValue.toObject(includeInstance, f),
previousPeriodRoi: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ROIMetrics}
 */
proto.analyzer.ROIMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ROIMetrics;
  return proto.analyzer.ROIMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ROIMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ROIMetrics}
 */
proto.analyzer.ROIMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAverageRoiPct(value);
      break;
    case 2:
      var value = new common_common_pb.FormattedDoubleValue;
      reader.readMessage(value,common_common_pb.FormattedDoubleValue.deserializeBinaryFromReader);
      msg.setRoiChangePct(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPreviousPeriodRoi(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ROIMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ROIMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ROIMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ROIMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAverageRoiPct();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getRoiChangePct();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_common_pb.FormattedDoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getPreviousPeriodRoi();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional double average_roi_pct = 1;
 * @return {number}
 */
proto.analyzer.ROIMetrics.prototype.getAverageRoiPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ROIMetrics} returns this
 */
proto.analyzer.ROIMetrics.prototype.setAverageRoiPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional common.v1.FormattedDoubleValue roi_change_pct = 2;
 * @return {?proto.analyzer.common.v1.FormattedDoubleValue}
 */
proto.analyzer.ROIMetrics.prototype.getRoiChangePct = function() {
  return /** @type{?proto.analyzer.common.v1.FormattedDoubleValue} */ (
    jspb.Message.getWrapperField(this, common_common_pb.FormattedDoubleValue, 2));
};


/**
 * @param {?proto.analyzer.common.v1.FormattedDoubleValue|undefined} value
 * @return {!proto.analyzer.ROIMetrics} returns this
*/
proto.analyzer.ROIMetrics.prototype.setRoiChangePct = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.ROIMetrics} returns this
 */
proto.analyzer.ROIMetrics.prototype.clearRoiChangePct = function() {
  return this.setRoiChangePct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.ROIMetrics.prototype.hasRoiChangePct = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional double previous_period_roi = 3;
 * @return {number}
 */
proto.analyzer.ROIMetrics.prototype.getPreviousPeriodRoi = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ROIMetrics} returns this
 */
proto.analyzer.ROIMetrics.prototype.setPreviousPeriodRoi = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.AccountPerformance.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.AccountPerformance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.AccountPerformance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.AccountPerformance.toObject = function(includeInstance, msg) {
  var f, obj = {
account: jspb.Message.getFieldWithDefault(msg, 1, ""),
roiPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.AccountPerformance}
 */
proto.analyzer.AccountPerformance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.AccountPerformance;
  return proto.analyzer.AccountPerformance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.AccountPerformance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.AccountPerformance}
 */
proto.analyzer.AccountPerformance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRoiPct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.AccountPerformance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.AccountPerformance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.AccountPerformance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.AccountPerformance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoiPct();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string account = 1;
 * @return {string}
 */
proto.analyzer.AccountPerformance.prototype.getAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountPerformance} returns this
 */
proto.analyzer.AccountPerformance.prototype.setAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double roi_pct = 2;
 * @return {number}
 */
proto.analyzer.AccountPerformance.prototype.getRoiPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.AccountPerformance} returns this
 */
proto.analyzer.AccountPerformance.prototype.setRoiPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetPortfolioEquityCurveReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetPortfolioEquityCurveReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetPortfolioEquityCurveReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetPortfolioEquityCurveReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
dateRange: (f = msg.getDateRange()) && common_common_pb.DateRange.toObject(includeInstance, f),
currency: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetPortfolioEquityCurveReq}
 */
proto.analyzer.GetPortfolioEquityCurveReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetPortfolioEquityCurveReq;
  return proto.analyzer.GetPortfolioEquityCurveReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetPortfolioEquityCurveReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetPortfolioEquityCurveReq}
 */
proto.analyzer.GetPortfolioEquityCurveReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new common_common_pb.DateRange;
      reader.readMessage(value,common_common_pb.DateRange.deserializeBinaryFromReader);
      msg.setDateRange(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetPortfolioEquityCurveReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetPortfolioEquityCurveReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetPortfolioEquityCurveReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetPortfolioEquityCurveReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDateRange();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_common_pb.DateRange.serializeBinaryToWriter
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.GetPortfolioEquityCurveReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetPortfolioEquityCurveReq} returns this
 */
proto.analyzer.GetPortfolioEquityCurveReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.v1.DateRange date_range = 2;
 * @return {?proto.analyzer.common.v1.DateRange}
 */
proto.analyzer.GetPortfolioEquityCurveReq.prototype.getDateRange = function() {
  return /** @type{?proto.analyzer.common.v1.DateRange} */ (
    jspb.Message.getWrapperField(this, common_common_pb.DateRange, 2));
};


/**
 * @param {?proto.analyzer.common.v1.DateRange|undefined} value
 * @return {!proto.analyzer.GetPortfolioEquityCurveReq} returns this
*/
proto.analyzer.GetPortfolioEquityCurveReq.prototype.setDateRange = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetPortfolioEquityCurveReq} returns this
 */
proto.analyzer.GetPortfolioEquityCurveReq.prototype.clearDateRange = function() {
  return this.setDateRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetPortfolioEquityCurveReq.prototype.hasDateRange = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string currency = 3;
 * @return {string}
 */
proto.analyzer.GetPortfolioEquityCurveReq.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetPortfolioEquityCurveReq} returns this
 */
proto.analyzer.GetPortfolioEquityCurveReq.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.PortfolioEquityCurve.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.PortfolioEquityCurve.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.PortfolioEquityCurve.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.PortfolioEquityCurve} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PortfolioEquityCurve.toObject = function(includeInstance, msg) {
  var f, obj = {
dataPointsList: jspb.Message.toObjectList(msg.getDataPointsList(),
    proto.analyzer.EquityCurveDataPoint.toObject, includeInstance),
minEquity: (f = msg.getMinEquity()) && common_common_pb.Money.toObject(includeInstance, f),
maxEquity: (f = msg.getMaxEquity()) && common_common_pb.Money.toObject(includeInstance, f),
currency: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.PortfolioEquityCurve}
 */
proto.analyzer.PortfolioEquityCurve.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.PortfolioEquityCurve;
  return proto.analyzer.PortfolioEquityCurve.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.PortfolioEquityCurve} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.PortfolioEquityCurve}
 */
proto.analyzer.PortfolioEquityCurve.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.EquityCurveDataPoint;
      reader.readMessage(value,proto.analyzer.EquityCurveDataPoint.deserializeBinaryFromReader);
      msg.addDataPoints(value);
      break;
    case 2:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setMinEquity(value);
      break;
    case 3:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setMaxEquity(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.PortfolioEquityCurve.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.PortfolioEquityCurve.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.PortfolioEquityCurve} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.PortfolioEquityCurve.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.EquityCurveDataPoint.serializeBinaryToWriter
    );
  }
  f = message.getMinEquity();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getMaxEquity();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * repeated EquityCurveDataPoint data_points = 1;
 * @return {!Array<!proto.analyzer.EquityCurveDataPoint>}
 */
proto.analyzer.PortfolioEquityCurve.prototype.getDataPointsList = function() {
  return /** @type{!Array<!proto.analyzer.EquityCurveDataPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.EquityCurveDataPoint, 1));
};


/**
 * @param {!Array<!proto.analyzer.EquityCurveDataPoint>} value
 * @return {!proto.analyzer.PortfolioEquityCurve} returns this
*/
proto.analyzer.PortfolioEquityCurve.prototype.setDataPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.EquityCurveDataPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.EquityCurveDataPoint}
 */
proto.analyzer.PortfolioEquityCurve.prototype.addDataPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.EquityCurveDataPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.PortfolioEquityCurve} returns this
 */
proto.analyzer.PortfolioEquityCurve.prototype.clearDataPointsList = function() {
  return this.setDataPointsList([]);
};


/**
 * optional common.v1.Money min_equity = 2;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.PortfolioEquityCurve.prototype.getMinEquity = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 2));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.PortfolioEquityCurve} returns this
*/
proto.analyzer.PortfolioEquityCurve.prototype.setMinEquity = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PortfolioEquityCurve} returns this
 */
proto.analyzer.PortfolioEquityCurve.prototype.clearMinEquity = function() {
  return this.setMinEquity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PortfolioEquityCurve.prototype.hasMinEquity = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional common.v1.Money max_equity = 3;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.PortfolioEquityCurve.prototype.getMaxEquity = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 3));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.PortfolioEquityCurve} returns this
*/
proto.analyzer.PortfolioEquityCurve.prototype.setMaxEquity = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.PortfolioEquityCurve} returns this
 */
proto.analyzer.PortfolioEquityCurve.prototype.clearMaxEquity = function() {
  return this.setMaxEquity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.PortfolioEquityCurve.prototype.hasMaxEquity = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string currency = 4;
 * @return {string}
 */
proto.analyzer.PortfolioEquityCurve.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.PortfolioEquityCurve} returns this
 */
proto.analyzer.PortfolioEquityCurve.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetPortfolioDailyAndCumulativeROIReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
dateRange: (f = msg.getDateRange()) && common_common_pb.DateRange.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetPortfolioDailyAndCumulativeROIReq}
 */
proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetPortfolioDailyAndCumulativeROIReq;
  return proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetPortfolioDailyAndCumulativeROIReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetPortfolioDailyAndCumulativeROIReq}
 */
proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new common_common_pb.DateRange;
      reader.readMessage(value,common_common_pb.DateRange.deserializeBinaryFromReader);
      msg.setDateRange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetPortfolioDailyAndCumulativeROIReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDateRange();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_common_pb.DateRange.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetPortfolioDailyAndCumulativeROIReq} returns this
 */
proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.v1.DateRange date_range = 2;
 * @return {?proto.analyzer.common.v1.DateRange}
 */
proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.prototype.getDateRange = function() {
  return /** @type{?proto.analyzer.common.v1.DateRange} */ (
    jspb.Message.getWrapperField(this, common_common_pb.DateRange, 2));
};


/**
 * @param {?proto.analyzer.common.v1.DateRange|undefined} value
 * @return {!proto.analyzer.GetPortfolioDailyAndCumulativeROIReq} returns this
*/
proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.prototype.setDateRange = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetPortfolioDailyAndCumulativeROIReq} returns this
 */
proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.prototype.clearDateRange = function() {
  return this.setDateRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetPortfolioDailyAndCumulativeROIReq.prototype.hasDateRange = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.EquityCurveDataPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.EquityCurveDataPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.EquityCurveDataPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.EquityCurveDataPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
timestamp: (f = msg.getTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
dateLabel: jspb.Message.getFieldWithDefault(msg, 2, ""),
equity: (f = msg.getEquity()) && common_common_pb.Money.toObject(includeInstance, f),
value: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
changeFromPreviousPeriod: (f = msg.getChangeFromPreviousPeriod()) && common_common_pb.FormattedDoubleValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.EquityCurveDataPoint}
 */
proto.analyzer.EquityCurveDataPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.EquityCurveDataPoint;
  return proto.analyzer.EquityCurveDataPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.EquityCurveDataPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.EquityCurveDataPoint}
 */
proto.analyzer.EquityCurveDataPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateLabel(value);
      break;
    case 3:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setEquity(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 5:
      var value = new common_common_pb.FormattedDoubleValue;
      reader.readMessage(value,common_common_pb.FormattedDoubleValue.deserializeBinaryFromReader);
      msg.setChangeFromPreviousPeriod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.EquityCurveDataPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.EquityCurveDataPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.EquityCurveDataPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.EquityCurveDataPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEquity();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getChangeFromPreviousPeriod();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_common_pb.FormattedDoubleValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp timestamp = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.analyzer.EquityCurveDataPoint.prototype.getTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.analyzer.EquityCurveDataPoint} returns this
*/
proto.analyzer.EquityCurveDataPoint.prototype.setTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.EquityCurveDataPoint} returns this
 */
proto.analyzer.EquityCurveDataPoint.prototype.clearTimestamp = function() {
  return this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.EquityCurveDataPoint.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string date_label = 2;
 * @return {string}
 */
proto.analyzer.EquityCurveDataPoint.prototype.getDateLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.EquityCurveDataPoint} returns this
 */
proto.analyzer.EquityCurveDataPoint.prototype.setDateLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.v1.Money equity = 3;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.EquityCurveDataPoint.prototype.getEquity = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 3));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.EquityCurveDataPoint} returns this
*/
proto.analyzer.EquityCurveDataPoint.prototype.setEquity = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.EquityCurveDataPoint} returns this
 */
proto.analyzer.EquityCurveDataPoint.prototype.clearEquity = function() {
  return this.setEquity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.EquityCurveDataPoint.prototype.hasEquity = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional double value = 4;
 * @return {number}
 */
proto.analyzer.EquityCurveDataPoint.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.EquityCurveDataPoint} returns this
 */
proto.analyzer.EquityCurveDataPoint.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional common.v1.FormattedDoubleValue change_from_previous_period = 5;
 * @return {?proto.analyzer.common.v1.FormattedDoubleValue}
 */
proto.analyzer.EquityCurveDataPoint.prototype.getChangeFromPreviousPeriod = function() {
  return /** @type{?proto.analyzer.common.v1.FormattedDoubleValue} */ (
    jspb.Message.getWrapperField(this, common_common_pb.FormattedDoubleValue, 5));
};


/**
 * @param {?proto.analyzer.common.v1.FormattedDoubleValue|undefined} value
 * @return {!proto.analyzer.EquityCurveDataPoint} returns this
*/
proto.analyzer.EquityCurveDataPoint.prototype.setChangeFromPreviousPeriod = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.EquityCurveDataPoint} returns this
 */
proto.analyzer.EquityCurveDataPoint.prototype.clearChangeFromPreviousPeriod = function() {
  return this.setChangeFromPreviousPeriod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.EquityCurveDataPoint.prototype.hasChangeFromPreviousPeriod = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.DailyROIChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.DailyROIChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.DailyROIChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.DailyROIChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DailyROIChart.toObject = function(includeInstance, msg) {
  var f, obj = {
dataPointsList: jspb.Message.toObjectList(msg.getDataPointsList(),
    proto.analyzer.DailyROIDataPoint.toObject, includeInstance),
minRoiPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
maxRoiPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.DailyROIChart}
 */
proto.analyzer.DailyROIChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.DailyROIChart;
  return proto.analyzer.DailyROIChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.DailyROIChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.DailyROIChart}
 */
proto.analyzer.DailyROIChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.DailyROIDataPoint;
      reader.readMessage(value,proto.analyzer.DailyROIDataPoint.deserializeBinaryFromReader);
      msg.addDataPoints(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinRoiPct(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxRoiPct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.DailyROIChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.DailyROIChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.DailyROIChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DailyROIChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.DailyROIDataPoint.serializeBinaryToWriter
    );
  }
  f = message.getMinRoiPct();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMaxRoiPct();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * repeated DailyROIDataPoint data_points = 1;
 * @return {!Array<!proto.analyzer.DailyROIDataPoint>}
 */
proto.analyzer.DailyROIChart.prototype.getDataPointsList = function() {
  return /** @type{!Array<!proto.analyzer.DailyROIDataPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.DailyROIDataPoint, 1));
};


/**
 * @param {!Array<!proto.analyzer.DailyROIDataPoint>} value
 * @return {!proto.analyzer.DailyROIChart} returns this
*/
proto.analyzer.DailyROIChart.prototype.setDataPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.DailyROIDataPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.DailyROIDataPoint}
 */
proto.analyzer.DailyROIChart.prototype.addDataPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.DailyROIDataPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.DailyROIChart} returns this
 */
proto.analyzer.DailyROIChart.prototype.clearDataPointsList = function() {
  return this.setDataPointsList([]);
};


/**
 * optional double min_roi_pct = 4;
 * @return {number}
 */
proto.analyzer.DailyROIChart.prototype.getMinRoiPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.DailyROIChart} returns this
 */
proto.analyzer.DailyROIChart.prototype.setMinRoiPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double max_roi_pct = 5;
 * @return {number}
 */
proto.analyzer.DailyROIChart.prototype.getMaxRoiPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.DailyROIChart} returns this
 */
proto.analyzer.DailyROIChart.prototype.setMaxRoiPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.DailyROIDataPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.DailyROIDataPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.DailyROIDataPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DailyROIDataPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
timestamp: (f = msg.getTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
dateLabel: jspb.Message.getFieldWithDefault(msg, 2, ""),
dailyRoiPct: (f = msg.getDailyRoiPct()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
cumulativeRoiPct: (f = msg.getCumulativeRoiPct()) && proto.analyzer.MetricValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.DailyROIDataPoint}
 */
proto.analyzer.DailyROIDataPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.DailyROIDataPoint;
  return proto.analyzer.DailyROIDataPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.DailyROIDataPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.DailyROIDataPoint}
 */
proto.analyzer.DailyROIDataPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateLabel(value);
      break;
    case 3:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setDailyRoiPct(value);
      break;
    case 4:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setCumulativeRoiPct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.DailyROIDataPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.DailyROIDataPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.DailyROIDataPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DailyROIDataPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDailyRoiPct();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getCumulativeRoiPct();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp timestamp = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.analyzer.DailyROIDataPoint.prototype.getTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.analyzer.DailyROIDataPoint} returns this
*/
proto.analyzer.DailyROIDataPoint.prototype.setTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.DailyROIDataPoint} returns this
 */
proto.analyzer.DailyROIDataPoint.prototype.clearTimestamp = function() {
  return this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.DailyROIDataPoint.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string date_label = 2;
 * @return {string}
 */
proto.analyzer.DailyROIDataPoint.prototype.getDateLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.DailyROIDataPoint} returns this
 */
proto.analyzer.DailyROIDataPoint.prototype.setDateLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional MetricValue daily_roi_pct = 3;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.DailyROIDataPoint.prototype.getDailyRoiPct = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 3));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.DailyROIDataPoint} returns this
*/
proto.analyzer.DailyROIDataPoint.prototype.setDailyRoiPct = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.DailyROIDataPoint} returns this
 */
proto.analyzer.DailyROIDataPoint.prototype.clearDailyRoiPct = function() {
  return this.setDailyRoiPct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.DailyROIDataPoint.prototype.hasDailyRoiPct = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional MetricValue cumulative_roi_pct = 4;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.DailyROIDataPoint.prototype.getCumulativeRoiPct = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 4));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.DailyROIDataPoint} returns this
*/
proto.analyzer.DailyROIDataPoint.prototype.setCumulativeRoiPct = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.DailyROIDataPoint} returns this
 */
proto.analyzer.DailyROIDataPoint.prototype.clearCumulativeRoiPct = function() {
  return this.setCumulativeRoiPct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.DailyROIDataPoint.prototype.hasCumulativeRoiPct = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ListAccountsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ListAccountsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ListAccountsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ListAccountsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountType: jspb.Message.getFieldWithDefault(msg, 2, 0),
sortBy: jspb.Message.getFieldWithDefault(msg, 3, 0),
sortOrder: jspb.Message.getFieldWithDefault(msg, 4, 0),
page: jspb.Message.getFieldWithDefault(msg, 5, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 6, 0),
searchQuery: jspb.Message.getFieldWithDefault(msg, 7, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ListAccountsReq}
 */
proto.analyzer.ListAccountsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ListAccountsReq;
  return proto.analyzer.ListAccountsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ListAccountsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ListAccountsReq}
 */
proto.analyzer.ListAccountsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.analyzer.common.v1.AccountType} */ (reader.readEnum());
      msg.setAccountType(value);
      break;
    case 3:
      var value = /** @type {!proto.analyzer.common.v1.SortBy} */ (reader.readEnum());
      msg.setSortBy(value);
      break;
    case 4:
      var value = /** @type {!proto.analyzer.common.v1.SortOrder} */ (reader.readEnum());
      msg.setSortOrder(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchQuery(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ListAccountsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ListAccountsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ListAccountsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ListAccountsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSortBy();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSortOrder();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getSearchQuery();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.ListAccountsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.ListAccountsReq} returns this
 */
proto.analyzer.ListAccountsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.v1.AccountType account_type = 2;
 * @return {!proto.analyzer.common.v1.AccountType}
 */
proto.analyzer.ListAccountsReq.prototype.getAccountType = function() {
  return /** @type {!proto.analyzer.common.v1.AccountType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.analyzer.common.v1.AccountType} value
 * @return {!proto.analyzer.ListAccountsReq} returns this
 */
proto.analyzer.ListAccountsReq.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional common.v1.SortBy sort_by = 3;
 * @return {!proto.analyzer.common.v1.SortBy}
 */
proto.analyzer.ListAccountsReq.prototype.getSortBy = function() {
  return /** @type {!proto.analyzer.common.v1.SortBy} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.analyzer.common.v1.SortBy} value
 * @return {!proto.analyzer.ListAccountsReq} returns this
 */
proto.analyzer.ListAccountsReq.prototype.setSortBy = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional common.v1.SortOrder sort_order = 4;
 * @return {!proto.analyzer.common.v1.SortOrder}
 */
proto.analyzer.ListAccountsReq.prototype.getSortOrder = function() {
  return /** @type {!proto.analyzer.common.v1.SortOrder} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.analyzer.common.v1.SortOrder} value
 * @return {!proto.analyzer.ListAccountsReq} returns this
 */
proto.analyzer.ListAccountsReq.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional uint32 page = 5;
 * @return {number}
 */
proto.analyzer.ListAccountsReq.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ListAccountsReq} returns this
 */
proto.analyzer.ListAccountsReq.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 page_size = 6;
 * @return {number}
 */
proto.analyzer.ListAccountsReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ListAccountsReq} returns this
 */
proto.analyzer.ListAccountsReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string search_query = 7;
 * @return {string}
 */
proto.analyzer.ListAccountsReq.prototype.getSearchQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.ListAccountsReq} returns this
 */
proto.analyzer.ListAccountsReq.prototype.setSearchQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string account_id = 8;
 * @return {string}
 */
proto.analyzer.ListAccountsReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.ListAccountsReq} returns this
 */
proto.analyzer.ListAccountsReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.ListAccountsReply.repeatedFields_ = [1,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ListAccountsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ListAccountsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ListAccountsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ListAccountsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.analyzer.AccountSummary.toObject, includeInstance),
pagination: (f = msg.getPagination()) && common_common_pb.Pagination.toObject(includeInstance, f),
typesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ListAccountsReply}
 */
proto.analyzer.ListAccountsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ListAccountsReply;
  return proto.analyzer.ListAccountsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ListAccountsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ListAccountsReply}
 */
proto.analyzer.ListAccountsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.AccountSummary;
      reader.readMessage(value,proto.analyzer.AccountSummary.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    case 2:
      var value = new common_common_pb.Pagination;
      reader.readMessage(value,common_common_pb.Pagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ListAccountsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ListAccountsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ListAccountsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ListAccountsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.AccountSummary.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_common_pb.Pagination.serializeBinaryToWriter
    );
  }
  f = message.getTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * repeated AccountSummary accounts = 1;
 * @return {!Array<!proto.analyzer.AccountSummary>}
 */
proto.analyzer.ListAccountsReply.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.analyzer.AccountSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.AccountSummary, 1));
};


/**
 * @param {!Array<!proto.analyzer.AccountSummary>} value
 * @return {!proto.analyzer.ListAccountsReply} returns this
*/
proto.analyzer.ListAccountsReply.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.AccountSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.AccountSummary}
 */
proto.analyzer.ListAccountsReply.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.AccountSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.ListAccountsReply} returns this
 */
proto.analyzer.ListAccountsReply.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};


/**
 * optional common.v1.Pagination pagination = 2;
 * @return {?proto.analyzer.common.v1.Pagination}
 */
proto.analyzer.ListAccountsReply.prototype.getPagination = function() {
  return /** @type{?proto.analyzer.common.v1.Pagination} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Pagination, 2));
};


/**
 * @param {?proto.analyzer.common.v1.Pagination|undefined} value
 * @return {!proto.analyzer.ListAccountsReply} returns this
*/
proto.analyzer.ListAccountsReply.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.ListAccountsReply} returns this
 */
proto.analyzer.ListAccountsReply.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.ListAccountsReply.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string types = 3;
 * @return {!Array<string>}
 */
proto.analyzer.ListAccountsReply.prototype.getTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.analyzer.ListAccountsReply} returns this
 */
proto.analyzer.ListAccountsReply.prototype.setTypesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.analyzer.ListAccountsReply} returns this
 */
proto.analyzer.ListAccountsReply.prototype.addTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.ListAccountsReply} returns this
 */
proto.analyzer.ListAccountsReply.prototype.clearTypesList = function() {
  return this.setTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ListAccountsLiteReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ListAccountsLiteReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ListAccountsLiteReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ListAccountsLiteReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ListAccountsLiteReq}
 */
proto.analyzer.ListAccountsLiteReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ListAccountsLiteReq;
  return proto.analyzer.ListAccountsLiteReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ListAccountsLiteReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ListAccountsLiteReq}
 */
proto.analyzer.ListAccountsLiteReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.analyzer.common.v1.AccountType} */ (reader.readEnum());
      msg.setAccountType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ListAccountsLiteReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ListAccountsLiteReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ListAccountsLiteReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ListAccountsLiteReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.ListAccountsLiteReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.ListAccountsLiteReq} returns this
 */
proto.analyzer.ListAccountsLiteReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.v1.AccountType account_type = 2;
 * @return {!proto.analyzer.common.v1.AccountType}
 */
proto.analyzer.ListAccountsLiteReq.prototype.getAccountType = function() {
  return /** @type {!proto.analyzer.common.v1.AccountType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.analyzer.common.v1.AccountType} value
 * @return {!proto.analyzer.ListAccountsLiteReq} returns this
 */
proto.analyzer.ListAccountsLiteReq.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.ListAccountsLiteReply.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ListAccountsLiteReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ListAccountsLiteReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ListAccountsLiteReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ListAccountsLiteReply.toObject = function(includeInstance, msg) {
  var f, obj = {
accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.analyzer.AccountLite.toObject, includeInstance),
typesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ListAccountsLiteReply}
 */
proto.analyzer.ListAccountsLiteReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ListAccountsLiteReply;
  return proto.analyzer.ListAccountsLiteReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ListAccountsLiteReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ListAccountsLiteReply}
 */
proto.analyzer.ListAccountsLiteReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.AccountLite;
      reader.readMessage(value,proto.analyzer.AccountLite.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ListAccountsLiteReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ListAccountsLiteReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ListAccountsLiteReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ListAccountsLiteReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.AccountLite.serializeBinaryToWriter
    );
  }
  f = message.getTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated AccountLite accounts = 1;
 * @return {!Array<!proto.analyzer.AccountLite>}
 */
proto.analyzer.ListAccountsLiteReply.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.analyzer.AccountLite>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.AccountLite, 1));
};


/**
 * @param {!Array<!proto.analyzer.AccountLite>} value
 * @return {!proto.analyzer.ListAccountsLiteReply} returns this
*/
proto.analyzer.ListAccountsLiteReply.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.AccountLite=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.AccountLite}
 */
proto.analyzer.ListAccountsLiteReply.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.AccountLite, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.ListAccountsLiteReply} returns this
 */
proto.analyzer.ListAccountsLiteReply.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};


/**
 * repeated string types = 2;
 * @return {!Array<string>}
 */
proto.analyzer.ListAccountsLiteReply.prototype.getTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.analyzer.ListAccountsLiteReply} returns this
 */
proto.analyzer.ListAccountsLiteReply.prototype.setTypesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.analyzer.ListAccountsLiteReply} returns this
 */
proto.analyzer.ListAccountsLiteReply.prototype.addTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.ListAccountsLiteReply} returns this
 */
proto.analyzer.ListAccountsLiteReply.prototype.clearTypesList = function() {
  return this.setTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.AccountLite.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.AccountLite.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.AccountLite} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.AccountLite.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
nickname: jspb.Message.getFieldWithDefault(msg, 2, ""),
accountNumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
platform: jspb.Message.getFieldWithDefault(msg, 4, ""),
formattedName: jspb.Message.getFieldWithDefault(msg, 5, ""),
userId: jspb.Message.getFieldWithDefault(msg, 6, ""),
type: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.AccountLite}
 */
proto.analyzer.AccountLite.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.AccountLite;
  return proto.analyzer.AccountLite.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.AccountLite} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.AccountLite}
 */
proto.analyzer.AccountLite.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormattedName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.AccountLite.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.AccountLite.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.AccountLite} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.AccountLite.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountNumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFormattedName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.analyzer.AccountLite.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountLite} returns this
 */
proto.analyzer.AccountLite.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string nickname = 2;
 * @return {string}
 */
proto.analyzer.AccountLite.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountLite} returns this
 */
proto.analyzer.AccountLite.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string account_number = 3;
 * @return {string}
 */
proto.analyzer.AccountLite.prototype.getAccountNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountLite} returns this
 */
proto.analyzer.AccountLite.prototype.setAccountNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string platform = 4;
 * @return {string}
 */
proto.analyzer.AccountLite.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountLite} returns this
 */
proto.analyzer.AccountLite.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string formatted_name = 5;
 * @return {string}
 */
proto.analyzer.AccountLite.prototype.getFormattedName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountLite} returns this
 */
proto.analyzer.AccountLite.prototype.setFormattedName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string user_id = 6;
 * @return {string}
 */
proto.analyzer.AccountLite.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountLite} returns this
 */
proto.analyzer.AccountLite.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string type = 7;
 * @return {string}
 */
proto.analyzer.AccountLite.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountLite} returns this
 */
proto.analyzer.AccountLite.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.AccountSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.AccountSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.AccountSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.AccountSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountType: jspb.Message.getFieldWithDefault(msg, 2, ""),
broker: jspb.Message.getFieldWithDefault(msg, 3, ""),
platform: jspb.Message.getFieldWithDefault(msg, 4, ""),
balance: (f = msg.getBalance()) && common_common_pb.Money.toObject(includeInstance, f),
equity: (f = msg.getEquity()) && common_common_pb.Money.toObject(includeInstance, f),
roi30dPct: (f = msg.getRoi30dPct()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
roiTrendChart: (f = msg.getRoiTrendChart()) && proto.analyzer.TrendChartData.toObject(includeInstance, f),
profitTarget: (f = msg.getProfitTarget()) && proto.analyzer.RiskMetric.toObject(includeInstance, f),
dailyLoss: (f = msg.getDailyLoss()) && proto.analyzer.RiskMetric.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 11, ""),
metrics: (f = msg.getMetrics()) && proto.analyzer.AccountMetrics.toObject(includeInstance, f),
equityChart: (f = msg.getEquityChart()) && proto.analyzer.AccountEquityChart.toObject(includeInstance, f),
roiSessionTrendsChart: (f = msg.getRoiSessionTrendsChart()) && proto.analyzer.ROISessionTrendsChart.toObject(includeInstance, f),
lastSynced: jspb.Message.getFieldWithDefault(msg, 15, ""),
firmType: jspb.Message.getFieldWithDefault(msg, 16, ""),
formattedName: jspb.Message.getFieldWithDefault(msg, 17, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.AccountSummary}
 */
proto.analyzer.AccountSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.AccountSummary;
  return proto.analyzer.AccountSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.AccountSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.AccountSummary}
 */
proto.analyzer.AccountSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 5:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setBalance(value);
      break;
    case 6:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setEquity(value);
      break;
    case 7:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setRoi30dPct(value);
      break;
    case 8:
      var value = new proto.analyzer.TrendChartData;
      reader.readMessage(value,proto.analyzer.TrendChartData.deserializeBinaryFromReader);
      msg.setRoiTrendChart(value);
      break;
    case 9:
      var value = new proto.analyzer.RiskMetric;
      reader.readMessage(value,proto.analyzer.RiskMetric.deserializeBinaryFromReader);
      msg.setProfitTarget(value);
      break;
    case 10:
      var value = new proto.analyzer.RiskMetric;
      reader.readMessage(value,proto.analyzer.RiskMetric.deserializeBinaryFromReader);
      msg.setDailyLoss(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 12:
      var value = new proto.analyzer.AccountMetrics;
      reader.readMessage(value,proto.analyzer.AccountMetrics.deserializeBinaryFromReader);
      msg.setMetrics(value);
      break;
    case 13:
      var value = new proto.analyzer.AccountEquityChart;
      reader.readMessage(value,proto.analyzer.AccountEquityChart.deserializeBinaryFromReader);
      msg.setEquityChart(value);
      break;
    case 14:
      var value = new proto.analyzer.ROISessionTrendsChart;
      reader.readMessage(value,proto.analyzer.ROISessionTrendsChart.deserializeBinaryFromReader);
      msg.setRoiSessionTrendsChart(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastSynced(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirmType(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormattedName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.AccountSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.AccountSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.AccountSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.AccountSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBalance();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getEquity();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getRoi30dPct();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getRoiTrendChart();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.analyzer.TrendChartData.serializeBinaryToWriter
    );
  }
  f = message.getProfitTarget();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.analyzer.RiskMetric.serializeBinaryToWriter
    );
  }
  f = message.getDailyLoss();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.analyzer.RiskMetric.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getMetrics();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.analyzer.AccountMetrics.serializeBinaryToWriter
    );
  }
  f = message.getEquityChart();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.analyzer.AccountEquityChart.serializeBinaryToWriter
    );
  }
  f = message.getRoiSessionTrendsChart();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.analyzer.ROISessionTrendsChart.serializeBinaryToWriter
    );
  }
  f = message.getLastSynced();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getFirmType();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getFormattedName();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.analyzer.AccountSummary.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_type = 2;
 * @return {string}
 */
proto.analyzer.AccountSummary.prototype.getAccountType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string broker = 3;
 * @return {string}
 */
proto.analyzer.AccountSummary.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string platform = 4;
 * @return {string}
 */
proto.analyzer.AccountSummary.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional common.v1.Money balance = 5;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.AccountSummary.prototype.getBalance = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 5));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.AccountSummary} returns this
*/
proto.analyzer.AccountSummary.prototype.setBalance = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.clearBalance = function() {
  return this.setBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.AccountSummary.prototype.hasBalance = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional common.v1.Money equity = 6;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.AccountSummary.prototype.getEquity = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 6));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.AccountSummary} returns this
*/
proto.analyzer.AccountSummary.prototype.setEquity = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.clearEquity = function() {
  return this.setEquity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.AccountSummary.prototype.hasEquity = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional MetricValue roi_30d_pct = 7;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.AccountSummary.prototype.getRoi30dPct = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 7));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.AccountSummary} returns this
*/
proto.analyzer.AccountSummary.prototype.setRoi30dPct = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.clearRoi30dPct = function() {
  return this.setRoi30dPct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.AccountSummary.prototype.hasRoi30dPct = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional TrendChartData roi_trend_chart = 8;
 * @return {?proto.analyzer.TrendChartData}
 */
proto.analyzer.AccountSummary.prototype.getRoiTrendChart = function() {
  return /** @type{?proto.analyzer.TrendChartData} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.TrendChartData, 8));
};


/**
 * @param {?proto.analyzer.TrendChartData|undefined} value
 * @return {!proto.analyzer.AccountSummary} returns this
*/
proto.analyzer.AccountSummary.prototype.setRoiTrendChart = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.clearRoiTrendChart = function() {
  return this.setRoiTrendChart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.AccountSummary.prototype.hasRoiTrendChart = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional RiskMetric profit_target = 9;
 * @return {?proto.analyzer.RiskMetric}
 */
proto.analyzer.AccountSummary.prototype.getProfitTarget = function() {
  return /** @type{?proto.analyzer.RiskMetric} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.RiskMetric, 9));
};


/**
 * @param {?proto.analyzer.RiskMetric|undefined} value
 * @return {!proto.analyzer.AccountSummary} returns this
*/
proto.analyzer.AccountSummary.prototype.setProfitTarget = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.clearProfitTarget = function() {
  return this.setProfitTarget(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.AccountSummary.prototype.hasProfitTarget = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional RiskMetric daily_loss = 10;
 * @return {?proto.analyzer.RiskMetric}
 */
proto.analyzer.AccountSummary.prototype.getDailyLoss = function() {
  return /** @type{?proto.analyzer.RiskMetric} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.RiskMetric, 10));
};


/**
 * @param {?proto.analyzer.RiskMetric|undefined} value
 * @return {!proto.analyzer.AccountSummary} returns this
*/
proto.analyzer.AccountSummary.prototype.setDailyLoss = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.clearDailyLoss = function() {
  return this.setDailyLoss(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.AccountSummary.prototype.hasDailyLoss = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string status = 11;
 * @return {string}
 */
proto.analyzer.AccountSummary.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional AccountMetrics metrics = 12;
 * @return {?proto.analyzer.AccountMetrics}
 */
proto.analyzer.AccountSummary.prototype.getMetrics = function() {
  return /** @type{?proto.analyzer.AccountMetrics} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.AccountMetrics, 12));
};


/**
 * @param {?proto.analyzer.AccountMetrics|undefined} value
 * @return {!proto.analyzer.AccountSummary} returns this
*/
proto.analyzer.AccountSummary.prototype.setMetrics = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.clearMetrics = function() {
  return this.setMetrics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.AccountSummary.prototype.hasMetrics = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional AccountEquityChart equity_chart = 13;
 * @return {?proto.analyzer.AccountEquityChart}
 */
proto.analyzer.AccountSummary.prototype.getEquityChart = function() {
  return /** @type{?proto.analyzer.AccountEquityChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.AccountEquityChart, 13));
};


/**
 * @param {?proto.analyzer.AccountEquityChart|undefined} value
 * @return {!proto.analyzer.AccountSummary} returns this
*/
proto.analyzer.AccountSummary.prototype.setEquityChart = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.clearEquityChart = function() {
  return this.setEquityChart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.AccountSummary.prototype.hasEquityChart = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional ROISessionTrendsChart roi_session_trends_chart = 14;
 * @return {?proto.analyzer.ROISessionTrendsChart}
 */
proto.analyzer.AccountSummary.prototype.getRoiSessionTrendsChart = function() {
  return /** @type{?proto.analyzer.ROISessionTrendsChart} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.ROISessionTrendsChart, 14));
};


/**
 * @param {?proto.analyzer.ROISessionTrendsChart|undefined} value
 * @return {!proto.analyzer.AccountSummary} returns this
*/
proto.analyzer.AccountSummary.prototype.setRoiSessionTrendsChart = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.clearRoiSessionTrendsChart = function() {
  return this.setRoiSessionTrendsChart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.AccountSummary.prototype.hasRoiSessionTrendsChart = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string last_synced = 15;
 * @return {string}
 */
proto.analyzer.AccountSummary.prototype.getLastSynced = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.setLastSynced = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string firm_type = 16;
 * @return {string}
 */
proto.analyzer.AccountSummary.prototype.getFirmType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.setFirmType = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string formatted_name = 17;
 * @return {string}
 */
proto.analyzer.AccountSummary.prototype.getFormattedName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountSummary} returns this
 */
proto.analyzer.AccountSummary.prototype.setFormattedName = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.TrendChartData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.TrendChartData.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.TrendChartData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.TrendChartData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TrendChartData.toObject = function(includeInstance, msg) {
  var f, obj = {
dataPointsList: jspb.Message.toObjectList(msg.getDataPointsList(),
    proto.analyzer.TrendDataPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.TrendChartData}
 */
proto.analyzer.TrendChartData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.TrendChartData;
  return proto.analyzer.TrendChartData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.TrendChartData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.TrendChartData}
 */
proto.analyzer.TrendChartData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.TrendDataPoint;
      reader.readMessage(value,proto.analyzer.TrendDataPoint.deserializeBinaryFromReader);
      msg.addDataPoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.TrendChartData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.TrendChartData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.TrendChartData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TrendChartData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.TrendDataPoint.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TrendDataPoint data_points = 1;
 * @return {!Array<!proto.analyzer.TrendDataPoint>}
 */
proto.analyzer.TrendChartData.prototype.getDataPointsList = function() {
  return /** @type{!Array<!proto.analyzer.TrendDataPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.TrendDataPoint, 1));
};


/**
 * @param {!Array<!proto.analyzer.TrendDataPoint>} value
 * @return {!proto.analyzer.TrendChartData} returns this
*/
proto.analyzer.TrendChartData.prototype.setDataPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.TrendDataPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.TrendDataPoint}
 */
proto.analyzer.TrendChartData.prototype.addDataPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.TrendDataPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.TrendChartData} returns this
 */
proto.analyzer.TrendChartData.prototype.clearDataPointsList = function() {
  return this.setDataPointsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.TrendDataPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.TrendDataPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.TrendDataPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TrendDataPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
value: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.TrendDataPoint}
 */
proto.analyzer.TrendDataPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.TrendDataPoint;
  return proto.analyzer.TrendDataPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.TrendDataPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.TrendDataPoint}
 */
proto.analyzer.TrendDataPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.TrendDataPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.TrendDataPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.TrendDataPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.TrendDataPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.analyzer.TrendDataPoint.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.TrendDataPoint} returns this
 */
proto.analyzer.TrendDataPoint.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double value = 2;
 * @return {number}
 */
proto.analyzer.TrendDataPoint.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.TrendDataPoint} returns this
 */
proto.analyzer.TrendDataPoint.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.RiskMetric.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.RiskMetric.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.RiskMetric} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RiskMetric.toObject = function(includeInstance, msg) {
  var f, obj = {
currentPct: jspb.Message.getFieldWithDefault(msg, 1, ""),
targetPct: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.RiskMetric}
 */
proto.analyzer.RiskMetric.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.RiskMetric;
  return proto.analyzer.RiskMetric.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.RiskMetric} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.RiskMetric}
 */
proto.analyzer.RiskMetric.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentPct(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetPct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.RiskMetric.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.RiskMetric.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.RiskMetric} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.RiskMetric.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentPct();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTargetPct();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string current_pct = 1;
 * @return {string}
 */
proto.analyzer.RiskMetric.prototype.getCurrentPct = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.RiskMetric} returns this
 */
proto.analyzer.RiskMetric.prototype.setCurrentPct = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string target_pct = 2;
 * @return {string}
 */
proto.analyzer.RiskMetric.prototype.getTargetPct = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.RiskMetric} returns this
 */
proto.analyzer.RiskMetric.prototype.setTargetPct = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.AccountMetrics.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.AccountMetrics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.AccountMetrics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.AccountMetrics.toObject = function(includeInstance, msg) {
  var f, obj = {
winRate: (f = msg.getWinRate()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
profitFactor: (f = msg.getProfitFactor()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
maxDrawdown: (f = msg.getMaxDrawdown()) && proto.analyzer.MetricValue.toObject(includeInstance, f),
sharpeRatio: (f = msg.getSharpeRatio()) && proto.analyzer.MetricValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.AccountMetrics}
 */
proto.analyzer.AccountMetrics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.AccountMetrics;
  return proto.analyzer.AccountMetrics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.AccountMetrics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.AccountMetrics}
 */
proto.analyzer.AccountMetrics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setWinRate(value);
      break;
    case 2:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setProfitFactor(value);
      break;
    case 3:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setMaxDrawdown(value);
      break;
    case 4:
      var value = new proto.analyzer.MetricValue;
      reader.readMessage(value,proto.analyzer.MetricValue.deserializeBinaryFromReader);
      msg.setSharpeRatio(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.AccountMetrics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.AccountMetrics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.AccountMetrics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.AccountMetrics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWinRate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getProfitFactor();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxDrawdown();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
  f = message.getSharpeRatio();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.analyzer.MetricValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional MetricValue win_rate = 1;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.AccountMetrics.prototype.getWinRate = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 1));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.AccountMetrics} returns this
*/
proto.analyzer.AccountMetrics.prototype.setWinRate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.AccountMetrics} returns this
 */
proto.analyzer.AccountMetrics.prototype.clearWinRate = function() {
  return this.setWinRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.AccountMetrics.prototype.hasWinRate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional MetricValue profit_factor = 2;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.AccountMetrics.prototype.getProfitFactor = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 2));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.AccountMetrics} returns this
*/
proto.analyzer.AccountMetrics.prototype.setProfitFactor = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.AccountMetrics} returns this
 */
proto.analyzer.AccountMetrics.prototype.clearProfitFactor = function() {
  return this.setProfitFactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.AccountMetrics.prototype.hasProfitFactor = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional MetricValue max_drawdown = 3;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.AccountMetrics.prototype.getMaxDrawdown = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 3));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.AccountMetrics} returns this
*/
proto.analyzer.AccountMetrics.prototype.setMaxDrawdown = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.AccountMetrics} returns this
 */
proto.analyzer.AccountMetrics.prototype.clearMaxDrawdown = function() {
  return this.setMaxDrawdown(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.AccountMetrics.prototype.hasMaxDrawdown = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional MetricValue sharpe_ratio = 4;
 * @return {?proto.analyzer.MetricValue}
 */
proto.analyzer.AccountMetrics.prototype.getSharpeRatio = function() {
  return /** @type{?proto.analyzer.MetricValue} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.MetricValue, 4));
};


/**
 * @param {?proto.analyzer.MetricValue|undefined} value
 * @return {!proto.analyzer.AccountMetrics} returns this
*/
proto.analyzer.AccountMetrics.prototype.setSharpeRatio = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.AccountMetrics} returns this
 */
proto.analyzer.AccountMetrics.prototype.clearSharpeRatio = function() {
  return this.setSharpeRatio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.AccountMetrics.prototype.hasSharpeRatio = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.AccountEquityChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.AccountEquityChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.AccountEquityChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.AccountEquityChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.AccountEquityChart.toObject = function(includeInstance, msg) {
  var f, obj = {
dataPointsList: jspb.Message.toObjectList(msg.getDataPointsList(),
    proto.analyzer.EquityDataPoint.toObject, includeInstance),
minEquity: (f = msg.getMinEquity()) && common_common_pb.Money.toObject(includeInstance, f),
maxEquity: (f = msg.getMaxEquity()) && common_common_pb.Money.toObject(includeInstance, f),
currency: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.AccountEquityChart}
 */
proto.analyzer.AccountEquityChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.AccountEquityChart;
  return proto.analyzer.AccountEquityChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.AccountEquityChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.AccountEquityChart}
 */
proto.analyzer.AccountEquityChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.EquityDataPoint;
      reader.readMessage(value,proto.analyzer.EquityDataPoint.deserializeBinaryFromReader);
      msg.addDataPoints(value);
      break;
    case 2:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setMinEquity(value);
      break;
    case 3:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setMaxEquity(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.AccountEquityChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.AccountEquityChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.AccountEquityChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.AccountEquityChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.EquityDataPoint.serializeBinaryToWriter
    );
  }
  f = message.getMinEquity();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getMaxEquity();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * repeated EquityDataPoint data_points = 1;
 * @return {!Array<!proto.analyzer.EquityDataPoint>}
 */
proto.analyzer.AccountEquityChart.prototype.getDataPointsList = function() {
  return /** @type{!Array<!proto.analyzer.EquityDataPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.EquityDataPoint, 1));
};


/**
 * @param {!Array<!proto.analyzer.EquityDataPoint>} value
 * @return {!proto.analyzer.AccountEquityChart} returns this
*/
proto.analyzer.AccountEquityChart.prototype.setDataPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.EquityDataPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.EquityDataPoint}
 */
proto.analyzer.AccountEquityChart.prototype.addDataPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.EquityDataPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.AccountEquityChart} returns this
 */
proto.analyzer.AccountEquityChart.prototype.clearDataPointsList = function() {
  return this.setDataPointsList([]);
};


/**
 * optional common.v1.Money min_equity = 2;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.AccountEquityChart.prototype.getMinEquity = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 2));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.AccountEquityChart} returns this
*/
proto.analyzer.AccountEquityChart.prototype.setMinEquity = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.AccountEquityChart} returns this
 */
proto.analyzer.AccountEquityChart.prototype.clearMinEquity = function() {
  return this.setMinEquity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.AccountEquityChart.prototype.hasMinEquity = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional common.v1.Money max_equity = 3;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.AccountEquityChart.prototype.getMaxEquity = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 3));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.AccountEquityChart} returns this
*/
proto.analyzer.AccountEquityChart.prototype.setMaxEquity = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.AccountEquityChart} returns this
 */
proto.analyzer.AccountEquityChart.prototype.clearMaxEquity = function() {
  return this.setMaxEquity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.AccountEquityChart.prototype.hasMaxEquity = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string currency = 4;
 * @return {string}
 */
proto.analyzer.AccountEquityChart.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AccountEquityChart} returns this
 */
proto.analyzer.AccountEquityChart.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.EquityDataPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.EquityDataPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.EquityDataPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.EquityDataPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
timestamp: (f = msg.getTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
dateLabel: jspb.Message.getFieldWithDefault(msg, 2, ""),
equity: (f = msg.getEquity()) && common_common_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.EquityDataPoint}
 */
proto.analyzer.EquityDataPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.EquityDataPoint;
  return proto.analyzer.EquityDataPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.EquityDataPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.EquityDataPoint}
 */
proto.analyzer.EquityDataPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateLabel(value);
      break;
    case 3:
      var value = new common_common_pb.Money;
      reader.readMessage(value,common_common_pb.Money.deserializeBinaryFromReader);
      msg.setEquity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.EquityDataPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.EquityDataPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.EquityDataPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.EquityDataPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEquity();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_common_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp timestamp = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.analyzer.EquityDataPoint.prototype.getTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.analyzer.EquityDataPoint} returns this
*/
proto.analyzer.EquityDataPoint.prototype.setTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.EquityDataPoint} returns this
 */
proto.analyzer.EquityDataPoint.prototype.clearTimestamp = function() {
  return this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.EquityDataPoint.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string date_label = 2;
 * @return {string}
 */
proto.analyzer.EquityDataPoint.prototype.getDateLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.EquityDataPoint} returns this
 */
proto.analyzer.EquityDataPoint.prototype.setDateLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.v1.Money equity = 3;
 * @return {?proto.analyzer.common.v1.Money}
 */
proto.analyzer.EquityDataPoint.prototype.getEquity = function() {
  return /** @type{?proto.analyzer.common.v1.Money} */ (
    jspb.Message.getWrapperField(this, common_common_pb.Money, 3));
};


/**
 * @param {?proto.analyzer.common.v1.Money|undefined} value
 * @return {!proto.analyzer.EquityDataPoint} returns this
*/
proto.analyzer.EquityDataPoint.prototype.setEquity = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.EquityDataPoint} returns this
 */
proto.analyzer.EquityDataPoint.prototype.clearEquity = function() {
  return this.setEquity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.EquityDataPoint.prototype.hasEquity = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.ROISessionTrendsChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ROISessionTrendsChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ROISessionTrendsChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ROISessionTrendsChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ROISessionTrendsChart.toObject = function(includeInstance, msg) {
  var f, obj = {
dataPointsList: jspb.Message.toObjectList(msg.getDataPointsList(),
    proto.analyzer.ROISessionDataPoint.toObject, includeInstance),
sessionCount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ROISessionTrendsChart}
 */
proto.analyzer.ROISessionTrendsChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ROISessionTrendsChart;
  return proto.analyzer.ROISessionTrendsChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ROISessionTrendsChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ROISessionTrendsChart}
 */
proto.analyzer.ROISessionTrendsChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.ROISessionDataPoint;
      reader.readMessage(value,proto.analyzer.ROISessionDataPoint.deserializeBinaryFromReader);
      msg.addDataPoints(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSessionCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ROISessionTrendsChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ROISessionTrendsChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ROISessionTrendsChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ROISessionTrendsChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.ROISessionDataPoint.serializeBinaryToWriter
    );
  }
  f = message.getSessionCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated ROISessionDataPoint data_points = 1;
 * @return {!Array<!proto.analyzer.ROISessionDataPoint>}
 */
proto.analyzer.ROISessionTrendsChart.prototype.getDataPointsList = function() {
  return /** @type{!Array<!proto.analyzer.ROISessionDataPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.ROISessionDataPoint, 1));
};


/**
 * @param {!Array<!proto.analyzer.ROISessionDataPoint>} value
 * @return {!proto.analyzer.ROISessionTrendsChart} returns this
*/
proto.analyzer.ROISessionTrendsChart.prototype.setDataPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.ROISessionDataPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.ROISessionDataPoint}
 */
proto.analyzer.ROISessionTrendsChart.prototype.addDataPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.ROISessionDataPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.ROISessionTrendsChart} returns this
 */
proto.analyzer.ROISessionTrendsChart.prototype.clearDataPointsList = function() {
  return this.setDataPointsList([]);
};


/**
 * optional int32 session_count = 2;
 * @return {number}
 */
proto.analyzer.ROISessionTrendsChart.prototype.getSessionCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ROISessionTrendsChart} returns this
 */
proto.analyzer.ROISessionTrendsChart.prototype.setSessionCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ROISessionDataPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ROISessionDataPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ROISessionDataPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ROISessionDataPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
sessionNumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
roiPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ROISessionDataPoint}
 */
proto.analyzer.ROISessionDataPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ROISessionDataPoint;
  return proto.analyzer.ROISessionDataPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ROISessionDataPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ROISessionDataPoint}
 */
proto.analyzer.ROISessionDataPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSessionNumber(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRoiPct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ROISessionDataPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ROISessionDataPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ROISessionDataPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ROISessionDataPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionNumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRoiPct();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional int32 session_number = 1;
 * @return {number}
 */
proto.analyzer.ROISessionDataPoint.prototype.getSessionNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ROISessionDataPoint} returns this
 */
proto.analyzer.ROISessionDataPoint.prototype.setSessionNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double roi_pct = 2;
 * @return {number}
 */
proto.analyzer.ROISessionDataPoint.prototype.getRoiPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ROISessionDataPoint} returns this
 */
proto.analyzer.ROISessionDataPoint.prototype.setRoiPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.ROITrendsChart.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ROITrendsChart.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ROITrendsChart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ROITrendsChart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ROITrendsChart.toObject = function(includeInstance, msg) {
  var f, obj = {
dataPointsList: jspb.Message.toObjectList(msg.getDataPointsList(),
    proto.analyzer.ROITrendDataPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ROITrendsChart}
 */
proto.analyzer.ROITrendsChart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ROITrendsChart;
  return proto.analyzer.ROITrendsChart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ROITrendsChart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ROITrendsChart}
 */
proto.analyzer.ROITrendsChart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.ROITrendDataPoint;
      reader.readMessage(value,proto.analyzer.ROITrendDataPoint.deserializeBinaryFromReader);
      msg.addDataPoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ROITrendsChart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ROITrendsChart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ROITrendsChart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ROITrendsChart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.ROITrendDataPoint.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ROITrendDataPoint data_points = 1;
 * @return {!Array<!proto.analyzer.ROITrendDataPoint>}
 */
proto.analyzer.ROITrendsChart.prototype.getDataPointsList = function() {
  return /** @type{!Array<!proto.analyzer.ROITrendDataPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.ROITrendDataPoint, 1));
};


/**
 * @param {!Array<!proto.analyzer.ROITrendDataPoint>} value
 * @return {!proto.analyzer.ROITrendsChart} returns this
*/
proto.analyzer.ROITrendsChart.prototype.setDataPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.ROITrendDataPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.ROITrendDataPoint}
 */
proto.analyzer.ROITrendsChart.prototype.addDataPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.ROITrendDataPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.ROITrendsChart} returns this
 */
proto.analyzer.ROITrendsChart.prototype.clearDataPointsList = function() {
  return this.setDataPointsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.ROITrendDataPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.ROITrendDataPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.ROITrendDataPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ROITrendDataPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
roiPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.ROITrendDataPoint}
 */
proto.analyzer.ROITrendDataPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.ROITrendDataPoint;
  return proto.analyzer.ROITrendDataPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.ROITrendDataPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.ROITrendDataPoint}
 */
proto.analyzer.ROITrendDataPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRoiPct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.ROITrendDataPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.ROITrendDataPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.ROITrendDataPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.ROITrendDataPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoiPct();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.analyzer.ROITrendDataPoint.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.ROITrendDataPoint} returns this
 */
proto.analyzer.ROITrendDataPoint.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double roi_pct = 2;
 * @return {number}
 */
proto.analyzer.ROITrendDataPoint.prototype.getRoiPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.ROITrendDataPoint} returns this
 */
proto.analyzer.ROITrendDataPoint.prototype.setRoiPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.AIInsight.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.AIInsight.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.AIInsight} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.AIInsight.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
subtitle: jspb.Message.getFieldWithDefault(msg, 2, ""),
tip: jspb.Message.getFieldWithDefault(msg, 3, ""),
signalStrength: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.AIInsight}
 */
proto.analyzer.AIInsight.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.AIInsight;
  return proto.analyzer.AIInsight.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.AIInsight} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.AIInsight}
 */
proto.analyzer.AIInsight.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubtitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTip(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignalStrength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.AIInsight.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.AIInsight.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.AIInsight} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.AIInsight.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubtitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTip();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSignalStrength();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.analyzer.AIInsight.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AIInsight} returns this
 */
proto.analyzer.AIInsight.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subtitle = 2;
 * @return {string}
 */
proto.analyzer.AIInsight.prototype.getSubtitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AIInsight} returns this
 */
proto.analyzer.AIInsight.prototype.setSubtitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string tip = 3;
 * @return {string}
 */
proto.analyzer.AIInsight.prototype.getTip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AIInsight} returns this
 */
proto.analyzer.AIInsight.prototype.setTip = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string signal_strength = 4;
 * @return {string}
 */
proto.analyzer.AIInsight.prototype.getSignalStrength = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.AIInsight} returns this
 */
proto.analyzer.AIInsight.prototype.setSignalStrength = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetAccountSettingsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetAccountSettingsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetAccountSettingsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetAccountSettingsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetAccountSettingsReq}
 */
proto.analyzer.GetAccountSettingsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetAccountSettingsReq;
  return proto.analyzer.GetAccountSettingsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetAccountSettingsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetAccountSettingsReq}
 */
proto.analyzer.GetAccountSettingsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetAccountSettingsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetAccountSettingsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetAccountSettingsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetAccountSettingsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.GetAccountSettingsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetAccountSettingsReq} returns this
 */
proto.analyzer.GetAccountSettingsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyzer.GetAccountSettingsReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetAccountSettingsReq} returns this
 */
proto.analyzer.GetAccountSettingsReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetAccountSettingsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetAccountSettingsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetAccountSettingsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetAccountSettingsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
alertSettings: (f = msg.getAlertSettings()) && proto.analyzer.AccountAlertSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetAccountSettingsReply}
 */
proto.analyzer.GetAccountSettingsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetAccountSettingsReply;
  return proto.analyzer.GetAccountSettingsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetAccountSettingsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetAccountSettingsReply}
 */
proto.analyzer.GetAccountSettingsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.AccountAlertSettings;
      reader.readMessage(value,proto.analyzer.AccountAlertSettings.deserializeBinaryFromReader);
      msg.setAlertSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetAccountSettingsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetAccountSettingsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetAccountSettingsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetAccountSettingsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlertSettings();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.analyzer.AccountAlertSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional AccountAlertSettings alert_settings = 1;
 * @return {?proto.analyzer.AccountAlertSettings}
 */
proto.analyzer.GetAccountSettingsReply.prototype.getAlertSettings = function() {
  return /** @type{?proto.analyzer.AccountAlertSettings} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.AccountAlertSettings, 1));
};


/**
 * @param {?proto.analyzer.AccountAlertSettings|undefined} value
 * @return {!proto.analyzer.GetAccountSettingsReply} returns this
*/
proto.analyzer.GetAccountSettingsReply.prototype.setAlertSettings = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.GetAccountSettingsReply} returns this
 */
proto.analyzer.GetAccountSettingsReply.prototype.clearAlertSettings = function() {
  return this.setAlertSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.GetAccountSettingsReply.prototype.hasAlertSettings = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.UpdateAccountSettingsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.UpdateAccountSettingsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.UpdateAccountSettingsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.UpdateAccountSettingsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
alertSettings: (f = msg.getAlertSettings()) && proto.analyzer.AccountAlertSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.UpdateAccountSettingsReq}
 */
proto.analyzer.UpdateAccountSettingsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.UpdateAccountSettingsReq;
  return proto.analyzer.UpdateAccountSettingsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.UpdateAccountSettingsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.UpdateAccountSettingsReq}
 */
proto.analyzer.UpdateAccountSettingsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = new proto.analyzer.AccountAlertSettings;
      reader.readMessage(value,proto.analyzer.AccountAlertSettings.deserializeBinaryFromReader);
      msg.setAlertSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.UpdateAccountSettingsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.UpdateAccountSettingsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.UpdateAccountSettingsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.UpdateAccountSettingsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAlertSettings();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.analyzer.AccountAlertSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.UpdateAccountSettingsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.UpdateAccountSettingsReq} returns this
 */
proto.analyzer.UpdateAccountSettingsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyzer.UpdateAccountSettingsReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.UpdateAccountSettingsReq} returns this
 */
proto.analyzer.UpdateAccountSettingsReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional AccountAlertSettings alert_settings = 3;
 * @return {?proto.analyzer.AccountAlertSettings}
 */
proto.analyzer.UpdateAccountSettingsReq.prototype.getAlertSettings = function() {
  return /** @type{?proto.analyzer.AccountAlertSettings} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.AccountAlertSettings, 3));
};


/**
 * @param {?proto.analyzer.AccountAlertSettings|undefined} value
 * @return {!proto.analyzer.UpdateAccountSettingsReq} returns this
*/
proto.analyzer.UpdateAccountSettingsReq.prototype.setAlertSettings = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.UpdateAccountSettingsReq} returns this
 */
proto.analyzer.UpdateAccountSettingsReq.prototype.clearAlertSettings = function() {
  return this.setAlertSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.UpdateAccountSettingsReq.prototype.hasAlertSettings = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.UpdateAccountSettingsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.UpdateAccountSettingsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.UpdateAccountSettingsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.UpdateAccountSettingsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
alertSettings: (f = msg.getAlertSettings()) && proto.analyzer.AccountAlertSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.UpdateAccountSettingsReply}
 */
proto.analyzer.UpdateAccountSettingsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.UpdateAccountSettingsReply;
  return proto.analyzer.UpdateAccountSettingsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.UpdateAccountSettingsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.UpdateAccountSettingsReply}
 */
proto.analyzer.UpdateAccountSettingsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.AccountAlertSettings;
      reader.readMessage(value,proto.analyzer.AccountAlertSettings.deserializeBinaryFromReader);
      msg.setAlertSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.UpdateAccountSettingsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.UpdateAccountSettingsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.UpdateAccountSettingsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.UpdateAccountSettingsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlertSettings();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.analyzer.AccountAlertSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional AccountAlertSettings alert_settings = 1;
 * @return {?proto.analyzer.AccountAlertSettings}
 */
proto.analyzer.UpdateAccountSettingsReply.prototype.getAlertSettings = function() {
  return /** @type{?proto.analyzer.AccountAlertSettings} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.AccountAlertSettings, 1));
};


/**
 * @param {?proto.analyzer.AccountAlertSettings|undefined} value
 * @return {!proto.analyzer.UpdateAccountSettingsReply} returns this
*/
proto.analyzer.UpdateAccountSettingsReply.prototype.setAlertSettings = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.UpdateAccountSettingsReply} returns this
 */
proto.analyzer.UpdateAccountSettingsReply.prototype.clearAlertSettings = function() {
  return this.setAlertSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.UpdateAccountSettingsReply.prototype.hasAlertSettings = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.AccountAlertSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.AccountAlertSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.AccountAlertSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.AccountAlertSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
riskAlertsEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
marginAlertsEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
opportunityAlertsEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
dailyLossLimitPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
maxLotSize: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
maxDrawdownPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
profitTargetPct: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
marginLevelThreshold: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
expectancyGoalR: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.AccountAlertSettings}
 */
proto.analyzer.AccountAlertSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.AccountAlertSettings;
  return proto.analyzer.AccountAlertSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.AccountAlertSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.AccountAlertSettings}
 */
proto.analyzer.AccountAlertSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRiskAlertsEnabled(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarginAlertsEnabled(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOpportunityAlertsEnabled(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDailyLossLimitPct(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxLotSize(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxDrawdownPct(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProfitTargetPct(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMarginLevelThreshold(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setExpectancyGoalR(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.AccountAlertSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.AccountAlertSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.AccountAlertSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.AccountAlertSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskAlertsEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMarginAlertsEnabled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getOpportunityAlertsEnabled();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getDailyLossLimitPct();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMaxLotSize();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getMaxDrawdownPct();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getProfitTargetPct();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getMarginLevelThreshold();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getExpectancyGoalR();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
};


/**
 * optional bool risk_alerts_enabled = 1;
 * @return {boolean}
 */
proto.analyzer.AccountAlertSettings.prototype.getRiskAlertsEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.analyzer.AccountAlertSettings} returns this
 */
proto.analyzer.AccountAlertSettings.prototype.setRiskAlertsEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool margin_alerts_enabled = 2;
 * @return {boolean}
 */
proto.analyzer.AccountAlertSettings.prototype.getMarginAlertsEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.analyzer.AccountAlertSettings} returns this
 */
proto.analyzer.AccountAlertSettings.prototype.setMarginAlertsEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool opportunity_alerts_enabled = 3;
 * @return {boolean}
 */
proto.analyzer.AccountAlertSettings.prototype.getOpportunityAlertsEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.analyzer.AccountAlertSettings} returns this
 */
proto.analyzer.AccountAlertSettings.prototype.setOpportunityAlertsEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional double daily_loss_limit_pct = 4;
 * @return {number}
 */
proto.analyzer.AccountAlertSettings.prototype.getDailyLossLimitPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.AccountAlertSettings} returns this
 */
proto.analyzer.AccountAlertSettings.prototype.setDailyLossLimitPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double max_lot_size = 5;
 * @return {number}
 */
proto.analyzer.AccountAlertSettings.prototype.getMaxLotSize = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.AccountAlertSettings} returns this
 */
proto.analyzer.AccountAlertSettings.prototype.setMaxLotSize = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double max_drawdown_pct = 6;
 * @return {number}
 */
proto.analyzer.AccountAlertSettings.prototype.getMaxDrawdownPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.AccountAlertSettings} returns this
 */
proto.analyzer.AccountAlertSettings.prototype.setMaxDrawdownPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double profit_target_pct = 7;
 * @return {number}
 */
proto.analyzer.AccountAlertSettings.prototype.getProfitTargetPct = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.AccountAlertSettings} returns this
 */
proto.analyzer.AccountAlertSettings.prototype.setProfitTargetPct = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double margin_level_threshold = 8;
 * @return {number}
 */
proto.analyzer.AccountAlertSettings.prototype.getMarginLevelThreshold = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.AccountAlertSettings} returns this
 */
proto.analyzer.AccountAlertSettings.prototype.setMarginLevelThreshold = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double expectancy_goal_r = 9;
 * @return {number}
 */
proto.analyzer.AccountAlertSettings.prototype.getExpectancyGoalR = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.AccountAlertSettings} returns this
 */
proto.analyzer.AccountAlertSettings.prototype.setExpectancyGoalR = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.Alert.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.Alert.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.Alert} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.Alert.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
severity: jspb.Message.getFieldWithDefault(msg, 3, 0),
category: jspb.Message.getFieldWithDefault(msg, 4, 0),
title: jspb.Message.getFieldWithDefault(msg, 5, ""),
description: jspb.Message.getFieldWithDefault(msg, 6, ""),
contextMap: (f = msg.getContextMap()) ? f.toObject(includeInstance, undefined) : [],
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
isRead: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
actionLabel: jspb.Message.getFieldWithDefault(msg, 10, ""),
actionType: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.Alert}
 */
proto.analyzer.Alert.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.Alert;
  return proto.analyzer.Alert.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.Alert} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.Alert}
 */
proto.analyzer.Alert.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {!proto.analyzer.AlertSeverity} */ (reader.readEnum());
      msg.setSeverity(value);
      break;
    case 4:
      var value = /** @type {!proto.analyzer.AlertCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 7:
      var value = msg.getContextMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsRead(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setActionLabel(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setActionType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.Alert.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.Alert.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.Alert} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.Alert.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSeverity();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getContextMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsRead();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getActionLabel();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getActionType();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.analyzer.Alert.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.Alert} returns this
 */
proto.analyzer.Alert.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyzer.Alert.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.Alert} returns this
 */
proto.analyzer.Alert.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional AlertSeverity severity = 3;
 * @return {!proto.analyzer.AlertSeverity}
 */
proto.analyzer.Alert.prototype.getSeverity = function() {
  return /** @type {!proto.analyzer.AlertSeverity} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.analyzer.AlertSeverity} value
 * @return {!proto.analyzer.Alert} returns this
 */
proto.analyzer.Alert.prototype.setSeverity = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional AlertCategory category = 4;
 * @return {!proto.analyzer.AlertCategory}
 */
proto.analyzer.Alert.prototype.getCategory = function() {
  return /** @type {!proto.analyzer.AlertCategory} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.analyzer.AlertCategory} value
 * @return {!proto.analyzer.Alert} returns this
 */
proto.analyzer.Alert.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string title = 5;
 * @return {string}
 */
proto.analyzer.Alert.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.Alert} returns this
 */
proto.analyzer.Alert.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.analyzer.Alert.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.Alert} returns this
 */
proto.analyzer.Alert.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * map<string, string> context = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.analyzer.Alert.prototype.getContextMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.analyzer.Alert} returns this
 */
proto.analyzer.Alert.prototype.clearContextMap = function() {
  this.getContextMap().clear();
  return this;
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.analyzer.Alert.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.analyzer.Alert} returns this
*/
proto.analyzer.Alert.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.Alert} returns this
 */
proto.analyzer.Alert.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.Alert.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool is_read = 9;
 * @return {boolean}
 */
proto.analyzer.Alert.prototype.getIsRead = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.analyzer.Alert} returns this
 */
proto.analyzer.Alert.prototype.setIsRead = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional string action_label = 10;
 * @return {string}
 */
proto.analyzer.Alert.prototype.getActionLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.Alert} returns this
 */
proto.analyzer.Alert.prototype.setActionLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string action_type = 11;
 * @return {string}
 */
proto.analyzer.Alert.prototype.getActionType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.Alert} returns this
 */
proto.analyzer.Alert.prototype.setActionType = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.UserTag.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.UserTag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.UserTag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.UserTag.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
color: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.UserTag}
 */
proto.analyzer.UserTag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.UserTag;
  return proto.analyzer.UserTag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.UserTag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.UserTag}
 */
proto.analyzer.UserTag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.UserTag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.UserTag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.UserTag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.UserTag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.analyzer.UserTag.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.UserTag} returns this
 */
proto.analyzer.UserTag.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.analyzer.UserTag.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.UserTag} returns this
 */
proto.analyzer.UserTag.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.analyzer.UserTag.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.UserTag} returns this
 */
proto.analyzer.UserTag.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string color = 4;
 * @return {string}
 */
proto.analyzer.UserTag.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.UserTag} returns this
 */
proto.analyzer.UserTag.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetUserTagsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetUserTagsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetUserTagsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetUserTagsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetUserTagsReq}
 */
proto.analyzer.GetUserTagsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetUserTagsReq;
  return proto.analyzer.GetUserTagsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetUserTagsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetUserTagsReq}
 */
proto.analyzer.GetUserTagsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetUserTagsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetUserTagsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetUserTagsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetUserTagsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.GetUserTagsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.GetUserTagsReq} returns this
 */
proto.analyzer.GetUserTagsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.analyzer.GetUserTagsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.GetUserTagsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.GetUserTagsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.GetUserTagsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetUserTagsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
tagsList: jspb.Message.toObjectList(msg.getTagsList(),
    proto.analyzer.UserTag.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.GetUserTagsReply}
 */
proto.analyzer.GetUserTagsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.GetUserTagsReply;
  return proto.analyzer.GetUserTagsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.GetUserTagsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.GetUserTagsReply}
 */
proto.analyzer.GetUserTagsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.UserTag;
      reader.readMessage(value,proto.analyzer.UserTag.deserializeBinaryFromReader);
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.GetUserTagsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.GetUserTagsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.GetUserTagsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.GetUserTagsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.analyzer.UserTag.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserTag tags = 1;
 * @return {!Array<!proto.analyzer.UserTag>}
 */
proto.analyzer.GetUserTagsReply.prototype.getTagsList = function() {
  return /** @type{!Array<!proto.analyzer.UserTag>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.analyzer.UserTag, 1));
};


/**
 * @param {!Array<!proto.analyzer.UserTag>} value
 * @return {!proto.analyzer.GetUserTagsReply} returns this
*/
proto.analyzer.GetUserTagsReply.prototype.setTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.analyzer.UserTag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.analyzer.UserTag}
 */
proto.analyzer.GetUserTagsReply.prototype.addTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.analyzer.UserTag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.analyzer.GetUserTagsReply} returns this
 */
proto.analyzer.GetUserTagsReply.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.CreateUserTagReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.CreateUserTagReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.CreateUserTagReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.CreateUserTagReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
color: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.CreateUserTagReq}
 */
proto.analyzer.CreateUserTagReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.CreateUserTagReq;
  return proto.analyzer.CreateUserTagReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.CreateUserTagReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.CreateUserTagReq}
 */
proto.analyzer.CreateUserTagReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.CreateUserTagReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.CreateUserTagReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.CreateUserTagReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.CreateUserTagReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.CreateUserTagReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.CreateUserTagReq} returns this
 */
proto.analyzer.CreateUserTagReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.analyzer.CreateUserTagReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.CreateUserTagReq} returns this
 */
proto.analyzer.CreateUserTagReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string color = 3;
 * @return {string}
 */
proto.analyzer.CreateUserTagReq.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.CreateUserTagReq} returns this
 */
proto.analyzer.CreateUserTagReq.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.CreateUserTagReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.CreateUserTagReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.CreateUserTagReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.CreateUserTagReply.toObject = function(includeInstance, msg) {
  var f, obj = {
tag: (f = msg.getTag()) && proto.analyzer.UserTag.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.CreateUserTagReply}
 */
proto.analyzer.CreateUserTagReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.CreateUserTagReply;
  return proto.analyzer.CreateUserTagReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.CreateUserTagReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.CreateUserTagReply}
 */
proto.analyzer.CreateUserTagReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.UserTag;
      reader.readMessage(value,proto.analyzer.UserTag.deserializeBinaryFromReader);
      msg.setTag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.CreateUserTagReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.CreateUserTagReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.CreateUserTagReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.CreateUserTagReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTag();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.analyzer.UserTag.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserTag tag = 1;
 * @return {?proto.analyzer.UserTag}
 */
proto.analyzer.CreateUserTagReply.prototype.getTag = function() {
  return /** @type{?proto.analyzer.UserTag} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.UserTag, 1));
};


/**
 * @param {?proto.analyzer.UserTag|undefined} value
 * @return {!proto.analyzer.CreateUserTagReply} returns this
*/
proto.analyzer.CreateUserTagReply.prototype.setTag = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.CreateUserTagReply} returns this
 */
proto.analyzer.CreateUserTagReply.prototype.clearTag = function() {
  return this.setTag(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.CreateUserTagReply.prototype.hasTag = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.DeleteUserTagReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.DeleteUserTagReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.DeleteUserTagReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DeleteUserTagReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
tagId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.DeleteUserTagReq}
 */
proto.analyzer.DeleteUserTagReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.DeleteUserTagReq;
  return proto.analyzer.DeleteUserTagReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.DeleteUserTagReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.DeleteUserTagReq}
 */
proto.analyzer.DeleteUserTagReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTagId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.DeleteUserTagReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.DeleteUserTagReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.DeleteUserTagReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DeleteUserTagReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTagId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.DeleteUserTagReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.DeleteUserTagReq} returns this
 */
proto.analyzer.DeleteUserTagReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 tag_id = 2;
 * @return {number}
 */
proto.analyzer.DeleteUserTagReq.prototype.getTagId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.DeleteUserTagReq} returns this
 */
proto.analyzer.DeleteUserTagReq.prototype.setTagId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.DeleteUserTagReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.DeleteUserTagReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.DeleteUserTagReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DeleteUserTagReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.DeleteUserTagReply}
 */
proto.analyzer.DeleteUserTagReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.DeleteUserTagReply;
  return proto.analyzer.DeleteUserTagReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.DeleteUserTagReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.DeleteUserTagReply}
 */
proto.analyzer.DeleteUserTagReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.DeleteUserTagReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.DeleteUserTagReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.DeleteUserTagReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.DeleteUserTagReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.SetTradeTagReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.SetTradeTagReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.SetTradeTagReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.SetTradeTagReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
tradeId: jspb.Message.getFieldWithDefault(msg, 3, 0),
tagId: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.SetTradeTagReq}
 */
proto.analyzer.SetTradeTagReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.SetTradeTagReq;
  return proto.analyzer.SetTradeTagReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.SetTradeTagReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.SetTradeTagReq}
 */
proto.analyzer.SetTradeTagReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTradeId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTagId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.SetTradeTagReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.SetTradeTagReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.SetTradeTagReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.SetTradeTagReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTradeId();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getTagId();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.SetTradeTagReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.SetTradeTagReq} returns this
 */
proto.analyzer.SetTradeTagReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.analyzer.SetTradeTagReq.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.SetTradeTagReq} returns this
 */
proto.analyzer.SetTradeTagReq.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 trade_id = 3;
 * @return {number}
 */
proto.analyzer.SetTradeTagReq.prototype.getTradeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.SetTradeTagReq} returns this
 */
proto.analyzer.SetTradeTagReq.prototype.setTradeId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 tag_id = 4;
 * @return {number}
 */
proto.analyzer.SetTradeTagReq.prototype.getTagId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.SetTradeTagReq} returns this
 */
proto.analyzer.SetTradeTagReq.prototype.setTagId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.SetTradeTagReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.SetTradeTagReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.SetTradeTagReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.SetTradeTagReply.toObject = function(includeInstance, msg) {
  var f, obj = {
tradeId: jspb.Message.getFieldWithDefault(msg, 1, 0),
tagId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.SetTradeTagReply}
 */
proto.analyzer.SetTradeTagReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.SetTradeTagReply;
  return proto.analyzer.SetTradeTagReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.SetTradeTagReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.SetTradeTagReply}
 */
proto.analyzer.SetTradeTagReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTradeId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTagId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.SetTradeTagReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.SetTradeTagReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.SetTradeTagReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.SetTradeTagReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTradeId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getTagId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional uint64 trade_id = 1;
 * @return {number}
 */
proto.analyzer.SetTradeTagReply.prototype.getTradeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.SetTradeTagReply} returns this
 */
proto.analyzer.SetTradeTagReply.prototype.setTradeId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 tag_id = 2;
 * @return {number}
 */
proto.analyzer.SetTradeTagReply.prototype.getTagId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.SetTradeTagReply} returns this
 */
proto.analyzer.SetTradeTagReply.prototype.setTagId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.UpdateUserTagReq.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.UpdateUserTagReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.UpdateUserTagReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.UpdateUserTagReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
tagId: jspb.Message.getFieldWithDefault(msg, 2, 0),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
color: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.UpdateUserTagReq}
 */
proto.analyzer.UpdateUserTagReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.UpdateUserTagReq;
  return proto.analyzer.UpdateUserTagReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.UpdateUserTagReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.UpdateUserTagReq}
 */
proto.analyzer.UpdateUserTagReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTagId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.UpdateUserTagReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.UpdateUserTagReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.UpdateUserTagReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.UpdateUserTagReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTagId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.analyzer.UpdateUserTagReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.UpdateUserTagReq} returns this
 */
proto.analyzer.UpdateUserTagReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 tag_id = 2;
 * @return {number}
 */
proto.analyzer.UpdateUserTagReq.prototype.getTagId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.analyzer.UpdateUserTagReq} returns this
 */
proto.analyzer.UpdateUserTagReq.prototype.setTagId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.analyzer.UpdateUserTagReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.UpdateUserTagReq} returns this
 */
proto.analyzer.UpdateUserTagReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string color = 4;
 * @return {string}
 */
proto.analyzer.UpdateUserTagReq.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.analyzer.UpdateUserTagReq} returns this
 */
proto.analyzer.UpdateUserTagReq.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.analyzer.UpdateUserTagReply.prototype.toObject = function(opt_includeInstance) {
  return proto.analyzer.UpdateUserTagReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.analyzer.UpdateUserTagReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.UpdateUserTagReply.toObject = function(includeInstance, msg) {
  var f, obj = {
tag: (f = msg.getTag()) && proto.analyzer.UserTag.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.analyzer.UpdateUserTagReply}
 */
proto.analyzer.UpdateUserTagReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.analyzer.UpdateUserTagReply;
  return proto.analyzer.UpdateUserTagReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.analyzer.UpdateUserTagReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.analyzer.UpdateUserTagReply}
 */
proto.analyzer.UpdateUserTagReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.analyzer.UserTag;
      reader.readMessage(value,proto.analyzer.UserTag.deserializeBinaryFromReader);
      msg.setTag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.analyzer.UpdateUserTagReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.analyzer.UpdateUserTagReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.analyzer.UpdateUserTagReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.analyzer.UpdateUserTagReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTag();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.analyzer.UserTag.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserTag tag = 1;
 * @return {?proto.analyzer.UserTag}
 */
proto.analyzer.UpdateUserTagReply.prototype.getTag = function() {
  return /** @type{?proto.analyzer.UserTag} */ (
    jspb.Message.getWrapperField(this, proto.analyzer.UserTag, 1));
};


/**
 * @param {?proto.analyzer.UserTag|undefined} value
 * @return {!proto.analyzer.UpdateUserTagReply} returns this
*/
proto.analyzer.UpdateUserTagReply.prototype.setTag = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.analyzer.UpdateUserTagReply} returns this
 */
proto.analyzer.UpdateUserTagReply.prototype.clearTag = function() {
  return this.setTag(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.analyzer.UpdateUserTagReply.prototype.hasTag = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * @enum {number}
 */
proto.analyzer.AlertSeverity = {
  ALERT_SEVERITY_UNSPECIFIED: 0,
  ALERT_SEVERITY_INFO: 1,
  ALERT_SEVERITY_WARNING: 2,
  ALERT_SEVERITY_CRITICAL: 3
};

/**
 * @enum {number}
 */
proto.analyzer.AlertCategory = {
  ALERT_CATEGORY_UNSPECIFIED: 0,
  ALERT_CATEGORY_RISK: 1,
  ALERT_CATEGORY_MARGIN: 2,
  ALERT_CATEGORY_OPPORTUNITY: 3
};

goog.object.extend(exports, proto.analyzer);
